{
  "data": {
    "$id": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Direction": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AppVars": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SVGItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SVGReference": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BackgroundImage": {
      "enums": {
        "positionx": {
          "LEFT": "left",
          "RIGHT": "right",
          "CENTER": "center"
        },
        "positiony": {
          "TOP": "top",
          "BOTTOM": "bottom",
          "CENTER": "center"
        },
        "repeatx": {
          "NO_REPEAT": "no_repeat",
          "REPEAT": "repeat"
        },
        "repeaty": {
          "NO_REPEAT": "no_repeat",
          "REPEAT": "repeat"
        },
        "attachment": {
          "SCROLL": "scroll",
          "FIXED": "fixed",
          "INHERIT": "inherit",
          "LOCAL": "local"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BackgroundMedia": {
      "enums": {
        "color": {
          "TRANSPARENT": "transparent",
          "NOCOLOR": "noColor"
        },
        "alignType": {
          "TOP": "top",
          "BOTTOM": "bottom",
          "LEFT": "left",
          "RIGHT": "right",
          "CENTER": "center",
          "TOP_LEFT": "top_left",
          "TOP_RIGHT": "top_right",
          "BOTTOM_LEFT": "bottom_left",
          "BOTTOM_RIGHT": "bottom_right"
        },
        "fittingType": {
          "FILL": "fill",
          "FIT": "fit",
          "STRETCH": "stretch",
          "ACTUAL_SIZE": "actual_size",
          "ORIGINAL_SIZE": "original_size",
          "TILE": "tile",
          "TILE_HORIZONTAL": "tile_horizontal",
          "TILE_VERTICAL": "tile_vertical",
          "FIT_AND_TILE": "fit_and_tile",
          "LEGACY_TILE": "legacy_tile",
          "LEGACY_TILE_HORIZONTAL": "legacy_tile_horizontal",
          "LEGACY_TILE_VERTICAL": "legacy_tile_vertical",
          "LEGACY_NORMAL": "legacy_normal"
        },
        "scrollType": {
          "NONE": "none",
          "FIXED": "fixed",
          "SCROLL": "scroll",
          "LOCAL": "local",
          "PARALLAX": "parallax"
        },
        "showOverlayForMediaType": {
          "ALL": "all",
          "WIXVIDEO": "WixVideo",
          "IMAGE": "Image"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "effectType": {
          "NONE": "none",
          "NORMAL": "normal",
          "INK": "ink",
          "KENNEDY": "kennedy",
          "FEATHERED": "feathered",
          "BLUR": "blur",
          "WHISTLER": "whistler",
          "_3D": "3d",
          "BLUERAY": "blueray",
          "LIGHTEN": "lighten",
          "DARKEN": "darken",
          "PINKRINSE": "pinkrinse",
          "REDRUM": "redrum",
          "GREENWASH": "greenwash",
          "YELLOWSTREAK": "yellowstreak",
          "NEONSKY": "neonsky",
          "SEAWEED": "seaweed",
          "SOLEDAD": "soledad",
          "SANGRIA": "sangria",
          "MALIBU": "malibu",
          "CANDYFLOSS": "candyfloss",
          "ELMO": "elmo",
          "UNICORN": "unicorn",
          "KEROUAC": "kerouac",
          "KOOLAID": "koolaid",
          "HYDRA": "hydra",
          "PIXIE": "pixie",
          "NIGHTRAIN": "nightrain",
          "BAUHAUS": "bauhaus",
          "NEPTUNE": "neptune",
          "ORCA": "orca",
          "MANHATTAN": "manhattan",
          "GOLDIE": "goldie",
          "FLAMINGO": "flamingo",
          "FADED": "faded",
          "GOTHAM": "gotham",
          "HULK": "hulk",
          "MIDNIGHT": "midnight",
          "LUCILLE": "lucille",
          "ORGANIC": "organic",
          "GRAYSCALE": "grayscale",
          "TVDUOTONE": "tvDuotone",
          "TVMONOTONEDARK": "tvMonotoneDark",
          "TVMONOTONELIGHT": "tvMonotoneLight",
          "TVHUE": "tvHue"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WixVideo": {
      "enums": {
        "format": {
          "MP4": "mp4",
          "WEBM": "webm",
          "HLS": "hls",
          "DASH": "dash"
        },
        "preload": {
          "AUTO": "auto",
          "METADATA": "metadata",
          "NONE": "none"
        },
        "controls": {
          "NONE": "none",
          "FULL": "full"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {
        "mediaFeatures": {
          "value": {
            "ALPHA": "alpha"
          }
        }
      },
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WixVideoData": {
      "enums": {
        "format": {
          "MP4": "mp4",
          "WEBM": "webm",
          "HLS": "hls",
          "DASH": "dash"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Document": {
      "enums": {
        "privacyNoteType": {
          "CHECKBOX": "CHECKBOX",
          "NOTE": "NOTE"
        },
        "currentSiteDirection": {
          "LTR": "ltr",
          "RTL": "rtl"
        },
        "mechanism": {
          "MESH": "mesh",
          "ANCHORS": "anchors"
        }
      },
      "links": [
        "smSettings"
      ],
      "refsNotOwnedBySchema": [
        "mainPage"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AccessibilitySettings": {
      "enums": {
        "currentSiteDirection": {
          "LTR": "ltr",
          "RTL": "rtl"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MobileSettings": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LayoutSettings": {
      "enums": {
        "mechanism": {
          "MESH": "mesh",
          "ANCHORS": "anchors"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StyleSettings": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SiteMembersData": {
      "enums": {
        "privacyNoteType": {
          "CHECKBOX": "CHECKBOX",
          "NOTE": "NOTE"
        }
      },
      "links": [
        "termsOfUse",
        "privacyPolicy",
        "codeOfConduct"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AppStudioData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {
        "dependencyData": {
          "value": {
            "PROVISION_ONLY_INSTALLATION": "PROVISION_ONLY_INSTALLATION",
            "NOTIFY_USER_ON_DEPENDENCY": "NOTIFY_USER_ON_DEPENDENCY",
            "IS_BUNDLE": "IS_BUNDLE"
          }
        }
      },
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "CodePackagesDescriptor": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WidgetPropertyDefinition": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "CustomDefinitionDescriptor": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WidgetDescriptor": {
      "enums": {
        "kind": {
          "CONTAINER": "container",
          "SECTION": "section"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [
        "rootCompId",
        "containedWidgets"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "DashboardDescriptor": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [
        "rootCompId"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PanelDescriptor": {
      "enums": {
        "kind": {
          "SETTINGS": "settings"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [
        "rootCompId"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VariationDescriptor": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [
        "rootCompId"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PresetDescriptor": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FlatTheme": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Image": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [
        "crop.x",
        "crop.y",
        "crop.width",
        "crop.height",
        "crop.rotate",
        "height",
        "width"
      ],
      "convertToString": []
    },
    "ImageA11y": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ImageReference": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GlobalImageQuality": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ImageQuality": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ClassicSectionA11y": {
      "enums": {
        "live": {
          "POLITE": "polite",
          "ASSERTIVE": "assertive"
        },
        "role": {
          "HEADING": "heading",
          "STATUS": "status",
          "ALERT": "alert"
        },
        "current": {
          "STEP": "step",
          "PAGE": "page",
          "TRUE": "true",
          "FALSE": "false"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StripColumnsContainerA11y": {
      "enums": {
        "live": {
          "POLITE": "polite",
          "ASSERTIVE": "assertive"
        },
        "role": {
          "HEADING": "heading",
          "STATUS": "status",
          "ALERT": "alert"
        },
        "current": {
          "STEP": "step",
          "PAGE": "page",
          "TRUE": "true",
          "FALSE": "false"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StripColumnsContainer": {
      "enums": {
        "itemsDirection": {
          "RTL": "rtl",
          "LTR": "ltr"
        },
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ClassicSection": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StripContainer": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ImageList": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Link": {
      "enums": {
        "linkType": {
          "SMS": "SMS",
          "CALL": "CALL",
          "SKYPE": "SKYPE",
          "MAP": "MAP",
          "EMAIL": "EMAIL",
          "FACEBOOK": "FACEBOOK",
          "FLICKR": "FLICKR",
          "BLOGGER": "BLOGGER",
          "MYSPACE": "MYSPACE",
          "LINKEDIN": "LINKEDIN",
          "TWITTER": "TWITTER",
          "TUMBLR": "TUMBLR",
          "YOUTUBE": "YOUTUBE",
          "VIMEO": "VIMEO",
          "PAGE": "PAGE",
          "FREE_LINK": "FREE_LINK",
          "TEXT": "TEXT",
          "DELICIOUS": "DELICIOUS",
          "WEBSITE": "WEBSITE",
          "DOCUMENT": "DOCUMENT",
          "ADMIN_LOGIN": "ADMIN_LOGIN",
          "LOGIN": "LOGIN"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TextLink": {
      "enums": {
        "linkType": {
          "SMS": "SMS",
          "CALL": "CALL",
          "SKYPE": "SKYPE",
          "MAP": "MAP",
          "EMAIL": "EMAIL",
          "FACEBOOK": "FACEBOOK",
          "FLICKR": "FLICKR",
          "BLOGGER": "BLOGGER",
          "MYSPACE": "MYSPACE",
          "LINKEDIN": "LINKEDIN",
          "TWITTER": "TWITTER",
          "TUMBLR": "TUMBLR",
          "YOUTUBE": "YOUTUBE",
          "VIMEO": "VIMEO",
          "PAGE": "PAGE",
          "FREE_LINK": "FREE_LINK",
          "TEXT": "TEXT",
          "DELICIOUS": "DELICIOUS",
          "WEBSITE": "WEBSITE",
          "DOCUMENT": "DOCUMENT",
          "ADMIN_LOGIN": "ADMIN_LOGIN",
          "LOGIN": "LOGIN"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AnchorLink": {
      "enums": {
        "rel": {
          "NOFOLLOW": "nofollow",
          "NOOPENER": "noopener",
          "NOREFERRER": "noreferrer",
          "SPONSORED": "sponsored"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [
        "anchorDataId",
        "pageId"
      ],
      "linksArr": [],
      "enumsArr": {
        "rel": {
          "value": {
            "NOFOLLOW": "nofollow",
            "NOOPENER": "noopener",
            "NOREFERRER": "noreferrer",
            "SPONSORED": "sponsored"
          }
        }
      },
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "DocumentLink": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PhoneLink": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WhatsAppLink": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AddressLink": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "EmailLink": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FormSubmitButtonLink": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ExternalLink": {
      "enums": {
        "target": {
          "_SELF": "_self",
          "_BLANK": "_blank"
        },
        "rel": {
          "NOFOLLOW": "nofollow",
          "NOOPENER": "noopener",
          "NOREFERRER": "noreferrer",
          "SPONSORED": "sponsored"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {
        "rel": {
          "value": {
            "NOFOLLOW": "nofollow",
            "NOOPENER": "noopener",
            "NOREFERRER": "noreferrer",
            "SPONSORED": "sponsored"
          }
        }
      },
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkRelAttribute": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "DynamicPageLink": {
      "enums": {
        "target": {
          "_SELF": "_self",
          "_BLANK": "_blank"
        },
        "rel": {
          "NOFOLLOW": "nofollow",
          "NOOPENER": "noopener",
          "NOREFERRER": "noreferrer",
          "SPONSORED": "sponsored"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [
        "anchorDataId"
      ],
      "linksArr": [],
      "enumsArr": {
        "rel": {
          "value": {
            "NOFOLLOW": "nofollow",
            "NOOPENER": "noopener",
            "NOREFERRER": "noreferrer",
            "SPONSORED": "sponsored"
          }
        }
      },
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TpaPageLink": {
      "enums": {
        "target": {
          "_SELF": "_self",
          "_BLANK": "_blank"
        },
        "rel": {
          "NOFOLLOW": "nofollow",
          "NOOPENER": "noopener",
          "NOREFERRER": "noreferrer",
          "SPONSORED": "sponsored"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [
        "pageId"
      ],
      "linksArr": [],
      "enumsArr": {
        "rel": {
          "value": {
            "NOFOLLOW": "nofollow",
            "NOOPENER": "noopener",
            "NOREFERRER": "noreferrer",
            "SPONSORED": "sponsored"
          }
        }
      },
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LoginToWixLink": {
      "enums": {
        "dialog": {
          "CREATEUSER": "createUser",
          "LOGIN": "login",
          "SHOWLOGIN": "showLogin"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PageLink": {
      "enums": {
        "target": {
          "_SELF": "_self",
          "_BLANK": "_blank"
        },
        "rel": {
          "NOFOLLOW": "nofollow",
          "NOOPENER": "noopener",
          "NOREFERRER": "noreferrer",
          "SPONSORED": "sponsored"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [
        "pageId"
      ],
      "linksArr": [],
      "enumsArr": {
        "rel": {
          "value": {
            "NOFOLLOW": "nofollow",
            "NOOPENER": "noopener",
            "NOREFERRER": "noreferrer",
            "SPONSORED": "sponsored"
          }
        }
      },
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MediaItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MediaRichText": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Page": {
      "enums": {
        "mediaSizing": {
          "DOCUMENT": "document",
          "VIEWPORT": "viewport"
        },
        "cacheMode": {
          "AUTO": "auto",
          "MANUAL": "manual",
          "DISABLED": "disabled"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [
        "parentPageId"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Text": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RichText": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RichTextImage": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BaseInput": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BaseTextInput": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TextInputA11y": {
      "enums": {
        "live": {
          "POLITE": "polite",
          "ASSERTIVE": "assertive"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TextInput": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "labelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "inputDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "errorDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "textType": {
          "TEXT": "text",
          "EMAIL": "email",
          "URL": "url",
          "NUMBER": "number",
          "TEL": "tel",
          "PASSWORD": "password"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TextAreaInput": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "labelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "inputDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "errorDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "CheckboxInput": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "DateItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "DateString": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "DateRange": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "DateRanges": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "DatePicker": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "labelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "inputDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {
        "disabledDaysOfWeek": {
          "value": {
            "_0": 0,
            "_1": 1,
            "_2": 2,
            "_3": 3,
            "_4": 4,
            "_5": 5,
            "_6": 6
          },
          "defaultValueEmpty": true
        }
      },
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Theme": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TwitterFollow": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TwitterTweet": {
      "enums": {
        "urlFormat": {
          "HASHBANG": "hashBang",
          "SLASH": "slash"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MobileMetaData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Preloader": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ContactInfo": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SocialLink": {
      "enums": {
        "id": {
          "FACEBOOK": "facebook",
          "TWITTER": "twitter",
          "PINTEREST": "pinterest",
          "GOOGLE_PLUS": "google_plus",
          "TUMBLR": "tumblr",
          "BLOGGER": "blogger",
          "LINKEDIN": "linkedin",
          "YOUTUBE": "youtube",
          "VIMEO": "vimeo",
          "FLICKR": "flickr"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "QuickActions": {
      "enums": {
        "colorScheme": {
          "DARK": "dark",
          "LIGHT": "light"
        },
        "id": {
          "FACEBOOK": "facebook",
          "TWITTER": "twitter",
          "PINTEREST": "pinterest",
          "GOOGLE_PLUS": "google_plus",
          "TUMBLR": "tumblr",
          "BLOGGER": "blogger",
          "LINKEDIN": "linkedin",
          "YOUTUBE": "youtube",
          "VIMEO": "vimeo",
          "FLICKR": "flickr"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "QuickActionBarItem": {
      "enums": {},
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SiteSettings": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AdvancedSeoSettingsDialog": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Anchor": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BasicMenuItem": {
      "enums": {},
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "CustomMenu": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "CustomMenusCollection": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "CustomMenuDataRef": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "itemDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "submenuDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "submenuSubItemDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [
        "menuRef"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "CustomMenuDataRefA11y": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Menu": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FacebookLikeBox": {
      "enums": {
        "colorScheme": {
          "LIGHT": "light",
          "DARK": "dark"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ImageButtonA11y": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ImageButton": {
      "enums": {},
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "NumericStepper": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PinItPinWidget": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PinterestPinIt": {
      "enums": {
        "urlFormat": {
          "HASHBANG": "hashBang",
          "SLASH": "slash"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SingleAudioPlayer": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SkypeCallButton": {
      "enums": {
        "buttonType": {
          "CALL": "call",
          "CHAT": "chat"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SpotifyFollow": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SpotifyPlayer": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SubscribeForm": {
      "enums": {
        "textDirection": {
          "LEFT": "left",
          "RIGHT": "right"
        },
        "onSubmitBehavior": {
          "MESSAGE": "message",
          "LINK": "link"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "YouTubeSubscribeButton": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AudioPlayer": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Boolean": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "CheckBox": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Grid": {
      "enums": {
        "type": {
          "STATIC": "static",
          "DYNAMIC": "dynamic"
        },
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ContactForm": {
      "enums": {
        "textDirection": {
          "LEFT": "left",
          "RIGHT": "right"
        },
        "onSubmitBehavior": {
          "MESSAGE": "message",
          "LINK": "link"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "DynamicContactForm": {
      "enums": {
        "textDirection": {
          "LEFT": "left",
          "RIGHT": "right"
        },
        "onSubmitBehavior": {
          "MESSAGE": "message",
          "LINK": "link"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "EbayItemsBySeller": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FacebookShareButton": {
      "enums": {
        "urlChoice": {
          "CURRENT_PAGE": "Current page",
          "SITE": "Site"
        },
        "urlFormat": {
          "HASHBANG": "hashBang",
          "SLASH": "slash"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FlashComponent": {
      "enums": {
        "linkType": {
          "SMS": "SMS",
          "CALL": "CALL",
          "SKYPE": "SKYPE",
          "MAP": "MAP",
          "EMAIL": "EMAIL",
          "FACEBOOK": "FACEBOOK",
          "FLICKR": "FLICKR",
          "BLOGGER": "BLOGGER",
          "MYSPACE": "MYSPACE",
          "LINKEDIN": "LINKEDIN",
          "TWITTER": "TWITTER",
          "TUMBLR": "TUMBLR",
          "YOUTUBE": "YOUTUBE",
          "VIMEO": "VIMEO",
          "PAGE": "PAGE",
          "FREE_LINK": "FREE_LINK",
          "TEXT": "TEXT",
          "DELICIOUS": "DELICIOUS",
          "WEBSITE": "WEBSITE",
          "DOCUMENT": "DOCUMENT",
          "ADMIN_LOGIN": "ADMIN_LOGIN",
          "LOGIN": "LOGIN"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FlickrBadgeWidget": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GeoMapLocation": {
      "enums": {},
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GeoMap": {
      "enums": {
        "language": {
          "AF": "af",
          "SQ": "sq",
          "AM": "am",
          "AR": "ar",
          "HY": "hy",
          "AZ": "az",
          "EU": "eu",
          "BE": "be",
          "BN": "bn",
          "BS": "bs",
          "BG": "bg",
          "MY": "my",
          "CA": "ca",
          "ZH": "zh",
          "ZH_CN": "zh-CN",
          "ZH_HK": "zh-HK",
          "ZH_TW": "zh-TW",
          "HR": "hr",
          "CS": "cs",
          "DA": "da",
          "NL": "nl",
          "EN": "en",
          "EN_AU": "en-AU",
          "EN_GB": "en-GB",
          "ET": "et",
          "FA": "fa",
          "FI": "fi",
          "FIL": "fil",
          "FR": "fr",
          "FR_CA": "fr-CA",
          "GL": "gl",
          "KA": "ka",
          "DE": "de",
          "EL": "el",
          "GU": "gu",
          "IW": "iw",
          "HI": "hi",
          "HU": "hu",
          "IS": "is",
          "ID": "id",
          "IT": "it",
          "JA": "ja",
          "KN": "kn",
          "KK": "kk",
          "KM": "km",
          "KO": "ko",
          "KY": "ky",
          "LO": "lo",
          "LV": "lv",
          "LT": "lt",
          "MK": "mk",
          "MS": "ms",
          "ML": "ml",
          "MR": "mr",
          "MN": "mn",
          "NE": "ne",
          "NO": "no",
          "PL": "pl",
          "PT": "pt",
          "PT_BR": "pt-BR",
          "PT_PT": "pt-PT",
          "PA": "pa",
          "RO": "ro",
          "RU": "ru",
          "SR": "sr",
          "SI": "si",
          "SK": "sk",
          "SL": "sl",
          "ES": "es",
          "ES_419": "es-419",
          "SW": "sw",
          "SV": "sv",
          "TA": "ta",
          "TE": "te",
          "TH": "th",
          "TR": "tr",
          "UK": "uk",
          "UR": "ur",
          "UZ": "uz",
          "VI": "vi",
          "ZU": "zu"
        },
        "elementType": {
          "ALL": "all",
          "GEOMETRY": "geometry",
          "GEOMETRY_FILL": "geometry.fill",
          "GEOMETRY_STROKE": "geometry.stroke",
          "LABELS": "labels",
          "LABELS_ICON": "labels.icon",
          "LABELS_TEXT": "labels.text",
          "LABELS_TEXT_FILL": "labels.text.fill",
          "LABELS_TEXT_STROKE": "labels.text.stroke"
        },
        "featureType": {
          "ADMINISTRATIVE": "administrative",
          "ADMINISTRATIVE_COUNTRY": "administrative.country",
          "ADMINISTRATIVE_LAND_PARCEL": "administrative.land_parcel",
          "ADMINISTRATIVE_LOCALITY": "administrative.locality",
          "ADMINISTRATIVE_NEIGHBORHOOD": "administrative.neighborhood",
          "ADMINISTRATIVE_PROVINCE": "administrative.province",
          "ALL": "all",
          "LANDSCAPE": "landscape",
          "LANDSCAPE_MAN_MADE": "landscape.man_made",
          "LANDSCAPE_NATURAL": "landscape.natural",
          "LANDSCAPE_NATURAL_LANDCOVER": "landscape.natural.landcover",
          "LANDSCAPE_NATURAL_TERRAIN": "landscape.natural.terrain",
          "POI": "poi",
          "POI_ATTRACTION": "poi.attraction",
          "POI_BUSINESS": "poi.business",
          "POI_GOVERNMENT": "poi.government",
          "POI_MEDICAL": "poi.medical",
          "POI_PARK": "poi.park",
          "POI_PLACE_OF_WORSHIP": "poi.place_of_worship",
          "POI_SCHOOL": "poi.school",
          "POI_SPORTS_COMPLEX": "poi.sports_complex",
          "ROAD": "road",
          "ROAD_ARTERIAL": "road.arterial",
          "ROAD_HIGHWAY": "road.highway",
          "ROAD_HIGHWAY_CONTROLLED_ACCESS": "road.highway.controlled_access",
          "ROAD_LOCAL": "road.local",
          "TRANSIT": "transit",
          "TRANSIT_LINE": "transit.line",
          "TRANSIT_STATION": "transit.station",
          "TRANSIT_STATION_AIRPORT": "transit.station.airport",
          "TRANSIT_STATION_BUS": "transit.station.bus",
          "TRANSIT_STATION_RAIL": "transit.station.rail",
          "WATER": "water"
        },
        "visibility": {
          "ON": "on",
          "OFF": "off",
          "SIMPLIFIED": "simplified"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "HtmlComponent": {
      "enums": {
        "componentConsentPolicy": {
          "ESSENTIAL": "essential",
          "FUNCTIONAL": "functional",
          "ANALYTICS": "analytics",
          "ADVERTISING": "advertising",
          "DATATOTHIRDPARTY": "dataToThirdParty"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "DisqusComments": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ItunesButton": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkableFlashComponent": {
      "enums": {},
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkableButton": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LoginButton": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TinyMenu": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [
        "loginSocialBarRef",
        "menuRef"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LoginSocialBar": {
      "enums": {
        "loggedInMember": {
          "AVATARONLY": "avatarOnly",
          "TEXTONLY": "textOnly",
          "AVATARANDTEXT": "avatarAndText",
          "MEMBERINITIALS": "memberInitials"
        },
        "loggedOutMember": {
          "AVATARONLY": "avatarOnly",
          "TEXTONLY": "textOnly",
          "AVATARANDTEXT": "avatarAndText"
        },
        "loggedInAvatarIcon": {
          "PROFILEIMAGE": "profileImage",
          "INITIALS": "initials",
          "CUSTOM": "custom"
        },
        "loggedOutAvatarIcon": {
          "PROFILEIMAGE": "profileImage",
          "INITIALS": "initials",
          "CUSTOM": "custom"
        },
        "loggedInTextState": {
          "MEMBERNAME": "memberName",
          "CUSTOM": "custom"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PagesGroupData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [
        "pages"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PagesGroupCollection": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PayPalButton": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PermaLink": {
      "enums": {
        "appType": {
          "LISTSAPPS": "ListsApps",
          "THIRDPARTYAPPS": "ThirdPartyApps"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PinterestFollow": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SelectableList": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "labelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "inputDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "dropdownDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "errorDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SelectOption": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RadioButton": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RadioGroup": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "labelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "optionsDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "CheckboxGroup": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "labelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "optionsDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FileUploader": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "labelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "buttonLabelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "filesDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "iconPosition": {
          "ROW": "row",
          "ROWREVERSE": "rowReverse",
          "COLUMN": "column",
          "COLUMNREVERSE": "columnReverse"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UploadName": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SiteButtonA11y": {
      "enums": {
        "live": {
          "POLITE": "polite",
          "ASSERTIVE": "assertive"
        },
        "haspopup": {
          "TRUE": "true",
          "FALSE": "false",
          "MENU": "menu",
          "DIALOG": "dialog",
          "LISTBOX": "listbox",
          "TREE": "tree",
          "GRID": "grid"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SiteButton": {
      "enums": {
        "linkType": {
          "SMS": "SMS",
          "CALL": "CALL",
          "SKYPE": "SKYPE",
          "MAP": "MAP",
          "EMAIL": "EMAIL",
          "FACEBOOK": "FACEBOOK",
          "FLICKR": "FLICKR",
          "BLOGGER": "BLOGGER",
          "MYSPACE": "MYSPACE",
          "LINKEDIN": "LINKEDIN",
          "TWITTER": "TWITTER",
          "TUMBLR": "TUMBLR",
          "YOUTUBE": "YOUTUBE",
          "VIMEO": "VIMEO",
          "PAGE": "PAGE",
          "FREE_LINK": "FREE_LINK",
          "TEXT": "TEXT",
          "DELICIOUS": "DELICIOUS",
          "WEBSITE": "WEBSITE",
          "DOCUMENT": "DOCUMENT",
          "ADMIN_LOGIN": "ADMIN_LOGIN",
          "LOGIN": "LOGIN"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SoundCloudWidget": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StyledTextA11y": {
      "enums": {
        "live": {
          "POLITE": "polite",
          "ASSERTIVE": "assertive"
        },
        "role": {
          "HEADING": "heading",
          "STATUS": "status",
          "ALERT": "alert"
        },
        "current": {
          "STEP": "step",
          "PAGE": "page",
          "TRUE": "true",
          "FALSE": "false"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StyledText": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [
        "linkList"
      ],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StyledTextLinkHelper": {
      "enums": {},
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SvgShape": {
      "enums": {},
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VectorImage": {
      "enums": {},
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Video": {
      "enums": {
        "videoType": {
          "YOUTUBE": "YOUTUBE",
          "VIMEO": "VIMEO",
          "FACEBOOK": "FACEBOOK",
          "DAILYMOTION": "DAILYMOTION"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VKShareButton": {
      "enums": {
        "style": {
          "BUTTON": "Button",
          "BUTTONWITHOUTCOUNTER": "ButtonWithoutCounter",
          "LINK": "Link",
          "LINKWITHOUTICON": "LinkWithoutIcon",
          "ICON": "Icon"
        },
        "urlFormat": {
          "HASHBANG": "hashBang",
          "SLASH": "slash"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ButtonWithIcon": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "EditorPreferences": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TPAWidget": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TPAData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TPAGlobalData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TPA": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TPASection": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TPAMultiSection": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RssButton": {
      "enums": {},
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AppPart": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AppPartCustomization": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AppPage": {
      "enums": {
        "mediaSizing": {
          "DOCUMENT": "document",
          "VIEWPORT": "viewport"
        },
        "cacheMode": {
          "AUTO": "auto",
          "MANUAL": "manual",
          "DISABLED": "disabled"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [
        "parentPageId"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AppBuilderComponent": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BoxSlideShow": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BoxSlideShowSlide": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StripContainerSlideShow": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StripContainerSlideShowSlide": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VerticalAnchorsMenu": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "bulletPosition": {
          "ROW": "row",
          "ROWREVERSE": "rowReverse",
          "COLUMN": "column",
          "COLUMNREVERSE": "columnReverse"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WFacebookComment": {
      "enums": {
        "urlFormat": {
          "HASHBANG": "hashBang",
          "SLASH": "slash"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WFacebookLike": {
      "enums": {
        "urlFormat": {
          "HASHBANG": "hashBang",
          "SLASH": "slash"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AppController": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RepeaterA11y": {
      "enums": {
        "role": {
          "MISSING_A11Y": null,
          "REGION": "region",
          "NONE": "none",
          "RADIOGROUP": "radiogroup",
          "LIST": "list",
          "GROUP": "group"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Repeater": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RepeatedData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ImageButtonWithText": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Icon": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WidgetRef": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "InternalRef": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [
        "rootCompId"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "InternalBlocksRef": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LightboxA11y": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LightboxContainer": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ContainerA11y": {
      "enums": {
        "role": {
          "MISSING_A11Y": null,
          "REGION": "region",
          "GROUP": "group",
          "NONE": "none",
          "STATUS": "status",
          "ALERT": "alert",
          "NAV": "nav",
          "LIST": "list",
          "LISTITEM": "listitem",
          "TABLIST": "tablist",
          "TAB": "tab",
          "TABPANEL": "tabpanel",
          "MENUBAR": "menubar",
          "PRESENTATION": "presentation",
          "HEADING": "heading"
        },
        "live": {
          "POLITE": "polite",
          "ASSERTIVE": "assertive"
        },
        "current": {
          "STEP": "step",
          "PAGE": "page",
          "TRUE": "true",
          "FALSE": "false"
        },
        "relevant": {
          "ALL": "all",
          "ADDITIONS": "additions",
          "TEXT": "text",
          "REMOVALS": "removals"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ContainerData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MediaBoxData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SlotsPlaceholderData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkType": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UrlFormat": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MultiStateBoxDataA11y": {
      "enums": {
        "live": {
          "POLITE": "polite",
          "ASSERTIVE": "assertive"
        },
        "role": {
          "MISSING_A11Y": null,
          "REGION": "region",
          "GROUP": "group",
          "TABLIST": "tablist",
          "TAB": "tab",
          "TABPANEL": "tabpanel",
          "ALERT": "alert",
          "STATUS": "status",
          "LIST": "list",
          "MENUBAR": "menubar",
          "PRESENTATION": "presentation",
          "NONE": "none",
          "NAV": "nav",
          "LISTITEM": "listitem"
        },
        "current": {
          "STEP": "step",
          "PAGE": "page",
          "TRUE": "true",
          "FALSE": "false",
          "LOCATION": "location",
          "DATE": "date",
          "TIME": "time"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MultiStateBoxData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [
        "defaultStateId",
        "selectedStateId"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AppsInstallState": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StateBoxA11y": {
      "enums": {
        "live": {
          "POLITE": "polite",
          "ASSERTIVE": "assertive"
        },
        "role": {
          "REGION": "region",
          "GROUP": "group",
          "TABLIST": "tablist",
          "TAB": "tab",
          "TABPANEL": "tabpanel",
          "ALERT": "alert",
          "STATUS": "status",
          "LIST": "list",
          "MENUBAR": "menubar",
          "PRESENTATION": "presentation",
          "NONE": "none",
          "NAV": "nav",
          "LISTITEM": "listitem"
        },
        "current": {
          "STEP": "step",
          "PAGE": "page",
          "TRUE": "true",
          "FALSE": "false",
          "LOCATION": "location",
          "DATE": "date",
          "TIME": "time"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StateBox": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StateBoxStateA11y": {
      "enums": {
        "live": {
          "POLITE": "polite",
          "ASSERTIVE": "assertive"
        },
        "role": {
          "REGION": "region",
          "GROUP": "group",
          "TABLIST": "tablist",
          "TAB": "tab",
          "TABPANEL": "tabpanel",
          "ALERT": "alert",
          "STATUS": "status",
          "LIST": "list",
          "MENUBAR": "menubar",
          "PRESENTATION": "presentation",
          "NONE": "none",
          "NAV": "nav",
          "LISTITEM": "listitem"
        },
        "current": {
          "STEP": "step",
          "PAGE": "page",
          "TRUE": "true",
          "FALSE": "false",
          "LOCATION": "location",
          "DATE": "date",
          "TIME": "time"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StateBoxState": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Builder.MenuItem": {
      "enums": {},
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Builder.MenuItems": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Builder.Image": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Builder.Video": {
      "enums": {
        "quality": {
          "_1080P": "1080p",
          "_720P": "720p",
          "_480P": "480p",
          "_360P": "360p"
        },
        "format": {
          "MP4": "mp4",
          "MP4_LUMINANCE": "mp4-luminance",
          "HLS": "hls",
          "DASH": "dash"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Builder.VectorArt": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Builder.RichText": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [
        "linkList"
      ],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "mobui.MobuiButton": {
      "enums": {
        "contentType": {
          "TEXT": "Text",
          "ICON": "Icon",
          "TEXT_AND_ICON": "Text and icon"
        },
        "iconPosition": {
          "LEFT": "Left",
          "RIGHT": "Right"
        },
        "buttonType": {
          "FULL": "Full",
          "OUTLINE": "Outline",
          "LINK": "Link"
        },
        "size": {
          "SMALL": "Small",
          "MEDIUM": "Medium",
          "LARGE": "Large"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "mobui.MobuiDatePicker": {
      "enums": {
        "initialText": {
          "TODAY'S_DATE": "today's date",
          "PLACEHOLDER": "placeholder"
        },
        "fieldType": {
          "FORM": "form",
          "SETTINGS": "settings",
          "FILTER": "filter"
        },
        "pickerType": {
          "WHEEL": "wheel",
          "CALENDAR": "calendar"
        },
        "wheelMode": {
          "DD_MM_YY": "DD/MM/YY",
          "MM_YY": "MM/YY"
        },
        "firstDay": {
          "SUNDAY": "Sunday",
          "MONDAY": "Monday"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "defaultItemSchemaType": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MobuiDateRangeType": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "mobui.MobuiImage": {
      "enums": {
        "resizeMode": {
          "COVER": "cover",
          "CONTAIN": "contain",
          "STRETCH": "stretch",
          "REPEAT": "repeat",
          "CENTER": "center"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "mobui.MobuiPicker": {
      "enums": {
        "fieldType": {
          "FORM": "form",
          "FILTER": "filter",
          "SETTINGS": "settings"
        },
        "pickerType": {
          "FULLSCREEN": "fullScreen",
          "DIALOG": "dialog"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MobuiPickerItemType": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "mobui.MobuiSwitch": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "mobui.MobuiText": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "mobui.MobuiTextInput": {
      "enums": {
        "inputType": {
          "TEXT": "text",
          "PASSWORD": "password",
          "PHONE": "phone",
          "EMAIL": "email",
          "URL": "url",
          "NUMBER": "number"
        },
        "validatorType": {
          "NONE": "none",
          "NUMBER": "number",
          "EMAIL": "email",
          "URL": "url",
          "REQUIRED": "required"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "mobui.MobuiVideoPlayer": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "mobui.MobuiMultiStateBoxData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [
        "defaultStateId",
        "selectedStateId"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.ExternalComponent": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.HamburgerOverlay": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.Logo": {
      "enums": {},
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.LottieEmbed": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.ProductSpecification": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.RangeSlider": {
      "enums": {
        "sliderType": {
          "CONTINUOUS": "Continuous",
          "STEPPED": "Stepped"
        },
        "stepType": {
          "NUMBER": "Number",
          "VALUE": "Value"
        },
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl"
        },
        "rootDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "labelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "sliderDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "thumbShape": {
          "CIRCLE": "Circle",
          "SQUARE": "Square",
          "RECTANGLE": "Rectangle",
          "BAR": "Bar"
        },
        "marksTickShape": {
          "LINES": "Lines",
          "DOTS": "Dots"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.Rive": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.ShareButtons": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "IShareButton": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.SingleTab": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AccordionContainerData": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AccordionItemData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AddressInput": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "labelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "inputDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "optionsDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BoltComponentData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreadcrumbsData": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "itemDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "submenuDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "submenuSubItemDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [
        "menuRef"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Captcha": {
      "enums": {
        "captchaType": {
          "IMAGE": "image",
          "AUDIO": "audio"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "CollapsibleTextData": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "textDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "buttonDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ComboBoxInputData": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "labelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "inputDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "dropdownDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "errorDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "CustomElement": {
      "enums": {
        "scriptType": {
          "NONE": "none",
          "MODULE": "module"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.FastGallery": {
      "enums": {
        "itemClickAction": {
          "ACTION": "ACTION",
          "LINK": "LINK",
          "NOTHING": "NOTHING"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.HamburgerMenuContainer": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.HamburgerMenuRoot": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ImageX": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        },
        "displayMode": {
          "FILL": "fill",
          "FIT": "fit",
          "FITWIDTH": "fitWidth"
        },
        "scrollEffect": {
          "PARALLAX": "parallax",
          "FIXED": "fixed",
          "ZOOMIN": "zoomIn",
          "FADEIN": "fadeIn",
          "NONE": "none"
        },
        "clickAction": {
          "NONE": "none",
          "GOTOLINK": "goToLink"
        },
        "mode": {
          "ALPHA": "alpha",
          "LUMINANCE": "luminance"
        },
        "parallaxDirection": {
          "NORMAL": "normal",
          "REVERSE": "reverse"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Crop": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FocalPoint": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LanguageSelector": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.MegaMenuContainerItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MenuData": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "itemDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "submenuDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "submenuItemDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "submenuSubItemDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [
        "menuRef"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.MenuList": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MusicPlayerData": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "coverDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "textDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WixAudio": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Pagination": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PaginationA11y": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ProgressBar": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "labelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "barDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RatingsDisplay": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "labelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "ratingsDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RatingsInput": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.RichContentViewer": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RichTextBox": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "labelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "inputDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SearchBox": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Section": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SectionA11y": {
      "enums": {
        "live": {
          "POLITE": "polite",
          "ASSERTIVE": "assertive"
        },
        "role": {
          "HEADING": "heading",
          "ALERT": "alert",
          "STATUS": "status"
        },
        "current": {
          "STEP": "step",
          "PAGE": "page",
          "TRUE": "true",
          "FALSE": "false",
          "LOCATION": "location",
          "DATE": "date",
          "TIME": "time"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.SelectableContainer": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.SelectableContainerInput": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SelectionTagsList": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "labelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "inputDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SelectionTag": {
      "enums": {
        "rel": {
          "NOFOLLOW": "nofollow"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SignatureInput": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "labelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "inputDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "buttonDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "radioButtonsDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SiteButtonData": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Slider": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "labelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "trackDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "tooltipDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "stepType": {
          "VALUE": "value",
          "COUNT": "count"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.Slideshow": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SocialAuth": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StylableButton": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StylableButtonA11y": {
      "enums": {
        "haspopup": {
          "TRUE": "true",
          "FALSE": "false",
          "DIALOG": "dialog",
          "MENU": "menu"
        },
        "live": {
          "POLITE": "polite",
          "ASSERTIVE": "assertive"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Submenu": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "itemDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "subItemDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SvgImage": {
      "enums": {
        "displayMode": {
          "FIT": "fit",
          "STRETCH": "stretch"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "wixui.Tabs": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TabsA11y": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TextEffectsSharedData": {
      "enums": {
        "tagName": {
          "H1": "h1",
          "H2": "h2",
          "H3": "h3",
          "H4": "h4",
          "H5": "h5",
          "H6": "h6",
          "BLOCKQUOTE": "blockquote",
          "DIV": "div",
          "P": "p"
        },
        "textDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "patternScope": {
          "NONE": "none",
          "CHARACTER": "character",
          "WORD": "word"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TextMarqueeData": {
      "enums": {
        "movementDirection": {
          "RTL": "rtl",
          "LTR": "ltr"
        },
        "textDirection": {
          "LTR": "ltr",
          "RTL": "rtl"
        },
        "tagName": {
          "H1": "h1",
          "H2": "h2",
          "H3": "h3",
          "H4": "h4",
          "H5": "h5",
          "H6": "h6",
          "BLOCKQUOTE": "blockquote",
          "DIV": "div",
          "P": "p"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TextMarqueeItem": {
      "enums": {},
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TextFxData": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl"
        },
        "tagName": {
          "H1": "h1",
          "H2": "h2",
          "H3": "h3",
          "H4": "h4",
          "H5": "h5",
          "H6": "h6",
          "BLOCKQUOTE": "blockquote",
          "DIV": "div",
          "P": "p"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TextOnPathData": {
      "enums": {
        "movementDirection": {
          "FORWARD": "forward",
          "REVERSE": "reverse"
        },
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl"
        },
        "tagName": {
          "H1": "h1",
          "H2": "h2",
          "H3": "h3",
          "H4": "h4",
          "H5": "h5",
          "H6": "h6",
          "BLOCKQUOTE": "blockquote",
          "DIV": "div"
        },
        "fillMode": {
          "NORMAL": "normal",
          "REPEAT": "repeat",
          "JUSTIFY": "justify"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TimePickerData": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "labelDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        },
        "inputDirection": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ToggleSwitch": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnsupportedComponentData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VideoPlayer": {
      "enums": {
        "videoType": {
          "DAILYMOTION": "dailymotion",
          "FACEBOOK": "facebook",
          "FILE": "file",
          "TWITCH": "twitch",
          "VIMEO": "vimeo",
          "YOUTUBE": "youtube"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.ControlTypes": {
      "enums": {
        "dropdown": {
          "OPTIONS_1": "Options 1",
          "OPTIONS_2": "Options 2",
          "OPTIONS_3": "Options 3",
          "OPTIONS_4": "Options 4"
        },
        "radioButtons": {
          "OPTIONS_1": "Options 1",
          "OPTIONS_2": "Options 2",
          "OPTIONS_3": "Options 3",
          "OPTIONS_4": "Options 4"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.DashboardButton": {
      "enums": {
        "skin": {
          "STANDARD": "Standard",
          "LIGHT": "Light",
          "DESTRUCTIVE": "Destructive",
          "PREMIUM": "Premium",
          "PREMIUM_LIGHT": "Premium light",
          "DARK": "Dark",
          "TRANSPARENT": "Transparent"
        },
        "size": {
          "TINY": "Tiny",
          "SMALL": "Small",
          "MEDIUM": "Medium",
          "LARGE": "Large"
        },
        "priority": {
          "PRIMARY": "Primary",
          "SECONDARY": "Secondary"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.DashboardHeading": {
      "enums": {
        "size": {
          "PAGE_TITLE_H1": "Page title H1",
          "MODAL_TITLE_H2": "Modal title H2",
          "CARD_TITLE_H3": "Card title H3",
          "SECTION_TITLE_H4": "Section title H4",
          "CARD_SECTION_TITLE_H5": "Card section title H5",
          "CAPTION_H6": "Caption H6"
        },
        "textAlignment": {
          "LEFT": "Left",
          "CENTER": "Center",
          "RIGHT": "Right"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.DashboardIconButton": {
      "enums": {
        "skin": {
          "STANDARD": "Standard",
          "PREMIUM": "Premium",
          "LIGHT": "Light",
          "TRANSPARENT": "Transparent"
        },
        "size": {
          "TINY": "Tiny",
          "SMALL": "Small",
          "MEDIUM": "Medium",
          "LARGE": "Large"
        },
        "priority": {
          "PRIMARY": "Primary",
          "SECONDARY": "Secondary"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.DashboardInfoIcon": {
      "enums": {
        "size": {
          "SMALL": "Small",
          "MEDIUM": "Medium"
        }
      },
      "links": [
        "tooltipLink"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.DashboardInput": {
      "enums": {
        "prefixType": {
          "ICON": "Icon",
          "TEXT": "Text"
        },
        "suffixType": {
          "ICON": "Icon",
          "TEXT": "Text"
        },
        "size": {
          "SMALL": "Small",
          "MEDIUM": "Medium",
          "LARGE": "Large"
        },
        "border": {
          "DEFAULT": "Default",
          "ROUND": "Round",
          "LINE": "Line",
          "NONE": "None"
        },
        "labelPosition": {
          "TOP": "Top",
          "LEFT": "Left",
          "RIGHT": "Right"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.DashboardNumberInput": {
      "enums": {
        "prefixType": {
          "ICON": "Icon",
          "TEXT": "Text"
        },
        "suffixType": {
          "ICON": "Icon",
          "TEXT": "Text"
        },
        "size": {
          "SMALL": "Small",
          "MEDIUM": "Medium",
          "LARGE": "Large"
        },
        "border": {
          "DEFAULT": "Default",
          "ROUND": "Round",
          "LINE": "Line",
          "NONE": "None"
        },
        "labelPlacement": {
          "TOP": "Top",
          "LEFT": "Left",
          "RIGHT": "Right"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.DashboardText": {
      "enums": {
        "preset": {
          "STANDARD": "Standard",
          "STANDARD_SECONDARY": "Standard secondary",
          "LIGHT": "Light",
          "LIGHT_SECONDARY": "Light secondary",
          "SUCCESS": "Success",
          "DESTRUCTIVE": "Destructive",
          "PRIMARY": "Primary",
          "PREMIUM": "Premium",
          "DISABLED": "Disabled"
        },
        "size": {
          "TINY": "Tiny",
          "SMALL": "Small",
          "MEDIUM": "Medium"
        },
        "weight": {
          "BOLD": "Bold",
          "NORMAL": "Normal",
          "THIN": "Thin"
        },
        "textAlignment": {
          "LEFT": "Left",
          "CENTER": "Center",
          "RIGHT": "Right"
        },
        "overflow": {
          "WRAP": "Wrap",
          "ELLIPSIS": "Ellipsis"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.DashboardTextButton": {
      "enums": {
        "skin": {
          "STANDARD": "Standard",
          "PREMIUM": "Premium",
          "LIGHT": "Light",
          "DARK": "Dark",
          "DESTRUCTIVE": "Destructive"
        },
        "underline": {
          "NEVER": "Never",
          "ON_HOVER": "On hover",
          "ALWAYS": "Always"
        },
        "size": {
          "TINY": "Tiny",
          "SMALL": "Small",
          "MEDIUM": "Medium"
        },
        "weight": {
          "REGULAR": "Regular",
          "MEDIUM": "Medium"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.DashboardToggleSwitch": {
      "enums": {
        "skin": {
          "STANDARD": "Standard",
          "SUCCESS": "Success",
          "DESTRUCTIVE": "Destructive"
        },
        "size": {
          "SMALL": "Small",
          "MEDIUM": "Medium",
          "LARGE": "Large"
        },
        "labelPosition": {
          "TOP": "Top",
          "LEFT": "Left",
          "RIGHT": "Right"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.SettingsPanelContainer": {
      "enums": {
        "theme": {
          "CLASSIC": "classic",
          "RESPONSIVE": "responsive"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuAccordion": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuBackButton": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuButton": {
      "enums": {
        "skin": {
          "STANDARD": "standard",
          "STANDARD_SECONDARY": "standard secondary",
          "PREMIUM": "premium",
          "PREMIUM_SECONDARY": "premium secondary",
          "ALERT": "alert",
          "ALERT_SECONDARY": "alert secondary",
          "INVERTED": "inverted"
        },
        "size": {
          "SMALL": "small",
          "MEDIUM": "medium",
          "LARGE": "large"
        },
        "divider": {
          "LONG": "long",
          "SHORT": "short",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuCheckboxGroup": {
      "enums": {
        "divider": {
          "LONG": "long",
          "SHORT": "short",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuColorPicker": {
      "enums": {
        "divider": {
          "LONG": "long",
          "SHORT": "short",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuColorSelector": {
      "enums": {
        "divider": {
          "LONG": "long",
          "SHORT": "short",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuColumnControllerControl": {
      "enums": {
        "dividerType": {
          "LONG": "long",
          "SHORT": "short",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuDatePicker": {
      "enums": {
        "divider": {
          "LONG": "long",
          "SHORT": "short",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuDrillDown": {
      "enums": {
        "iconType": {
          "NONE": "None",
          "INFO": "Info",
          "ALERT": "Alert"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuDropdown": {
      "enums": {
        "divider": {
          "LONG": "long",
          "SHORT": "short",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuEmptyState": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuFontAndColorPicker": {
      "enums": {
        "divider": {
          "LONG": "long",
          "SHORT": "short",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuHorizontalTabs": {
      "enums": {
        "tabsStyle": {
          "FOLDER": "Folder",
          "ARROWED": "Arrowed",
          "ARROWED_WITHOUT_A_LINE": "Arrowed Without a Line"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuLeftTextButton": {
      "enums": {
        "size": {
          "TINY": "tiny",
          "SMALL": "small",
          "MEDIUM": "medium"
        },
        "skin": {
          "STANDARD": "standard",
          "PREMIUM": "premium"
        },
        "weight": {
          "THIN": "thin",
          "NORMAL": "normal"
        },
        "divider": {
          "LONG": "long",
          "SHORT": "short",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuMultilineTextInput": {
      "enums": {
        "divider": {
          "LONG": "long",
          "SHORT": "short",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuNotificationBanner": {
      "enums": {
        "skin": {
          "STANDARD": "standard",
          "PREMIUM": "premium",
          "ALERT": "alert",
          "SUCCESS": "success"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuNumericInput": {
      "enums": {
        "unitSuffix": {
          "NONE": "None",
          "PIXELS": "Pixels",
          "PERCENTAGE": "Percentage",
          "DEGREES": "Degrees"
        },
        "divider": {
          "LONG": "long",
          "SHORT": "short",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuRadioButtonGroup": {
      "enums": {
        "divider": {
          "LONG": "long",
          "SHORT": "short",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuRichText": {
      "enums": {
        "divider": {
          "LONG": "long",
          "SHORT": "short",
          "NONE": "none"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuSectionDivider": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuSlider": {
      "enums": {
        "unitOfMeasurement": {
          "NUMBER": "number",
          "PERCENTAGE": "percentage",
          "PIXELS": "pixels",
          "ANGLE": "angle"
        },
        "divider": {
          "LONG": "long",
          "SHORT": "short",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuTextInput": {
      "enums": {
        "divider": {
          "LONG": "long",
          "SHORT": "short",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuThumbnails": {
      "enums": {
        "thumbnailHeight": {
          "FIXED_RATIO__1_1_": "Fixed ratio (1:1)",
          "FLUID": "Fluid"
        },
        "divider": {
          "LONG": "long",
          "SHORT": "short",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ThumbnailItemData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WbuToggleSwitch": {
      "enums": {
        "divider": {
          "LONG": "long",
          "SHORT": "short",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WutAvatar": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WutAvatarGroup": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WutBadge": {
      "enums": {
        "composition": {
          "TEXTANDICON": "TextAndIcon",
          "TEXT": "Text",
          "ICON": "Icon",
          "NONE": "None"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dsgnsys.WutRadioButton": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RefArray": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VariantRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MinimalUnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SPXReferenceDefinition": {
      "enums": {
        "resolverType": {
          "SCALE": "scale",
          "FIXED": "fixed"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLength": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLengthPercentage": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitAngle": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizeArea": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizePoint": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointsData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRange": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "NumberThatCanConnectToAVariable": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkReference": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_Image": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_SVGItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ColorLayers": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinearLayer": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleLayer": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseLayer": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientMeshLayer": {
      "enums": {
        "type": {
          "GRADIENTMESH": "GradientMesh",
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConicLayer": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColorLayer": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinear": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircle": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipse": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConic": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColor": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BlendMode": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientColorStop": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientAngularColorStop": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    }
  },
  "props": {
    "$id": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FontsEnum": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "DefaultProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FlipProperties": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "HORIZONTAL": "horizontal",
          "VERTICAL": "vertical",
          "BOTH": "both",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VideoBackgroundProperties": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "CardsLayoutProperties": {
      "enums": {
        "alignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right",
          "JUSTIFY": "justify"
        },
        "direction": {
          "RTL": "rtl",
          "LTR": "ltr"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VerticalLayoutProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "DisableableProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ClassicSectionProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StripColumnsContainerProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ColumnProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "InputProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "InputElementsErrorProperties": {
      "enums": {
        "errorMessageType": {
          "INLINE": "inline",
          "TOOLTIP": "tooltip"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "QuickActionBarProperties": {
      "enums": {
        "colorScheme": {
          "BLACK": "black",
          "GREY": "grey",
          "BRAND": "brand"
        },
        "alignment": {
          "RIGHT": "right",
          "LEFT": "left"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PhotoProperties": {
      "enums": {
        "imageSize": {
          "SMALL": "small",
          "MEDIUM": "medium",
          "LARGE": "large"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FacebookLikeBoxProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ImageButtonProperties": {
      "enums": {
        "transition": {
          "NONE": "none",
          "FADE": "fade"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MultiSelectionProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MultiSelectionItemProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "NumericStepperProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PinterestPinItProperties": {
      "enums": {
        "size": {
          "SMALL": "small",
          "LARGE": "large"
        },
        "color": {
          "GRAY": "gray",
          "RED": "red",
          "WHITE": "white"
        },
        "counterPosition": {
          "NONE": "none",
          "ABOVE": "above",
          "BESIDE": "beside"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SingleAudioPlayerProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SkypeCallButtonProperties": {
      "enums": {
        "imageSize": {
          "SMALL": "small",
          "MEDIUM": "medium",
          "LARGE": "large"
        },
        "imageColor": {
          "BLUE": "blue",
          "WHITE": "white"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SpotifyFollowProperties": {
      "enums": {
        "size": {
          "SMALL": "small",
          "LARGE": "large"
        },
        "theme": {
          "LIGHT": "light",
          "DARK": "dark"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SpotifyPlayerProperties": {
      "enums": {
        "size": {
          "COMPACT": "compact",
          "LARGE": "large"
        },
        "color": {
          "BLACK": "black",
          "WHITE": "white"
        },
        "style": {
          "LIST": "list",
          "COVERART": "coverart"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SubscribeFormProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VerticalMenuProperties": {
      "enums": {
        "itemsAlignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "subMenuOpenSide": {
          "LEFT": "left",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "YouTubeSubscribeButtonProperties": {
      "enums": {
        "layout": {
          "DEFAULT": "default",
          "FULL": "full"
        },
        "theme": {
          "LIGHT": "light",
          "DARK": "dark"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BgImageStripProperties": {
      "enums": {
        "bgSize": {
          "AUTO": "auto",
          "COVER": "cover",
          "CONTAIN": "contain"
        },
        "bgRepeat": {
          "NO_REPEAT": "no-repeat",
          "REPEAT_X": "repeat-x",
          "REPEAT_Y": "repeat-y",
          "REPEAT": "repeat"
        },
        "bgPosition": {
          "TOP_LEFT": "top left",
          "TOP_CENTER": "top center",
          "TOP_RIGHT": "top right",
          "CENTER_LEFT": "center left",
          "CENTER": "center",
          "CENTER_RIGHT": "center right",
          "BOTTOM_LEFT": "bottom left",
          "BOTTOM_CENTER": "bottom center",
          "BOTTOM_RIGHT": "bottom right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BgImageStripUnifiedProperties": {
      "enums": {
        "fittingType": {
          "FILL": "fill",
          "FIT": "fit",
          "ACTUAL_SIZE": "actual_size",
          "TILE": "tile",
          "FIT_AND_TILE": "fit_and_tile",
          "TILE_HORIZONTAL": "tile_horizontal",
          "TILE_VERTICAL": "tile_vertical",
          "LEGACY_STRIP_TILE": "legacy_strip_tile",
          "LEGACY_STRIP_TILE_HORIZONTAL": "legacy_strip_tile_horizontal",
          "LEGACY_STRIP_TILE_VERTICAL": "legacy_strip_tile_vertical",
          "LEGACY_STRIP_ORIGINAL_SIZE": "legacy_strip_original_size",
          "LEGACY_STRIP_FILL": "legacy_strip_fill",
          "LEGACY_STRIP_FIT": "legacy_strip_fit",
          "LEGACY_STRIP_FIT_AND_TILE": "legacy_strip_fit_and_tile"
        },
        "alignType": {
          "TOP_LEFT": "top_left",
          "TOP": "top",
          "TOP_RIGHT": "top_right",
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right",
          "BOTTOM_LEFT": "bottom_left",
          "BOTTOM": "bottom",
          "BOTTOM_RIGHT": "bottom_right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FileUploaderProperties": {
      "enums": {
        "buttonAlignment": {
          "RTL": "rtl",
          "LTR": "ltr"
        },
        "filesAlignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "filesType": {
          "IMAGE": "Image",
          "DOCUMENT": "Document",
          "VIDEO": "Video",
          "AUDIO": "Audio",
          "ARCHIVE": "Archive",
          "GALLERY": "Gallery"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UploadNameProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ButtonProperties": {
      "enums": {
        "align": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LoginSocialBarProperties": {
      "enums": {
        "buttonsDirection": {
          "LTR": "ltr",
          "RTL": "rtl"
        },
        "dropDownTextAlignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "buttonsAlignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "arrowShape": {
          "NONE": "none",
          "LINE": "line",
          "FULL": "full"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ComboBoxInputProperties": {
      "enums": {
        "textAlignment": {
          "LEFT": "left",
          "RIGHT": "right",
          "CENTER": "center"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        },
        "errorMessageType": {
          "INLINE": "inline",
          "TOOLTIP": "tooltip"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [
        "textPadding",
        "size",
        "dropdownItemsSpacing",
        "inputHeight",
        "inputHeightMobile",
        "labelMargin",
        "labelPadding",
        "labelMobileFontSize",
        "inputMobileFontSize"
      ],
      "convertToString": []
    },
    "RadioButtonProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RadioGroupProperties": {
      "enums": {
        "alignment": {
          "LEFT": "left",
          "RIGHT": "right"
        },
        "layout": {
          "VERTICAL": "vertical",
          "HORIZONTAL": "horizontal"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        },
        "errorMessageType": {
          "INLINE": "inline",
          "TOOLTIP": "tooltip"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "CheckboxGroupProperties": {
      "enums": {
        "alignment": {
          "LEFT": "left",
          "RIGHT": "right"
        },
        "layout": {
          "VERTICAL": "vertical",
          "HORIZONTAL": "horizontal"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        },
        "errorMessageType": {
          "INLINE": "inline",
          "TOOLTIP": "tooltip"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ContactFormProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "DocumentMediaProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "EbayItemsBySellerProperties": {
      "enums": {
        "headerImage": {
          "_0": "0",
          "_2": "2",
          "_3": "3",
          "_4": "4",
          "_5": "5",
          "_6": "6",
          "_7": "7",
          "_8": "8",
          "_9": "9",
          "_10": "10",
          "_11": "11"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FiveGridLineProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FlashComponentProperties": {
      "enums": {
        "displayMode": {
          "ORIGINAL": "original",
          "FIT": "fit",
          "STRETCH": "stretch"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GalleryExpandProperties": {
      "enums": {
        "galleryImageOnClickAction": {
          "DISABLED": "disabled",
          "ZOOMMODE": "zoomMode",
          "GOTOLINK": "goToLink"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GoogleMapProperties": {
      "enums": {
        "mapType": {
          "ROADMAP": "ROADMAP",
          "TERRAIN": "TERRAIN",
          "SATELLITE": "SATELLITE",
          "HYBRID": "HYBRID"
        },
        "language": {
          "USERLANG": "userLang",
          "CS": "cs",
          "DA": "da",
          "DE": "de",
          "EN": "en",
          "ES": "es",
          "FR": "fr",
          "HI": "hi",
          "IT": "it",
          "JA": "ja",
          "KO": "ko",
          "NL": "nl",
          "NO": "no",
          "PL": "pl",
          "PT": "pt",
          "RU": "ru",
          "SV": "sv",
          "ZH": "zh",
          "TH": "th",
          "UK": "uk",
          "TR": "tr"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "HorizontalMenuProperties": {
      "enums": {
        "alignButtons": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "alignText": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ImpressProperties": {
      "enums": {
        "font": {
          "LUCIDASANSCONSOLE": "lucidaSansConsole",
          "PALATINOLINOTYPE": "palatinoLinotype",
          "AMERICANTYPWRTERITCW01__731025": "americantypwrteritcw01--731025",
          "ANTON": "anton",
          "ARIAL": "arial",
          "ARIALBLACK": "arialBlack",
          "AVENIDA_W01": "avenida-w01",
          "BASIC": "basic",
          "CAUDEX": "caudex",
          "CLARENDON_W01_MEDIUM_692107": "clarendon-w01-medium-692107",
          "COMICSANSMS": "comicSansMS",
          "COOKIE": "cookie",
          "COQUETTE_W00_LIGHT": "coquette-w00-light",
          "COURIERNEW": "courierNew",
          "DIN_NEXT_W01_LIGHT": "din-next-w01-light",
          "DROID_SERIF_W01_REGULAR": "droid-serif-w01-regular",
          "EB_GARAMOND": "eb garamond",
          "ENRIQUETA": "enriqueta",
          "FORUM": "forum",
          "GEORGIA": "georgia",
          "HELVETICA_W01_ROMAN": "helvetica-w01-roman",
          "HELVETICA_W01_BOLD": "helvetica-w01-bold",
          "HELVETICA_W01_LIGHT": "helvetica-w01-light",
          "IMPACT": "impact",
          "JOCKEY_ONE": "jockey one",
          "JURA": "jura",
          "KELLY_SLAB": "kelly slab",
          "LOBSTER": "lobster",
          "LUCIDACONSOLE": "lucidaConsole",
          "MARCK_SCRIPT": "marck script",
          "MONOTON": "monoton",
          "NOTICIA_TEXT": "noticia text",
          "OPEN_SANS": "open sans",
          "OPEN_SANS_CONDENSED": "open sans condensed",
          "PALATINO_LINOTYPE": "palatino linotype",
          "PATRICK_HAND": "patrick hand",
          "PLAY": "play",
          "REKLAMESCRIPTW00_MEDIUM": "reklamescriptw00-medium",
          "SACRAMENTO": "sacramento",
          "SARINA": "sarina",
          "SIGNIKA": "signika",
          "SOHO_W01_THIN_CONDENSED": "soho-w01-thin-condensed",
          "TAHOMA": "tahoma",
          "TIMESNEWROMAN": "timesNewRoman",
          "VERDANA": "verdana",
          "BODONI_W01_POSTER": "bodoni-w01-poster",
          "MS_JP_GOTHIC": "ｍｓ ゴシック",
          "MS_JP_MING_DYNASTY": "ｍｓ 明朝",
          "MS_JP_P_GOTHIC": "ｍｓ ｐゴシック",
          "MS_JP_P_MING_DYNASTY": "ｍｓ ｐ明朝",
          "MEIRYO": "meiryo",
          "JP_MEIRYO": "メイリオ",
          "BM_HANNA": "bm-hanna",
          "KO_MAGPIE": "돋움",
          "FBBLUEGOTHICL": "fbbluegothicl",
          "FBCHAMBLUE": "fbchamblue",
          "FBGREEN": "fbgreen",
          "FBNEOGOTHIC": "fbneogothic",
          "FBPLUM": "fbplum",
          "KO_ROLL": "굴림",
          "KO_CLEAR_GOTHIC": "맑은 고딕",
          "NANUMGOTHIC_REGULAR": "nanumgothic-regular",
          "AHMEDLTW20_OUTLINEREGUL": "ahmedltw20-outlineregul",
          "AMIRI": "amiri",
          "ARABICTYPESETTINGW23_RE": "arabictypesettingw23-re",
          "ARIAN_LT_W20_REGULAR": "arian-lt-w20-regular",
          "ARIAN_LT_W20_LIGHT": "arian-lt-w20-light",
          "COHEADLINEW23_ARABICBOL": "coheadlinew23-arabicbol",
          "DINNEXTLTW23_ULTRALIGHT": "dinnextltw23-ultralight",
          "DROID_NASKH": "droid-naskh",
          "JANNA_LT_W20_REGULAR": "janna-lt-w20-regular",
          "KUFI_LT_W20_REGULAR": "kufi-lt-w20-regular",
          "MIDAN_W20": "midan-w20",
          "HELVETICANEUELTW20_LIGH": "helveticaneueltw20-ligh",
          "TANSEEKMODERNW20_LIGHT": "tanseekmodernw20-light",
          "ADLER_W26_REGULAR": "adler-w26-regular",
          "ALEF_REGULAR": "alef-regular",
          "ALMONI_DL_AAA_700": "almoni-dl-aaa-700",
          "ALMONI_DL_AAA_300": "almoni-dl-aaa-300",
          "ALMONI_DL_AAA_400": "almoni-dl-aaa-400",
          "ASIMON_AAA_400": "asimon-aaa-400",
          "ATLAS_AAA_500": "atlas-aaa-500",
          "CHIPS_W26_NORMAL": "chips-w26-normal",
          "FRANK_RUHL_W26_REGULAR": "frank-ruhl-w26-regular",
          "GULASH_W26_REGULAR": "gulash-w26-regular",
          "HAIM_ARUKEEM_W26_MEDIUM": "haim-arukeem-w26-medium",
          "MIRIAM_W26_MEDIUM": "miriam-w26-medium",
          "MIXTAPE_AAA_400": "mixtape-aaa-400",
          "MUSEUM_AAA_400": "museum-aaa-400",
          "NEKUDOT_W26_BOLD": "nekudot-w26-bold",
          "OMES_AAA_400": "omes-aaa-400",
          "OPENSANSHEBREWCONDENSED_REGULAR": "opensanshebrewcondensed-regular",
          "SHABAZI_W26_BOLD": "shabazi-w26-bold",
          "AMATIC_SC": "amatic sc",
          "BRAGGADOCIO_W01": "braggadocio-w01",
          "CHELSEA_MARKET": "chelsea market",
          "CORBEN": "corben",
          "FREDERICKA_THE_GREAT": "fredericka the great",
          "GEOTICA_W01_FOUR_OPEN": "geotica-w01-four-open",
          "HELVETICA_NEUE": "helvetica neue",
          "HELVETICA_NEUE_ITALIC": "helvetica neue italic",
          "HELVETICA_NEUE_MEDIUM": "helvetica neue medium",
          "HELVETICA_NEUE_THIN": "helvetica neue thin",
          "ITC_ARECIBO_W01_REGULAR": "itc-arecibo-w01-regular",
          "JOSEFIN_SLAB": "josefin slab",
          "LUCIDA_SANS_UNICODE": "lucida sans unicode",
          "MARZO_W00_REGULAR": "marzo-w00-regular",
          "MR_DE_HAVILAND": "mr de haviland",
          "MUSEO_W01_700": "museo-w01-700",
          "MUSEO_SLAB_W01_100": "museo-slab-w01-100",
          "NICONNE": "niconne",
          "NIMBUS_SANS_TW01CON": "nimbus-sans-tw01con",
          "OVERLOCK": "overlock",
          "PACIFICA_W00_CONDENSED": "pacifica-w00-condensed",
          "RALEWAY": "raleway",
          "ROSEWOOD_W01_REGULAR": "rosewood-w01-regular",
          "SNELLROUNDHANDW01_SCRIP": "snellroundhandw01-scrip",
          "SPINNAKER": "spinnaker",
          "STENCIL_W01_BOLD": "stencil-w01-bold"
        },
        "textMode": {
          "TITLEANDDESCRIPTION": "titleAndDescription",
          "TITLEONLY": "titleOnly",
          "DESCRIPTIONONLY": "descriptionOnly",
          "NOTEXT": "noText"
        },
        "alignText": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "galleryImageOnClickAction": {
          "DISABLED": "disabled",
          "ZOOMMODE": "zoomMode",
          "GOTOLINK": "goToLink"
        },
        "cropAndFitStage": {
          "CROP": "crop",
          "FIT": "fit"
        },
        "transition": {
          "NONE": "none",
          "_1": "1",
          "_2": "2",
          "_3": "3",
          "_4": "4",
          "_5": "5",
          "RANDOM": "random"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MasonryProperties": {
      "enums": {
        "font": {
          "LUCIDASANSCONSOLE": "lucidaSansConsole",
          "PALATINOLINOTYPE": "palatinoLinotype",
          "AMERICANTYPWRTERITCW01__731025": "americantypwrteritcw01--731025",
          "ANTON": "anton",
          "ARIAL": "arial",
          "ARIALBLACK": "arialBlack",
          "AVENIDA_W01": "avenida-w01",
          "BASIC": "basic",
          "CAUDEX": "caudex",
          "CLARENDON_W01_MEDIUM_692107": "clarendon-w01-medium-692107",
          "COMICSANSMS": "comicSansMS",
          "COOKIE": "cookie",
          "COQUETTE_W00_LIGHT": "coquette-w00-light",
          "COURIERNEW": "courierNew",
          "DIN_NEXT_W01_LIGHT": "din-next-w01-light",
          "DROID_SERIF_W01_REGULAR": "droid-serif-w01-regular",
          "EB_GARAMOND": "eb garamond",
          "ENRIQUETA": "enriqueta",
          "FORUM": "forum",
          "GEORGIA": "georgia",
          "HELVETICA_W01_ROMAN": "helvetica-w01-roman",
          "HELVETICA_W01_BOLD": "helvetica-w01-bold",
          "HELVETICA_W01_LIGHT": "helvetica-w01-light",
          "IMPACT": "impact",
          "JOCKEY_ONE": "jockey one",
          "JURA": "jura",
          "KELLY_SLAB": "kelly slab",
          "LOBSTER": "lobster",
          "LUCIDACONSOLE": "lucidaConsole",
          "MARCK_SCRIPT": "marck script",
          "MONOTON": "monoton",
          "NOTICIA_TEXT": "noticia text",
          "OPEN_SANS": "open sans",
          "OPEN_SANS_CONDENSED": "open sans condensed",
          "PALATINO_LINOTYPE": "palatino linotype",
          "PATRICK_HAND": "patrick hand",
          "PLAY": "play",
          "REKLAMESCRIPTW00_MEDIUM": "reklamescriptw00-medium",
          "SACRAMENTO": "sacramento",
          "SARINA": "sarina",
          "SIGNIKA": "signika",
          "SOHO_W01_THIN_CONDENSED": "soho-w01-thin-condensed",
          "TAHOMA": "tahoma",
          "TIMESNEWROMAN": "timesNewRoman",
          "VERDANA": "verdana",
          "BODONI_W01_POSTER": "bodoni-w01-poster",
          "MS_JP_GOTHIC": "ｍｓ ゴシック",
          "MS_JP_MING_DYNASTY": "ｍｓ 明朝",
          "MS_JP_P_GOTHIC": "ｍｓ ｐゴシック",
          "MS_JP_P_MING_DYNASTY": "ｍｓ ｐ明朝",
          "MEIRYO": "meiryo",
          "JP_MEIRYO": "メイリオ",
          "BM_HANNA": "bm-hanna",
          "KO_MAGPIE": "돋움",
          "FBBLUEGOTHICL": "fbbluegothicl",
          "FBCHAMBLUE": "fbchamblue",
          "FBGREEN": "fbgreen",
          "FBNEOGOTHIC": "fbneogothic",
          "FBPLUM": "fbplum",
          "KO_ROLL": "굴림",
          "KO_CLEAR_GOTHIC": "맑은 고딕",
          "NANUMGOTHIC_REGULAR": "nanumgothic-regular",
          "AHMEDLTW20_OUTLINEREGUL": "ahmedltw20-outlineregul",
          "AMIRI": "amiri",
          "ARABICTYPESETTINGW23_RE": "arabictypesettingw23-re",
          "ARIAN_LT_W20_REGULAR": "arian-lt-w20-regular",
          "ARIAN_LT_W20_LIGHT": "arian-lt-w20-light",
          "COHEADLINEW23_ARABICBOL": "coheadlinew23-arabicbol",
          "DINNEXTLTW23_ULTRALIGHT": "dinnextltw23-ultralight",
          "DROID_NASKH": "droid-naskh",
          "JANNA_LT_W20_REGULAR": "janna-lt-w20-regular",
          "KUFI_LT_W20_REGULAR": "kufi-lt-w20-regular",
          "MIDAN_W20": "midan-w20",
          "HELVETICANEUELTW20_LIGH": "helveticaneueltw20-ligh",
          "TANSEEKMODERNW20_LIGHT": "tanseekmodernw20-light",
          "ADLER_W26_REGULAR": "adler-w26-regular",
          "ALEF_REGULAR": "alef-regular",
          "ALMONI_DL_AAA_700": "almoni-dl-aaa-700",
          "ALMONI_DL_AAA_300": "almoni-dl-aaa-300",
          "ALMONI_DL_AAA_400": "almoni-dl-aaa-400",
          "ASIMON_AAA_400": "asimon-aaa-400",
          "ATLAS_AAA_500": "atlas-aaa-500",
          "CHIPS_W26_NORMAL": "chips-w26-normal",
          "FRANK_RUHL_W26_REGULAR": "frank-ruhl-w26-regular",
          "GULASH_W26_REGULAR": "gulash-w26-regular",
          "HAIM_ARUKEEM_W26_MEDIUM": "haim-arukeem-w26-medium",
          "MIRIAM_W26_MEDIUM": "miriam-w26-medium",
          "MIXTAPE_AAA_400": "mixtape-aaa-400",
          "MUSEUM_AAA_400": "museum-aaa-400",
          "NEKUDOT_W26_BOLD": "nekudot-w26-bold",
          "OMES_AAA_400": "omes-aaa-400",
          "OPENSANSHEBREWCONDENSED_REGULAR": "opensanshebrewcondensed-regular",
          "SHABAZI_W26_BOLD": "shabazi-w26-bold",
          "AMATIC_SC": "amatic sc",
          "BRAGGADOCIO_W01": "braggadocio-w01",
          "CHELSEA_MARKET": "chelsea market",
          "CORBEN": "corben",
          "FREDERICKA_THE_GREAT": "fredericka the great",
          "GEOTICA_W01_FOUR_OPEN": "geotica-w01-four-open",
          "HELVETICA_NEUE": "helvetica neue",
          "HELVETICA_NEUE_ITALIC": "helvetica neue italic",
          "HELVETICA_NEUE_MEDIUM": "helvetica neue medium",
          "HELVETICA_NEUE_THIN": "helvetica neue thin",
          "ITC_ARECIBO_W01_REGULAR": "itc-arecibo-w01-regular",
          "JOSEFIN_SLAB": "josefin slab",
          "LUCIDA_SANS_UNICODE": "lucida sans unicode",
          "MARZO_W00_REGULAR": "marzo-w00-regular",
          "MR_DE_HAVILAND": "mr de haviland",
          "MUSEO_W01_700": "museo-w01-700",
          "MUSEO_SLAB_W01_100": "museo-slab-w01-100",
          "NICONNE": "niconne",
          "NIMBUS_SANS_TW01CON": "nimbus-sans-tw01con",
          "OVERLOCK": "overlock",
          "PACIFICA_W00_CONDENSED": "pacifica-w00-condensed",
          "RALEWAY": "raleway",
          "ROSEWOOD_W01_REGULAR": "rosewood-w01-regular",
          "SNELLROUNDHANDW01_SCRIP": "snellroundhandw01-scrip",
          "SPINNAKER": "spinnaker",
          "STENCIL_W01_BOLD": "stencil-w01-bold"
        },
        "galleryImageOnClickAction": {
          "DISABLED": "disabled",
          "ZOOMMODE": "zoomMode",
          "GOTOLINK": "goToLink"
        },
        "textMode": {
          "TITLEANDDESCRIPTION": "titleAndDescription",
          "TITLEONLY": "titleOnly",
          "DESCRIPTIONONLY": "descriptionOnly",
          "NOTEXT": "noText"
        },
        "alignText": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StripShowcaseProperties": {
      "enums": {
        "galleryImageOnClickAction": {
          "DISABLED": "disabled",
          "ZOOMMODE": "zoomMode",
          "GOTOLINK": "goToLink"
        },
        "cropAndFitStage": {
          "CROP": "crop",
          "FIT": "fit"
        },
        "imageScale": {
          "_16_9": "16:9",
          "_4_3": "4:3",
          "_1_1": "1:1",
          "_3_4": "3:4",
          "_9_16": "9:16"
        },
        "thumbsScale": {
          "_16_9": "16:9",
          "_4_3": "4:3",
          "_1_1": "1:1",
          "_3_4": "3:4",
          "_9_16": "9:16"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StripSlideshowProperties": {
      "enums": {
        "font": {
          "LUCIDASANSCONSOLE": "lucidaSansConsole",
          "PALATINOLINOTYPE": "palatinoLinotype",
          "AMERICANTYPWRTERITCW01__731025": "americantypwrteritcw01--731025",
          "ANTON": "anton",
          "ARIAL": "arial",
          "ARIALBLACK": "arialBlack",
          "AVENIDA_W01": "avenida-w01",
          "BASIC": "basic",
          "CAUDEX": "caudex",
          "CLARENDON_W01_MEDIUM_692107": "clarendon-w01-medium-692107",
          "COMICSANSMS": "comicSansMS",
          "COOKIE": "cookie",
          "COQUETTE_W00_LIGHT": "coquette-w00-light",
          "COURIERNEW": "courierNew",
          "DIN_NEXT_W01_LIGHT": "din-next-w01-light",
          "DROID_SERIF_W01_REGULAR": "droid-serif-w01-regular",
          "EB_GARAMOND": "eb garamond",
          "ENRIQUETA": "enriqueta",
          "FORUM": "forum",
          "GEORGIA": "georgia",
          "HELVETICA_W01_ROMAN": "helvetica-w01-roman",
          "HELVETICA_W01_BOLD": "helvetica-w01-bold",
          "HELVETICA_W01_LIGHT": "helvetica-w01-light",
          "IMPACT": "impact",
          "JOCKEY_ONE": "jockey one",
          "JURA": "jura",
          "KELLY_SLAB": "kelly slab",
          "LOBSTER": "lobster",
          "LUCIDACONSOLE": "lucidaConsole",
          "MARCK_SCRIPT": "marck script",
          "MONOTON": "monoton",
          "NOTICIA_TEXT": "noticia text",
          "OPEN_SANS": "open sans",
          "OPEN_SANS_CONDENSED": "open sans condensed",
          "PALATINO_LINOTYPE": "palatino linotype",
          "PATRICK_HAND": "patrick hand",
          "PLAY": "play",
          "REKLAMESCRIPTW00_MEDIUM": "reklamescriptw00-medium",
          "SACRAMENTO": "sacramento",
          "SARINA": "sarina",
          "SIGNIKA": "signika",
          "SOHO_W01_THIN_CONDENSED": "soho-w01-thin-condensed",
          "TAHOMA": "tahoma",
          "TIMESNEWROMAN": "timesNewRoman",
          "VERDANA": "verdana",
          "BODONI_W01_POSTER": "bodoni-w01-poster",
          "MS_JP_GOTHIC": "ｍｓ ゴシック",
          "MS_JP_MING_DYNASTY": "ｍｓ 明朝",
          "MS_JP_P_GOTHIC": "ｍｓ ｐゴシック",
          "MS_JP_P_MING_DYNASTY": "ｍｓ ｐ明朝",
          "MEIRYO": "meiryo",
          "JP_MEIRYO": "メイリオ",
          "BM_HANNA": "bm-hanna",
          "KO_MAGPIE": "돋움",
          "FBBLUEGOTHICL": "fbbluegothicl",
          "FBCHAMBLUE": "fbchamblue",
          "FBGREEN": "fbgreen",
          "FBNEOGOTHIC": "fbneogothic",
          "FBPLUM": "fbplum",
          "KO_ROLL": "굴림",
          "KO_CLEAR_GOTHIC": "맑은 고딕",
          "NANUMGOTHIC_REGULAR": "nanumgothic-regular",
          "AHMEDLTW20_OUTLINEREGUL": "ahmedltw20-outlineregul",
          "AMIRI": "amiri",
          "ARABICTYPESETTINGW23_RE": "arabictypesettingw23-re",
          "ARIAN_LT_W20_REGULAR": "arian-lt-w20-regular",
          "ARIAN_LT_W20_LIGHT": "arian-lt-w20-light",
          "COHEADLINEW23_ARABICBOL": "coheadlinew23-arabicbol",
          "DINNEXTLTW23_ULTRALIGHT": "dinnextltw23-ultralight",
          "DROID_NASKH": "droid-naskh",
          "JANNA_LT_W20_REGULAR": "janna-lt-w20-regular",
          "KUFI_LT_W20_REGULAR": "kufi-lt-w20-regular",
          "MIDAN_W20": "midan-w20",
          "HELVETICANEUELTW20_LIGH": "helveticaneueltw20-ligh",
          "TANSEEKMODERNW20_LIGHT": "tanseekmodernw20-light",
          "ADLER_W26_REGULAR": "adler-w26-regular",
          "ALEF_REGULAR": "alef-regular",
          "ALMONI_DL_AAA_700": "almoni-dl-aaa-700",
          "ALMONI_DL_AAA_300": "almoni-dl-aaa-300",
          "ALMONI_DL_AAA_400": "almoni-dl-aaa-400",
          "ASIMON_AAA_400": "asimon-aaa-400",
          "ATLAS_AAA_500": "atlas-aaa-500",
          "CHIPS_W26_NORMAL": "chips-w26-normal",
          "FRANK_RUHL_W26_REGULAR": "frank-ruhl-w26-regular",
          "GULASH_W26_REGULAR": "gulash-w26-regular",
          "HAIM_ARUKEEM_W26_MEDIUM": "haim-arukeem-w26-medium",
          "MIRIAM_W26_MEDIUM": "miriam-w26-medium",
          "MIXTAPE_AAA_400": "mixtape-aaa-400",
          "MUSEUM_AAA_400": "museum-aaa-400",
          "NEKUDOT_W26_BOLD": "nekudot-w26-bold",
          "OMES_AAA_400": "omes-aaa-400",
          "OPENSANSHEBREWCONDENSED_REGULAR": "opensanshebrewcondensed-regular",
          "SHABAZI_W26_BOLD": "shabazi-w26-bold",
          "AMATIC_SC": "amatic sc",
          "BRAGGADOCIO_W01": "braggadocio-w01",
          "CHELSEA_MARKET": "chelsea market",
          "CORBEN": "corben",
          "FREDERICKA_THE_GREAT": "fredericka the great",
          "GEOTICA_W01_FOUR_OPEN": "geotica-w01-four-open",
          "HELVETICA_NEUE": "helvetica neue",
          "HELVETICA_NEUE_ITALIC": "helvetica neue italic",
          "HELVETICA_NEUE_MEDIUM": "helvetica neue medium",
          "HELVETICA_NEUE_THIN": "helvetica neue thin",
          "ITC_ARECIBO_W01_REGULAR": "itc-arecibo-w01-regular",
          "JOSEFIN_SLAB": "josefin slab",
          "LUCIDA_SANS_UNICODE": "lucida sans unicode",
          "MARZO_W00_REGULAR": "marzo-w00-regular",
          "MR_DE_HAVILAND": "mr de haviland",
          "MUSEO_W01_700": "museo-w01-700",
          "MUSEO_SLAB_W01_100": "museo-slab-w01-100",
          "NICONNE": "niconne",
          "NIMBUS_SANS_TW01CON": "nimbus-sans-tw01con",
          "OVERLOCK": "overlock",
          "PACIFICA_W00_CONDENSED": "pacifica-w00-condensed",
          "RALEWAY": "raleway",
          "ROSEWOOD_W01_REGULAR": "rosewood-w01-regular",
          "SNELLROUNDHANDW01_SCRIP": "snellroundhandw01-scrip",
          "SPINNAKER": "spinnaker",
          "STENCIL_W01_BOLD": "stencil-w01-bold"
        },
        "textMode": {
          "TITLEANDDESCRIPTION": "titleAndDescription",
          "TITLEONLY": "titleOnly",
          "DESCRIPTIONONLY": "descriptionOnly",
          "NOTEXT": "noText"
        },
        "alignText": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "transition": {
          "NONE": "none",
          "CROSSFADE": "crossFade",
          "SLIDE": "slide",
          "SCROLL": "scroll",
          "ZOOM": "zoom",
          "RANDOM": "random"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ThumbnailsProperties": {
      "enums": {
        "font": {
          "LUCIDASANSCONSOLE": "lucidaSansConsole",
          "PALATINOLINOTYPE": "palatinoLinotype",
          "AMERICANTYPWRTERITCW01__731025": "americantypwrteritcw01--731025",
          "ANTON": "anton",
          "ARIAL": "arial",
          "ARIALBLACK": "arialBlack",
          "AVENIDA_W01": "avenida-w01",
          "BASIC": "basic",
          "CAUDEX": "caudex",
          "CLARENDON_W01_MEDIUM_692107": "clarendon-w01-medium-692107",
          "COMICSANSMS": "comicSansMS",
          "COOKIE": "cookie",
          "COQUETTE_W00_LIGHT": "coquette-w00-light",
          "COURIERNEW": "courierNew",
          "DIN_NEXT_W01_LIGHT": "din-next-w01-light",
          "DROID_SERIF_W01_REGULAR": "droid-serif-w01-regular",
          "EB_GARAMOND": "eb garamond",
          "ENRIQUETA": "enriqueta",
          "FORUM": "forum",
          "GEORGIA": "georgia",
          "HELVETICA_W01_ROMAN": "helvetica-w01-roman",
          "HELVETICA_W01_BOLD": "helvetica-w01-bold",
          "HELVETICA_W01_LIGHT": "helvetica-w01-light",
          "IMPACT": "impact",
          "JOCKEY_ONE": "jockey one",
          "JURA": "jura",
          "KELLY_SLAB": "kelly slab",
          "LOBSTER": "lobster",
          "LUCIDACONSOLE": "lucidaConsole",
          "MARCK_SCRIPT": "marck script",
          "MONOTON": "monoton",
          "NOTICIA_TEXT": "noticia text",
          "OPEN_SANS": "open sans",
          "OPEN_SANS_CONDENSED": "open sans condensed",
          "PALATINO_LINOTYPE": "palatino linotype",
          "PATRICK_HAND": "patrick hand",
          "PLAY": "play",
          "REKLAMESCRIPTW00_MEDIUM": "reklamescriptw00-medium",
          "SACRAMENTO": "sacramento",
          "SARINA": "sarina",
          "SIGNIKA": "signika",
          "SOHO_W01_THIN_CONDENSED": "soho-w01-thin-condensed",
          "TAHOMA": "tahoma",
          "TIMESNEWROMAN": "timesNewRoman",
          "VERDANA": "verdana",
          "BODONI_W01_POSTER": "bodoni-w01-poster",
          "MS_JP_GOTHIC": "ｍｓ ゴシック",
          "MS_JP_MING_DYNASTY": "ｍｓ 明朝",
          "MS_JP_P_GOTHIC": "ｍｓ ｐゴシック",
          "MS_JP_P_MING_DYNASTY": "ｍｓ ｐ明朝",
          "MEIRYO": "meiryo",
          "JP_MEIRYO": "メイリオ",
          "BM_HANNA": "bm-hanna",
          "KO_MAGPIE": "돋움",
          "FBBLUEGOTHICL": "fbbluegothicl",
          "FBCHAMBLUE": "fbchamblue",
          "FBGREEN": "fbgreen",
          "FBNEOGOTHIC": "fbneogothic",
          "FBPLUM": "fbplum",
          "KO_ROLL": "굴림",
          "KO_CLEAR_GOTHIC": "맑은 고딕",
          "NANUMGOTHIC_REGULAR": "nanumgothic-regular",
          "AHMEDLTW20_OUTLINEREGUL": "ahmedltw20-outlineregul",
          "AMIRI": "amiri",
          "ARABICTYPESETTINGW23_RE": "arabictypesettingw23-re",
          "ARIAN_LT_W20_REGULAR": "arian-lt-w20-regular",
          "ARIAN_LT_W20_LIGHT": "arian-lt-w20-light",
          "COHEADLINEW23_ARABICBOL": "coheadlinew23-arabicbol",
          "DINNEXTLTW23_ULTRALIGHT": "dinnextltw23-ultralight",
          "DROID_NASKH": "droid-naskh",
          "JANNA_LT_W20_REGULAR": "janna-lt-w20-regular",
          "KUFI_LT_W20_REGULAR": "kufi-lt-w20-regular",
          "MIDAN_W20": "midan-w20",
          "HELVETICANEUELTW20_LIGH": "helveticaneueltw20-ligh",
          "TANSEEKMODERNW20_LIGHT": "tanseekmodernw20-light",
          "ADLER_W26_REGULAR": "adler-w26-regular",
          "ALEF_REGULAR": "alef-regular",
          "ALMONI_DL_AAA_700": "almoni-dl-aaa-700",
          "ALMONI_DL_AAA_300": "almoni-dl-aaa-300",
          "ALMONI_DL_AAA_400": "almoni-dl-aaa-400",
          "ASIMON_AAA_400": "asimon-aaa-400",
          "ATLAS_AAA_500": "atlas-aaa-500",
          "CHIPS_W26_NORMAL": "chips-w26-normal",
          "FRANK_RUHL_W26_REGULAR": "frank-ruhl-w26-regular",
          "GULASH_W26_REGULAR": "gulash-w26-regular",
          "HAIM_ARUKEEM_W26_MEDIUM": "haim-arukeem-w26-medium",
          "MIRIAM_W26_MEDIUM": "miriam-w26-medium",
          "MIXTAPE_AAA_400": "mixtape-aaa-400",
          "MUSEUM_AAA_400": "museum-aaa-400",
          "NEKUDOT_W26_BOLD": "nekudot-w26-bold",
          "OMES_AAA_400": "omes-aaa-400",
          "OPENSANSHEBREWCONDENSED_REGULAR": "opensanshebrewcondensed-regular",
          "SHABAZI_W26_BOLD": "shabazi-w26-bold",
          "AMATIC_SC": "amatic sc",
          "BRAGGADOCIO_W01": "braggadocio-w01",
          "CHELSEA_MARKET": "chelsea market",
          "CORBEN": "corben",
          "FREDERICKA_THE_GREAT": "fredericka the great",
          "GEOTICA_W01_FOUR_OPEN": "geotica-w01-four-open",
          "HELVETICA_NEUE": "helvetica neue",
          "HELVETICA_NEUE_ITALIC": "helvetica neue italic",
          "HELVETICA_NEUE_MEDIUM": "helvetica neue medium",
          "HELVETICA_NEUE_THIN": "helvetica neue thin",
          "ITC_ARECIBO_W01_REGULAR": "itc-arecibo-w01-regular",
          "JOSEFIN_SLAB": "josefin slab",
          "LUCIDA_SANS_UNICODE": "lucida sans unicode",
          "MARZO_W00_REGULAR": "marzo-w00-regular",
          "MR_DE_HAVILAND": "mr de haviland",
          "MUSEO_W01_700": "museo-w01-700",
          "MUSEO_SLAB_W01_100": "museo-slab-w01-100",
          "NICONNE": "niconne",
          "NIMBUS_SANS_TW01CON": "nimbus-sans-tw01con",
          "OVERLOCK": "overlock",
          "PACIFICA_W00_CONDENSED": "pacifica-w00-condensed",
          "RALEWAY": "raleway",
          "ROSEWOOD_W01_REGULAR": "rosewood-w01-regular",
          "SNELLROUNDHANDW01_SCRIP": "snellroundhandw01-scrip",
          "SPINNAKER": "spinnaker",
          "STENCIL_W01_BOLD": "stencil-w01-bold"
        },
        "cropAndFitStage": {
          "CROP": "crop",
          "FIT": "fit"
        },
        "componentScale": {
          "_16_9": "16:9",
          "_4_3": "4:3",
          "_1_1": "1:1"
        },
        "textMode": {
          "TITLEANDDESCRIPTION": "titleAndDescription",
          "TITLEONLY": "titleOnly",
          "DESCRIPTIONONLY": "descriptionOnly",
          "NOTEXT": "noText"
        },
        "alignText": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "transition": {
          "NONE": "none",
          "CROSSFADE": "crossFade",
          "SLIDE": "slide",
          "SCROLL": "scroll",
          "ZOOM": "zoom",
          "RANDOM": "random"
        },
        "thumbnailsGravity": {
          "TOP": "top",
          "BOTTOM": "bottom",
          "LEFT": "left",
          "RIGHT": "right"
        },
        "galleryImageOnClickAction": {
          "DISABLED": "disabled",
          "ZOOMMODE": "zoomMode",
          "GOTOLINK": "goToLink"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AccordionProperties": {
      "enums": {
        "font": {
          "LUCIDASANSCONSOLE": "lucidaSansConsole",
          "PALATINOLINOTYPE": "palatinoLinotype",
          "AMERICANTYPWRTERITCW01__731025": "americantypwrteritcw01--731025",
          "ANTON": "anton",
          "ARIAL": "arial",
          "ARIALBLACK": "arialBlack",
          "AVENIDA_W01": "avenida-w01",
          "BASIC": "basic",
          "CAUDEX": "caudex",
          "CLARENDON_W01_MEDIUM_692107": "clarendon-w01-medium-692107",
          "COMICSANSMS": "comicSansMS",
          "COOKIE": "cookie",
          "COQUETTE_W00_LIGHT": "coquette-w00-light",
          "COURIERNEW": "courierNew",
          "DIN_NEXT_W01_LIGHT": "din-next-w01-light",
          "DROID_SERIF_W01_REGULAR": "droid-serif-w01-regular",
          "EB_GARAMOND": "eb garamond",
          "ENRIQUETA": "enriqueta",
          "FORUM": "forum",
          "GEORGIA": "georgia",
          "HELVETICA_W01_ROMAN": "helvetica-w01-roman",
          "HELVETICA_W01_BOLD": "helvetica-w01-bold",
          "HELVETICA_W01_LIGHT": "helvetica-w01-light",
          "IMPACT": "impact",
          "JOCKEY_ONE": "jockey one",
          "JURA": "jura",
          "KELLY_SLAB": "kelly slab",
          "LOBSTER": "lobster",
          "LUCIDACONSOLE": "lucidaConsole",
          "MARCK_SCRIPT": "marck script",
          "MONOTON": "monoton",
          "NOTICIA_TEXT": "noticia text",
          "OPEN_SANS": "open sans",
          "OPEN_SANS_CONDENSED": "open sans condensed",
          "PALATINO_LINOTYPE": "palatino linotype",
          "PATRICK_HAND": "patrick hand",
          "PLAY": "play",
          "REKLAMESCRIPTW00_MEDIUM": "reklamescriptw00-medium",
          "SACRAMENTO": "sacramento",
          "SARINA": "sarina",
          "SIGNIKA": "signika",
          "SOHO_W01_THIN_CONDENSED": "soho-w01-thin-condensed",
          "TAHOMA": "tahoma",
          "TIMESNEWROMAN": "timesNewRoman",
          "VERDANA": "verdana",
          "BODONI_W01_POSTER": "bodoni-w01-poster",
          "MS_JP_GOTHIC": "ｍｓ ゴシック",
          "MS_JP_MING_DYNASTY": "ｍｓ 明朝",
          "MS_JP_P_GOTHIC": "ｍｓ ｐゴシック",
          "MS_JP_P_MING_DYNASTY": "ｍｓ ｐ明朝",
          "MEIRYO": "meiryo",
          "JP_MEIRYO": "メイリオ",
          "BM_HANNA": "bm-hanna",
          "KO_MAGPIE": "돋움",
          "FBBLUEGOTHICL": "fbbluegothicl",
          "FBCHAMBLUE": "fbchamblue",
          "FBGREEN": "fbgreen",
          "FBNEOGOTHIC": "fbneogothic",
          "FBPLUM": "fbplum",
          "KO_ROLL": "굴림",
          "KO_CLEAR_GOTHIC": "맑은 고딕",
          "NANUMGOTHIC_REGULAR": "nanumgothic-regular",
          "AHMEDLTW20_OUTLINEREGUL": "ahmedltw20-outlineregul",
          "AMIRI": "amiri",
          "ARABICTYPESETTINGW23_RE": "arabictypesettingw23-re",
          "ARIAN_LT_W20_REGULAR": "arian-lt-w20-regular",
          "ARIAN_LT_W20_LIGHT": "arian-lt-w20-light",
          "COHEADLINEW23_ARABICBOL": "coheadlinew23-arabicbol",
          "DINNEXTLTW23_ULTRALIGHT": "dinnextltw23-ultralight",
          "DROID_NASKH": "droid-naskh",
          "JANNA_LT_W20_REGULAR": "janna-lt-w20-regular",
          "KUFI_LT_W20_REGULAR": "kufi-lt-w20-regular",
          "MIDAN_W20": "midan-w20",
          "HELVETICANEUELTW20_LIGH": "helveticaneueltw20-ligh",
          "TANSEEKMODERNW20_LIGHT": "tanseekmodernw20-light",
          "ADLER_W26_REGULAR": "adler-w26-regular",
          "ALEF_REGULAR": "alef-regular",
          "ALMONI_DL_AAA_700": "almoni-dl-aaa-700",
          "ALMONI_DL_AAA_300": "almoni-dl-aaa-300",
          "ALMONI_DL_AAA_400": "almoni-dl-aaa-400",
          "ASIMON_AAA_400": "asimon-aaa-400",
          "ATLAS_AAA_500": "atlas-aaa-500",
          "CHIPS_W26_NORMAL": "chips-w26-normal",
          "FRANK_RUHL_W26_REGULAR": "frank-ruhl-w26-regular",
          "GULASH_W26_REGULAR": "gulash-w26-regular",
          "HAIM_ARUKEEM_W26_MEDIUM": "haim-arukeem-w26-medium",
          "MIRIAM_W26_MEDIUM": "miriam-w26-medium",
          "MIXTAPE_AAA_400": "mixtape-aaa-400",
          "MUSEUM_AAA_400": "museum-aaa-400",
          "NEKUDOT_W26_BOLD": "nekudot-w26-bold",
          "OMES_AAA_400": "omes-aaa-400",
          "OPENSANSHEBREWCONDENSED_REGULAR": "opensanshebrewcondensed-regular",
          "SHABAZI_W26_BOLD": "shabazi-w26-bold",
          "AMATIC_SC": "amatic sc",
          "BRAGGADOCIO_W01": "braggadocio-w01",
          "CHELSEA_MARKET": "chelsea market",
          "CORBEN": "corben",
          "FREDERICKA_THE_GREAT": "fredericka the great",
          "GEOTICA_W01_FOUR_OPEN": "geotica-w01-four-open",
          "HELVETICA_NEUE": "helvetica neue",
          "HELVETICA_NEUE_ITALIC": "helvetica neue italic",
          "HELVETICA_NEUE_MEDIUM": "helvetica neue medium",
          "HELVETICA_NEUE_THIN": "helvetica neue thin",
          "ITC_ARECIBO_W01_REGULAR": "itc-arecibo-w01-regular",
          "JOSEFIN_SLAB": "josefin slab",
          "LUCIDA_SANS_UNICODE": "lucida sans unicode",
          "MARZO_W00_REGULAR": "marzo-w00-regular",
          "MR_DE_HAVILAND": "mr de haviland",
          "MUSEO_W01_700": "museo-w01-700",
          "MUSEO_SLAB_W01_100": "museo-slab-w01-100",
          "NICONNE": "niconne",
          "NIMBUS_SANS_TW01CON": "nimbus-sans-tw01con",
          "OVERLOCK": "overlock",
          "PACIFICA_W00_CONDENSED": "pacifica-w00-condensed",
          "RALEWAY": "raleway",
          "ROSEWOOD_W01_REGULAR": "rosewood-w01-regular",
          "SNELLROUNDHANDW01_SCRIP": "snellroundhandw01-scrip",
          "SPINNAKER": "spinnaker",
          "STENCIL_W01_BOLD": "stencil-w01-bold"
        },
        "descFont": {
          "LUCIDASANSCONSOLE": "lucidaSansConsole",
          "PALATINOLINOTYPE": "palatinoLinotype",
          "AMERICANTYPWRTERITCW01__731025": "americantypwrteritcw01--731025",
          "ANTON": "anton",
          "ARIAL": "arial",
          "ARIALBLACK": "arialBlack",
          "AVENIDA_W01": "avenida-w01",
          "BASIC": "basic",
          "CAUDEX": "caudex",
          "CLARENDON_W01_MEDIUM_692107": "clarendon-w01-medium-692107",
          "COMICSANSMS": "comicSansMS",
          "COOKIE": "cookie",
          "COQUETTE_W00_LIGHT": "coquette-w00-light",
          "COURIERNEW": "courierNew",
          "DIN_NEXT_W01_LIGHT": "din-next-w01-light",
          "DROID_SERIF_W01_REGULAR": "droid-serif-w01-regular",
          "EB_GARAMOND": "eb garamond",
          "ENRIQUETA": "enriqueta",
          "FORUM": "forum",
          "GEORGIA": "georgia",
          "HELVETICA_W01_ROMAN": "helvetica-w01-roman",
          "HELVETICA_W01_BOLD": "helvetica-w01-bold",
          "HELVETICA_W01_LIGHT": "helvetica-w01-light",
          "IMPACT": "impact",
          "JOCKEY_ONE": "jockey one",
          "JURA": "jura",
          "KELLY_SLAB": "kelly slab",
          "LOBSTER": "lobster",
          "LUCIDACONSOLE": "lucidaConsole",
          "MARCK_SCRIPT": "marck script",
          "MONOTON": "monoton",
          "NOTICIA_TEXT": "noticia text",
          "OPEN_SANS": "open sans",
          "OPEN_SANS_CONDENSED": "open sans condensed",
          "PALATINO_LINOTYPE": "palatino linotype",
          "PATRICK_HAND": "patrick hand",
          "PLAY": "play",
          "REKLAMESCRIPTW00_MEDIUM": "reklamescriptw00-medium",
          "SACRAMENTO": "sacramento",
          "SARINA": "sarina",
          "SIGNIKA": "signika",
          "SOHO_W01_THIN_CONDENSED": "soho-w01-thin-condensed",
          "TAHOMA": "tahoma",
          "TIMESNEWROMAN": "timesNewRoman",
          "VERDANA": "verdana",
          "BODONI_W01_POSTER": "bodoni-w01-poster",
          "MS_JP_GOTHIC": "ｍｓ ゴシック",
          "MS_JP_MING_DYNASTY": "ｍｓ 明朝",
          "MS_JP_P_GOTHIC": "ｍｓ ｐゴシック",
          "MS_JP_P_MING_DYNASTY": "ｍｓ ｐ明朝",
          "MEIRYO": "meiryo",
          "JP_MEIRYO": "メイリオ",
          "BM_HANNA": "bm-hanna",
          "KO_MAGPIE": "돋움",
          "FBBLUEGOTHICL": "fbbluegothicl",
          "FBCHAMBLUE": "fbchamblue",
          "FBGREEN": "fbgreen",
          "FBNEOGOTHIC": "fbneogothic",
          "FBPLUM": "fbplum",
          "KO_ROLL": "굴림",
          "KO_CLEAR_GOTHIC": "맑은 고딕",
          "NANUMGOTHIC_REGULAR": "nanumgothic-regular",
          "AHMEDLTW20_OUTLINEREGUL": "ahmedltw20-outlineregul",
          "AMIRI": "amiri",
          "ARABICTYPESETTINGW23_RE": "arabictypesettingw23-re",
          "ARIAN_LT_W20_REGULAR": "arian-lt-w20-regular",
          "ARIAN_LT_W20_LIGHT": "arian-lt-w20-light",
          "COHEADLINEW23_ARABICBOL": "coheadlinew23-arabicbol",
          "DINNEXTLTW23_ULTRALIGHT": "dinnextltw23-ultralight",
          "DROID_NASKH": "droid-naskh",
          "JANNA_LT_W20_REGULAR": "janna-lt-w20-regular",
          "KUFI_LT_W20_REGULAR": "kufi-lt-w20-regular",
          "MIDAN_W20": "midan-w20",
          "HELVETICANEUELTW20_LIGH": "helveticaneueltw20-ligh",
          "TANSEEKMODERNW20_LIGHT": "tanseekmodernw20-light",
          "ADLER_W26_REGULAR": "adler-w26-regular",
          "ALEF_REGULAR": "alef-regular",
          "ALMONI_DL_AAA_700": "almoni-dl-aaa-700",
          "ALMONI_DL_AAA_300": "almoni-dl-aaa-300",
          "ALMONI_DL_AAA_400": "almoni-dl-aaa-400",
          "ASIMON_AAA_400": "asimon-aaa-400",
          "ATLAS_AAA_500": "atlas-aaa-500",
          "CHIPS_W26_NORMAL": "chips-w26-normal",
          "FRANK_RUHL_W26_REGULAR": "frank-ruhl-w26-regular",
          "GULASH_W26_REGULAR": "gulash-w26-regular",
          "HAIM_ARUKEEM_W26_MEDIUM": "haim-arukeem-w26-medium",
          "MIRIAM_W26_MEDIUM": "miriam-w26-medium",
          "MIXTAPE_AAA_400": "mixtape-aaa-400",
          "MUSEUM_AAA_400": "museum-aaa-400",
          "NEKUDOT_W26_BOLD": "nekudot-w26-bold",
          "OMES_AAA_400": "omes-aaa-400",
          "OPENSANSHEBREWCONDENSED_REGULAR": "opensanshebrewcondensed-regular",
          "SHABAZI_W26_BOLD": "shabazi-w26-bold",
          "AMATIC_SC": "amatic sc",
          "BRAGGADOCIO_W01": "braggadocio-w01",
          "CHELSEA_MARKET": "chelsea market",
          "CORBEN": "corben",
          "FREDERICKA_THE_GREAT": "fredericka the great",
          "GEOTICA_W01_FOUR_OPEN": "geotica-w01-four-open",
          "HELVETICA_NEUE": "helvetica neue",
          "HELVETICA_NEUE_ITALIC": "helvetica neue italic",
          "HELVETICA_NEUE_MEDIUM": "helvetica neue medium",
          "HELVETICA_NEUE_THIN": "helvetica neue thin",
          "ITC_ARECIBO_W01_REGULAR": "itc-arecibo-w01-regular",
          "JOSEFIN_SLAB": "josefin slab",
          "LUCIDA_SANS_UNICODE": "lucida sans unicode",
          "MARZO_W00_REGULAR": "marzo-w00-regular",
          "MR_DE_HAVILAND": "mr de haviland",
          "MUSEO_W01_700": "museo-w01-700",
          "MUSEO_SLAB_W01_100": "museo-slab-w01-100",
          "NICONNE": "niconne",
          "NIMBUS_SANS_TW01CON": "nimbus-sans-tw01con",
          "OVERLOCK": "overlock",
          "PACIFICA_W00_CONDENSED": "pacifica-w00-condensed",
          "RALEWAY": "raleway",
          "ROSEWOOD_W01_REGULAR": "rosewood-w01-regular",
          "SNELLROUNDHANDW01_SCRIP": "snellroundhandw01-scrip",
          "SPINNAKER": "spinnaker",
          "STENCIL_W01_BOLD": "stencil-w01-bold"
        },
        "alignText": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "textMode": {
          "TITLEONLY": "titleOnly",
          "NOTEXT": "noText"
        },
        "galleryImageOnClickAction": {
          "DISABLED": "disabled",
          "ZOOMMODE": "zoomMode",
          "GOTOLINK": "goToLink"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "CollageProperties": {
      "enums": {
        "font": {
          "LUCIDASANSCONSOLE": "lucidaSansConsole",
          "PALATINOLINOTYPE": "palatinoLinotype",
          "AMERICANTYPWRTERITCW01__731025": "americantypwrteritcw01--731025",
          "ANTON": "anton",
          "ARIAL": "arial",
          "ARIALBLACK": "arialBlack",
          "AVENIDA_W01": "avenida-w01",
          "BASIC": "basic",
          "CAUDEX": "caudex",
          "CLARENDON_W01_MEDIUM_692107": "clarendon-w01-medium-692107",
          "COMICSANSMS": "comicSansMS",
          "COOKIE": "cookie",
          "COQUETTE_W00_LIGHT": "coquette-w00-light",
          "COURIERNEW": "courierNew",
          "DIN_NEXT_W01_LIGHT": "din-next-w01-light",
          "DROID_SERIF_W01_REGULAR": "droid-serif-w01-regular",
          "EB_GARAMOND": "eb garamond",
          "ENRIQUETA": "enriqueta",
          "FORUM": "forum",
          "GEORGIA": "georgia",
          "HELVETICA_W01_ROMAN": "helvetica-w01-roman",
          "HELVETICA_W01_BOLD": "helvetica-w01-bold",
          "HELVETICA_W01_LIGHT": "helvetica-w01-light",
          "IMPACT": "impact",
          "JOCKEY_ONE": "jockey one",
          "JURA": "jura",
          "KELLY_SLAB": "kelly slab",
          "LOBSTER": "lobster",
          "LUCIDACONSOLE": "lucidaConsole",
          "MARCK_SCRIPT": "marck script",
          "MONOTON": "monoton",
          "NOTICIA_TEXT": "noticia text",
          "OPEN_SANS": "open sans",
          "OPEN_SANS_CONDENSED": "open sans condensed",
          "PALATINO_LINOTYPE": "palatino linotype",
          "PATRICK_HAND": "patrick hand",
          "PLAY": "play",
          "REKLAMESCRIPTW00_MEDIUM": "reklamescriptw00-medium",
          "SACRAMENTO": "sacramento",
          "SARINA": "sarina",
          "SIGNIKA": "signika",
          "SOHO_W01_THIN_CONDENSED": "soho-w01-thin-condensed",
          "TAHOMA": "tahoma",
          "TIMESNEWROMAN": "timesNewRoman",
          "VERDANA": "verdana",
          "BODONI_W01_POSTER": "bodoni-w01-poster",
          "MS_JP_GOTHIC": "ｍｓ ゴシック",
          "MS_JP_MING_DYNASTY": "ｍｓ 明朝",
          "MS_JP_P_GOTHIC": "ｍｓ ｐゴシック",
          "MS_JP_P_MING_DYNASTY": "ｍｓ ｐ明朝",
          "MEIRYO": "meiryo",
          "JP_MEIRYO": "メイリオ",
          "BM_HANNA": "bm-hanna",
          "KO_MAGPIE": "돋움",
          "FBBLUEGOTHICL": "fbbluegothicl",
          "FBCHAMBLUE": "fbchamblue",
          "FBGREEN": "fbgreen",
          "FBNEOGOTHIC": "fbneogothic",
          "FBPLUM": "fbplum",
          "KO_ROLL": "굴림",
          "KO_CLEAR_GOTHIC": "맑은 고딕",
          "NANUMGOTHIC_REGULAR": "nanumgothic-regular",
          "AHMEDLTW20_OUTLINEREGUL": "ahmedltw20-outlineregul",
          "AMIRI": "amiri",
          "ARABICTYPESETTINGW23_RE": "arabictypesettingw23-re",
          "ARIAN_LT_W20_REGULAR": "arian-lt-w20-regular",
          "ARIAN_LT_W20_LIGHT": "arian-lt-w20-light",
          "COHEADLINEW23_ARABICBOL": "coheadlinew23-arabicbol",
          "DINNEXTLTW23_ULTRALIGHT": "dinnextltw23-ultralight",
          "DROID_NASKH": "droid-naskh",
          "JANNA_LT_W20_REGULAR": "janna-lt-w20-regular",
          "KUFI_LT_W20_REGULAR": "kufi-lt-w20-regular",
          "MIDAN_W20": "midan-w20",
          "HELVETICANEUELTW20_LIGH": "helveticaneueltw20-ligh",
          "TANSEEKMODERNW20_LIGHT": "tanseekmodernw20-light",
          "ADLER_W26_REGULAR": "adler-w26-regular",
          "ALEF_REGULAR": "alef-regular",
          "ALMONI_DL_AAA_700": "almoni-dl-aaa-700",
          "ALMONI_DL_AAA_300": "almoni-dl-aaa-300",
          "ALMONI_DL_AAA_400": "almoni-dl-aaa-400",
          "ASIMON_AAA_400": "asimon-aaa-400",
          "ATLAS_AAA_500": "atlas-aaa-500",
          "CHIPS_W26_NORMAL": "chips-w26-normal",
          "FRANK_RUHL_W26_REGULAR": "frank-ruhl-w26-regular",
          "GULASH_W26_REGULAR": "gulash-w26-regular",
          "HAIM_ARUKEEM_W26_MEDIUM": "haim-arukeem-w26-medium",
          "MIRIAM_W26_MEDIUM": "miriam-w26-medium",
          "MIXTAPE_AAA_400": "mixtape-aaa-400",
          "MUSEUM_AAA_400": "museum-aaa-400",
          "NEKUDOT_W26_BOLD": "nekudot-w26-bold",
          "OMES_AAA_400": "omes-aaa-400",
          "OPENSANSHEBREWCONDENSED_REGULAR": "opensanshebrewcondensed-regular",
          "SHABAZI_W26_BOLD": "shabazi-w26-bold",
          "AMATIC_SC": "amatic sc",
          "BRAGGADOCIO_W01": "braggadocio-w01",
          "CHELSEA_MARKET": "chelsea market",
          "CORBEN": "corben",
          "FREDERICKA_THE_GREAT": "fredericka the great",
          "GEOTICA_W01_FOUR_OPEN": "geotica-w01-four-open",
          "HELVETICA_NEUE": "helvetica neue",
          "HELVETICA_NEUE_ITALIC": "helvetica neue italic",
          "HELVETICA_NEUE_MEDIUM": "helvetica neue medium",
          "HELVETICA_NEUE_THIN": "helvetica neue thin",
          "ITC_ARECIBO_W01_REGULAR": "itc-arecibo-w01-regular",
          "JOSEFIN_SLAB": "josefin slab",
          "LUCIDA_SANS_UNICODE": "lucida sans unicode",
          "MARZO_W00_REGULAR": "marzo-w00-regular",
          "MR_DE_HAVILAND": "mr de haviland",
          "MUSEO_W01_700": "museo-w01-700",
          "MUSEO_SLAB_W01_100": "museo-slab-w01-100",
          "NICONNE": "niconne",
          "NIMBUS_SANS_TW01CON": "nimbus-sans-tw01con",
          "OVERLOCK": "overlock",
          "PACIFICA_W00_CONDENSED": "pacifica-w00-condensed",
          "RALEWAY": "raleway",
          "ROSEWOOD_W01_REGULAR": "rosewood-w01-regular",
          "SNELLROUNDHANDW01_SCRIP": "snellroundhandw01-scrip",
          "SPINNAKER": "spinnaker",
          "STENCIL_W01_BOLD": "stencil-w01-bold"
        },
        "alignText": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "textMode": {
          "TITLEANDDESCRIPTION": "titleAndDescription",
          "TITLEONLY": "titleOnly",
          "NOTEXT": "noText"
        },
        "galleryImageOnClickAction": {
          "DISABLED": "disabled",
          "ZOOMMODE": "zoomMode",
          "GOTOLINK": "goToLink"
        },
        "orientation": {
          "VERTICAL": "vertical",
          "HORIZONTAL": "horizontal"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FreestyleProperties": {
      "enums": {
        "galleryImageOnClickAction": {
          "DISABLED": "disabled",
          "ZOOMMODE": "zoomMode",
          "GOTOLINK": "goToLink"
        },
        "cropAndFitStage": {
          "CROP": "crop",
          "FIT": "fit"
        },
        "imageDecoration": {
          "NONE": "none",
          "POLAROID": "polaroid",
          "SCOTCHTAPE": "scotchTape",
          "VINTAGEFRAME": "vintageFrame",
          "RANDOM": "random"
        },
        "orientation": {
          "VERTICAL": "vertical",
          "HORIZONTAL": "horizontal"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ItunesButtonProperties": {
      "enums": {
        "language": {
          "USERLANG": "userLang",
          "DA": "da",
          "DE": "de",
          "EN": "en",
          "ES": "es",
          "FR": "fr",
          "IT": "it",
          "JP": "jp",
          "KO": "ko",
          "NL": "nl",
          "NO": "no",
          "PL": "pl",
          "PT": "pt",
          "RU": "ru",
          "SV": "sv",
          "TR": "tr"
        },
        "openIn": {
          "_SELF": "_self",
          "_BLANK": "_blank"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LayoutProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkBarProperties": {
      "enums": {
        "orientation": {
          "HORIZ": "HORIZ",
          "VERT": "VERT"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MatrixGalleryProperties": {
      "enums": {
        "imageMode": {
          "CLIPIMAGE": "clipImage",
          "FLEXIBLEWIDTHFIXED": "flexibleWidthFixed"
        },
        "alignText": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "galleryImageOnClickAction": {
          "DISABLED": "disabled",
          "ZOOMMODE": "zoomMode",
          "GOTOLINK": "goToLink"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [
        "itemHeight"
      ],
      "convertToString": []
    },
    "NumberInputProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PageGroupProperties": {
      "enums": {
        "transition": {
          "NONE": "none",
          "SWIPEHORIZONTALFULLSCREEN": "swipeHorizontalFullScreen",
          "SWIPEVERTICALFULLSCREEN": "swipeVerticalFullScreen",
          "CROSSFADE": "crossfade",
          "OUTIN": "outIn",
          "SLIDE": "slide"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PaginatedGridGalleryProperties": {
      "enums": {
        "imageMode": {
          "CLIPIMAGE": "clipImage"
        },
        "transition": {
          "NONE": "none",
          "SEQ_CROSSFADE_ALL": "seq_crossFade_All",
          "SEQ_SHRINK_ALL": "seq_shrink_All",
          "SWIPE_HORIZ_ALL": "swipe_horiz_All",
          "SWIPE_VERT_ALL": "swipe_vert_All",
          "SEQ_RANDOM": "seq_random"
        },
        "galleryImageOnClickAction": {
          "DISABLED": "disabled",
          "ZOOMMODE": "zoomMode",
          "GOTOLINK": "goToLink"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PayPalButtonProperties": {
      "enums": {
        "buttonType": {
          "BUY": "buy",
          "DONATE": "donate"
        },
        "target": {
          "_SELF": "_self",
          "_BLANK": "_blank"
        },
        "language": {
          "USERLANG": "userLang",
          "DA": "da",
          "DE": "de",
          "EN": "en",
          "ES": "es",
          "FR": "fr",
          "IT": "it",
          "JA": "ja",
          "NL": "nl",
          "NO": "no",
          "PL": "pl",
          "PT": "pt",
          "RU": "ru",
          "SV": "sv",
          "TR": "tr"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SiteSegmentContainerProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SliderGalleryProperties": {
      "enums": {
        "imageMode": {
          "CLIPIMAGE": "clipImage",
          "FLEXIBLEWIDTH": "flexibleWidth"
        },
        "aspectRatioPreset": {
          "_16_9": "16:9",
          "_4_3": "4:3",
          "_1_1": "1:1",
          "_3_4": "3:4",
          "_9_16": "9:16"
        },
        "galleryImageOnClickAction": {
          "DISABLED": "disabled",
          "ZOOMMODE": "zoomMode",
          "GOTOLINK": "goToLink"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SlideShowGalleryProperties": {
      "enums": {
        "imageMode": {
          "CLIPIMAGE": "clipImage",
          "FLEXIBLEHEIGHT": "flexibleHeight",
          "FLEXIBLEWIDTHFIXED": "flexibleWidthFixed"
        },
        "transition": {
          "NONE": "none",
          "SWIPEVERTICAL": "swipeVertical",
          "SWIPEHORIZONTAL": "swipeHorizontal",
          "CROSSFADE": "crossfade",
          "OUTIN": "outIn"
        },
        "galleryImageOnClickAction": {
          "DISABLED": "disabled",
          "ZOOMMODE": "zoomMode",
          "GOTOLINK": "goToLink"
        },
        "alignText": {
          "LEFT": "left",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SvgShapeProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VectorImageProperties": {
      "enums": {
        "displayMode": {
          "LEGACYFIT": "legacyFit",
          "FIT": "fit",
          "STRETCH": "stretch"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        },
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "HORIZONTAL": "horizontal",
          "VERTICAL": "vertical",
          "BOTH": "both",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TableComponentProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TinyMenuProperties": {
      "enums": {
        "direction": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ExpandableMenuProperties": {
      "enums": {
        "itemsAlignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "subMenuOpenSide": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "menuArrowDirection": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TwitterFeedProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VideoProperties": {
      "enums": {
        "showControls": {
          "ALWAYS_SHOW": "always_show",
          "ALWAYS_HIDE": "always_hide",
          "TEMP_SHOW": "temp_show"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VKShareProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WFacebookCommentProperties": {
      "enums": {
        "colorScheme": {
          "LIGHT": "light",
          "DARK": "dark"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "DisqusCommentsProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WFacebookLikeProperties": {
      "enums": {
        "layout": {
          "STANDARD": "standard",
          "BUTTON_COUNT": "button_count",
          "BOX_COUNT": "box_count"
        },
        "action": {
          "LIKE": "like",
          "RECOMMEND": "recommend"
        },
        "font": {
          "HELVETICA": "helvetica",
          "ARIAL": "arial",
          "LUCIDA_GRANDE": "lucida grande",
          "SEGOE_UI": "segoe ui",
          "TAHOMA": "tahoma",
          "TREBUCHET_MS": "trebuchet ms",
          "VERDANA": "verdana"
        },
        "colorScheme": {
          "LIGHT": "light",
          "DARK": "dark"
        },
        "language": {
          "USERLANG": "userLang",
          "DA": "da",
          "DE": "de",
          "EN": "en",
          "ES": "es",
          "FR": "fr",
          "IT": "it",
          "JA": "ja",
          "KR": "kr",
          "NL": "nl",
          "NO": "no",
          "PL": "pl",
          "PT": "pt",
          "RU": "ru",
          "SV": "sv",
          "TR": "tr"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WGooglePlusOneProperties": {
      "enums": {
        "size": {
          "SMALL": "small",
          "MEDIUM": "medium",
          "STANDARD": "standard",
          "TALL": "tall"
        },
        "annotation": {
          "NONE": "none",
          "BUBBLE": "bubble",
          "INLINE": "inline"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WPhotoProperties": {
      "enums": {
        "displayMode": {
          "FIT": "fit",
          "FILL": "fill",
          "FULL": "full",
          "STRETCH": "stretch",
          "FITWIDTH": "fitWidth",
          "FITWIDTHSTRICT": "fitWidthStrict",
          "FITHEIGHTSTRICT": "fitHeightStrict"
        },
        "onClickBehavior": {
          "DISABLED": "disabled",
          "GOTOLINK": "goToLink",
          "ZOOMMODE": "zoomMode",
          "ZOOMANDPANMODE": "zoomAndPanMode"
        },
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "HORIZONTAL": "horizontal",
          "VERTICAL": "vertical",
          "BOTH": "both",
          "NONE": "none"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WRichTextProperties": {
      "enums": {
        "overrideAlignment": {
          "LEFT": "left",
          "RIGHT": "right",
          "CENTER": "center",
          "JUSTIFY": "justify"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [
        "minHeight",
        "minWidth"
      ],
      "convertToString": []
    },
    "RefComponentProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WTwitterFollowProperties": {
      "enums": {
        "dataLang": {
          "USERLANG": "userLang",
          "DA": "da",
          "DE": "de",
          "EN": "en",
          "ES": "es",
          "FR": "fr",
          "HI": "hi",
          "IT": "it",
          "JA": "ja",
          "KO": "ko",
          "NL": "nl",
          "NO": "no",
          "PL": "pl",
          "PT": "pt",
          "RU": "ru",
          "SV": "sv",
          "TR": "tr"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WTwitterTweetProperties": {
      "enums": {
        "dataCount": {
          "NONE": "none",
          "HORIZONTAL": "horizontal",
          "VERTICAL": "vertical"
        },
        "dataLang": {
          "USERLANG": "userLang",
          "DA": "da",
          "DE": "de",
          "EN": "en",
          "ES": "es",
          "FR": "fr",
          "HI": "hi",
          "IT": "it",
          "JA": "ja",
          "KO": "ko",
          "NL": "nl",
          "NO": "no",
          "PL": "pl",
          "PT": "pt",
          "RU": "ru",
          "SV": "sv",
          "TR": "tr"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "HoverBoxProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TPAGluedProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": [
        "verticalMargin",
        "horizontalMargin"
      ]
    },
    "HoneycombProperties": {
      "enums": {
        "font": {
          "LUCIDASANSCONSOLE": "lucidaSansConsole",
          "PALATINOLINOTYPE": "palatinoLinotype",
          "AMERICANTYPWRTERITCW01__731025": "americantypwrteritcw01--731025",
          "ANTON": "anton",
          "ARIAL": "arial",
          "ARIALBLACK": "arialBlack",
          "AVENIDA_W01": "avenida-w01",
          "BASIC": "basic",
          "CAUDEX": "caudex",
          "CLARENDON_W01_MEDIUM_692107": "clarendon-w01-medium-692107",
          "COMICSANSMS": "comicSansMS",
          "COOKIE": "cookie",
          "COQUETTE_W00_LIGHT": "coquette-w00-light",
          "COURIERNEW": "courierNew",
          "DIN_NEXT_W01_LIGHT": "din-next-w01-light",
          "DROID_SERIF_W01_REGULAR": "droid-serif-w01-regular",
          "EB_GARAMOND": "eb garamond",
          "ENRIQUETA": "enriqueta",
          "FORUM": "forum",
          "GEORGIA": "georgia",
          "HELVETICA_W01_ROMAN": "helvetica-w01-roman",
          "HELVETICA_W01_BOLD": "helvetica-w01-bold",
          "HELVETICA_W01_LIGHT": "helvetica-w01-light",
          "IMPACT": "impact",
          "JOCKEY_ONE": "jockey one",
          "JURA": "jura",
          "KELLY_SLAB": "kelly slab",
          "LOBSTER": "lobster",
          "LUCIDACONSOLE": "lucidaConsole",
          "MARCK_SCRIPT": "marck script",
          "MONOTON": "monoton",
          "NOTICIA_TEXT": "noticia text",
          "OPEN_SANS": "open sans",
          "OPEN_SANS_CONDENSED": "open sans condensed",
          "PALATINO_LINOTYPE": "palatino linotype",
          "PATRICK_HAND": "patrick hand",
          "PLAY": "play",
          "REKLAMESCRIPTW00_MEDIUM": "reklamescriptw00-medium",
          "SACRAMENTO": "sacramento",
          "SARINA": "sarina",
          "SIGNIKA": "signika",
          "SOHO_W01_THIN_CONDENSED": "soho-w01-thin-condensed",
          "TAHOMA": "tahoma",
          "TIMESNEWROMAN": "timesNewRoman",
          "VERDANA": "verdana",
          "BODONI_W01_POSTER": "bodoni-w01-poster",
          "MS_JP_GOTHIC": "ｍｓ ゴシック",
          "MS_JP_MING_DYNASTY": "ｍｓ 明朝",
          "MS_JP_P_GOTHIC": "ｍｓ ｐゴシック",
          "MS_JP_P_MING_DYNASTY": "ｍｓ ｐ明朝",
          "MEIRYO": "meiryo",
          "JP_MEIRYO": "メイリオ",
          "BM_HANNA": "bm-hanna",
          "KO_MAGPIE": "돋움",
          "FBBLUEGOTHICL": "fbbluegothicl",
          "FBCHAMBLUE": "fbchamblue",
          "FBGREEN": "fbgreen",
          "FBNEOGOTHIC": "fbneogothic",
          "FBPLUM": "fbplum",
          "KO_ROLL": "굴림",
          "KO_CLEAR_GOTHIC": "맑은 고딕",
          "NANUMGOTHIC_REGULAR": "nanumgothic-regular",
          "AHMEDLTW20_OUTLINEREGUL": "ahmedltw20-outlineregul",
          "AMIRI": "amiri",
          "ARABICTYPESETTINGW23_RE": "arabictypesettingw23-re",
          "ARIAN_LT_W20_REGULAR": "arian-lt-w20-regular",
          "ARIAN_LT_W20_LIGHT": "arian-lt-w20-light",
          "COHEADLINEW23_ARABICBOL": "coheadlinew23-arabicbol",
          "DINNEXTLTW23_ULTRALIGHT": "dinnextltw23-ultralight",
          "DROID_NASKH": "droid-naskh",
          "JANNA_LT_W20_REGULAR": "janna-lt-w20-regular",
          "KUFI_LT_W20_REGULAR": "kufi-lt-w20-regular",
          "MIDAN_W20": "midan-w20",
          "HELVETICANEUELTW20_LIGH": "helveticaneueltw20-ligh",
          "TANSEEKMODERNW20_LIGHT": "tanseekmodernw20-light",
          "ADLER_W26_REGULAR": "adler-w26-regular",
          "ALEF_REGULAR": "alef-regular",
          "ALMONI_DL_AAA_700": "almoni-dl-aaa-700",
          "ALMONI_DL_AAA_300": "almoni-dl-aaa-300",
          "ALMONI_DL_AAA_400": "almoni-dl-aaa-400",
          "ASIMON_AAA_400": "asimon-aaa-400",
          "ATLAS_AAA_500": "atlas-aaa-500",
          "CHIPS_W26_NORMAL": "chips-w26-normal",
          "FRANK_RUHL_W26_REGULAR": "frank-ruhl-w26-regular",
          "GULASH_W26_REGULAR": "gulash-w26-regular",
          "HAIM_ARUKEEM_W26_MEDIUM": "haim-arukeem-w26-medium",
          "MIRIAM_W26_MEDIUM": "miriam-w26-medium",
          "MIXTAPE_AAA_400": "mixtape-aaa-400",
          "MUSEUM_AAA_400": "museum-aaa-400",
          "NEKUDOT_W26_BOLD": "nekudot-w26-bold",
          "OMES_AAA_400": "omes-aaa-400",
          "OPENSANSHEBREWCONDENSED_REGULAR": "opensanshebrewcondensed-regular",
          "SHABAZI_W26_BOLD": "shabazi-w26-bold",
          "AMATIC_SC": "amatic sc",
          "BRAGGADOCIO_W01": "braggadocio-w01",
          "CHELSEA_MARKET": "chelsea market",
          "CORBEN": "corben",
          "FREDERICKA_THE_GREAT": "fredericka the great",
          "GEOTICA_W01_FOUR_OPEN": "geotica-w01-four-open",
          "HELVETICA_NEUE": "helvetica neue",
          "HELVETICA_NEUE_ITALIC": "helvetica neue italic",
          "HELVETICA_NEUE_MEDIUM": "helvetica neue medium",
          "HELVETICA_NEUE_THIN": "helvetica neue thin",
          "ITC_ARECIBO_W01_REGULAR": "itc-arecibo-w01-regular",
          "JOSEFIN_SLAB": "josefin slab",
          "LUCIDA_SANS_UNICODE": "lucida sans unicode",
          "MARZO_W00_REGULAR": "marzo-w00-regular",
          "MR_DE_HAVILAND": "mr de haviland",
          "MUSEO_W01_700": "museo-w01-700",
          "MUSEO_SLAB_W01_100": "museo-slab-w01-100",
          "NICONNE": "niconne",
          "NIMBUS_SANS_TW01CON": "nimbus-sans-tw01con",
          "OVERLOCK": "overlock",
          "PACIFICA_W00_CONDENSED": "pacifica-w00-condensed",
          "RALEWAY": "raleway",
          "ROSEWOOD_W01_REGULAR": "rosewood-w01-regular",
          "SNELLROUNDHANDW01_SCRIP": "snellroundhandw01-scrip",
          "SPINNAKER": "spinnaker",
          "STENCIL_W01_BOLD": "stencil-w01-bold"
        },
        "alignText": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "textMode": {
          "TITLEANDDESCRIPTION": "titleAndDescription",
          "TITLEONLY": "titleOnly",
          "DESCRIPTIONONLY": "descriptionOnly",
          "NOTEXT": "noText"
        },
        "galleryImageOnClickAction": {
          "DISABLED": "disabled",
          "ZOOMMODE": "zoomMode",
          "GOTOLINK": "goToLink"
        },
        "rolloverAnimation": {
          "COLORONLY": "colorOnly",
          "GLOW": "glow",
          "BOUNCE": "bounce"
        },
        "imageShape": {
          "HEXAGON": "hexagon",
          "SQUARE": "square",
          "TRIANGLE": "triangle"
        },
        "imageScale": {
          "X1": "x1",
          "X2": "x2",
          "X3": "x3"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AppPartProperties": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RssButtonProperties": {
      "enums": {
        "transition": {
          "NONE": "none",
          "FADE": "fade",
          "FLOAT": "float",
          "EXPAND": "expand",
          "SPIN": "spin",
          "FLY": "fly",
          "TURN": "turn",
          "REVEAL": "reveal",
          "SLIDE": "slide",
          "PUFF": "puff",
          "FLIP": "flip",
          "FOLD": "fold",
          "ARC": "arc"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BoxSlideShowProperties": {
      "enums": {
        "transition": {
          "NOTRANSITION": "NoTransition",
          "SLIDEVERTICAL": "SlideVertical",
          "SLIDEHORIZONTAL": "SlideHorizontal",
          "CROSSFADE": "CrossFade",
          "OUTIN": "OutIn"
        },
        "direction": {
          "LTR": "LTR",
          "RTL": "RTL"
        },
        "navigationDotsAlignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BoxSlideShowSlideProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StateBoxProperties": {
      "enums": {
        "transition": {
          "NOTRANSITION": "NoTransition",
          "SLIDEVERTICAL": "SlideVertical",
          "SLIDEHORIZONTAL": "SlideHorizontal",
          "CROSSFADE": "CrossFade",
          "OUTIN": "OutIn"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StateBoxStateProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StateBoxFormStateProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StripContainerSlideShowProperties": {
      "enums": {
        "transition": {
          "NOTRANSITION": "NoTransition",
          "SLIDEVERTICAL": "SlideVertical",
          "SLIDEHORIZONTAL": "SlideHorizontal",
          "CROSSFADE": "CrossFade",
          "OUTIN": "OutIn"
        },
        "direction": {
          "LTR": "LTR",
          "RTL": "RTL"
        },
        "navigationDotsAlignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StripContainerSlideShowSlideProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VerticalAnchorsMenuProperties": {
      "enums": {
        "itemsAlignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "orientation": {
          "LEFT": "left",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TextInputProperties": {
      "enums": {
        "textAlignment": {
          "LEFT": "left",
          "RIGHT": "right",
          "CENTER": "center"
        },
        "defaultTextType": {
          "NONE": "none",
          "INITIALTEXT": "initialText",
          "PLACEHOLDERTEXT": "placeholderText",
          "PLACEHOLDERANDINITIALTEXT": "placeholderAndInitialText"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        },
        "errorMessageType": {
          "INLINE": "inline",
          "TOOLTIP": "tooltip"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [
        "inputHeight",
        "inputHeightMobile",
        "labelMargin",
        "labelPadding",
        "labelMobileFontSize",
        "inputMobileFontSize"
      ],
      "convertToString": []
    },
    "TextAreaInputProperties": {
      "enums": {
        "textAlignment": {
          "LEFT": "left",
          "RIGHT": "right",
          "CENTER": "center"
        },
        "defaultTextType": {
          "NONE": "none",
          "INITIALTEXT": "initialText",
          "PLACEHOLDERTEXT": "placeholderText",
          "PLACEHOLDERANDINITIALTEXT": "placeholderAndInitialText"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        },
        "errorMessageType": {
          "INLINE": "inline",
          "TOOLTIP": "tooltip"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [
        "inputHeight",
        "inputHeightMobile",
        "labelMargin",
        "labelPadding",
        "labelMobileFontSize",
        "inputMobileFontSize"
      ],
      "convertToString": []
    },
    "CheckboxProperties": {
      "enums": {
        "alignment": {
          "LEFT": "left",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "DatePickerProperties": {
      "enums": {
        "textAlignment": {
          "LEFT": "left",
          "RIGHT": "right",
          "CENTER": "center"
        },
        "dateFormat": {
          "MM_DD_YYYY": "MM/DD/YYYY",
          "DD_MM_YYYY": "DD/MM/YYYY",
          "YYYY_MM_DD": "YYYY/MM/DD",
          "YYYY_M_D": "YYYY/M/D"
        },
        "defaultTextType": {
          "NONE": "none",
          "TODAY": "today",
          "PLACEHOLDER": "placeholder"
        },
        "dayToStart": {
          "SUNDAY": "Sunday",
          "MONDAY": "Monday"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [
        "inputHeight",
        "inputHeightMobile",
        "labelMargin",
        "labelPadding",
        "labelMobileFontSize",
        "inputMobileFontSize"
      ],
      "convertToString": []
    },
    "GridProperties": {
      "enums": {
        "type": {
          "NUMBER": "number",
          "STRING": "string",
          "DATE": "date",
          "IMAGE": "image",
          "BOOL": "bool",
          "RICHTEXT": "richText",
          "NORMAL": "normal",
          "PAGINATION": "pagination",
          "VIRTUAL": "virtual"
        },
        "heightLayout": {
          "MANUAL": "manual",
          "AUTO": "auto"
        },
        "style": {
          "TEXT": "text",
          "NUMBER": "number",
          "SIMPLE": "simple"
        },
        "alignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right",
          "SPREAD": "spread"
        },
        "userSelectionType": {
          "NONE": "none",
          "CELL": "cell",
          "ROW": "row"
        },
        "sort": {
          "ASC": "asc",
          "DESC": "desc",
          "NONE": "none"
        },
        "linkTarget": {
          "_SELF": "_self",
          "_BLANK": "_blank"
        },
        "columnLayout": {
          "EQUAL": "equal",
          "FITCONTENT": "fitContent",
          "MANUAL": "manual"
        },
        "horizontalAlignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PagePropertiesForDevice": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PageProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PopupContainerProperties": {
      "enums": {
        "horizontalAlignment": {
          "LEFT": "left",
          "RIGHT": "right",
          "CENTER": "center"
        },
        "verticalAlignment": {
          "TOP": "top",
          "BOTTOM": "bottom",
          "CENTER": "center"
        },
        "alignmentType": {
          "NINEGRID": "nineGrid",
          "FULLHEIGHT": "fullHeight",
          "FULLWIDTH": "fullWidth"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MediaPlayerProperties": {
      "enums": {
        "click": {
          "NONE": "none",
          "PLAY": "play",
          "TOGGLE": "toggle"
        },
        "rollIn": {
          "NONE": "none",
          "PLAY": "play",
          "PAUSE": "pause",
          "MUTE": "mute",
          "UNMUTE": "unmute"
        },
        "rollOut": {
          "NONE": "none",
          "PLAY": "play",
          "PAUSE": "pause",
          "MUTE": "mute",
          "UNMUTE": "unmute"
        },
        "animatePoster": {
          "NONE": "none",
          "FADE": "fade"
        },
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "HORIZONTAL": "horizontal",
          "VERTICAL": "vertical",
          "BOTH": "both",
          "NONE": "none"
        },
        "mode": {
          "ALPHA": "alpha",
          "LUMINANCE": "luminance"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MediaControlsProperties": {
      "enums": {
        "showStoryboard": {
          "VIDEOANDTIME": "videoAndTime",
          "TIME": "time",
          "NONE": "none"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MediaOverlayControlsProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LanguageSelectorProperties": {
      "enums": {
        "displayMode": {
          "HORIZONTAL": "horizontal",
          "DROPDOWN": "dropdown"
        },
        "iconType": {
          "NONE": "none",
          "CIRCLE": "circle",
          "SQUARE": "square",
          "ROUNDED": "rounded"
        },
        "itemFormat": {
          "SHORTNAME": "shortName",
          "FULLNAME": "fullName",
          "ICONONLY": "iconOnly",
          "FULLLOCALIZEDNAME": "fullLocalizedName"
        },
        "alignTabs": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MediaBoxProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PopoverProperties": {
      "enums": {
        "position": {
          "TOP": "top",
          "BOTTOM": "bottom",
          "LEFT": "left",
          "RIGHT": "right"
        },
        "alignment": {
          "START": "start",
          "CENTER": "center",
          "END": "end"
        },
        "closeMethod": {
          "MOUSEOUT": "mouseOut",
          "OUTERCLICK": "outerClick",
          "MANUAL": "manual"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "mobui.MobuiPickerProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MobuiPickerItemType": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "mobui.MobuiTextInputProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AccordionContainerProperties": {
      "enums": {
        "defaultOpened": {
          "CLOSE_ALL": "close_all",
          "OPEN_FIRST": "open_first",
          "OPEN_ALL": "open_all"
        },
        "icon": {
          "ARROW": "arrow",
          "PLUS": "plus"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AccordionItemProperties": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AddressInputProperties": {
      "enums": {
        "alignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [
        "inputHeight",
        "inputHeightMobile",
        "labelMargin",
        "labelPadding",
        "labelMobileFontSize",
        "inputMobileFontSize"
      ],
      "convertToString": []
    },
    "BoltComponentProperties": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreadcrumbsProperties": {
      "enums": {
        "separator": {
          "GREATER_THAN": "greater-than",
          "SLASH": "slash"
        },
        "direction": {
          "RTL": "rtl",
          "LTR": "ltr"
        },
        "alignment": {
          "FLEX_START": "flex-start",
          "CENTER": "center",
          "FLEX_END": "flex-end"
        },
        "align": {
          "START": "start",
          "CENTER": "center",
          "END": "end"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "CaptchaProperties": {
      "enums": {
        "theme": {
          "LIGHT": "light",
          "DARK": "dark"
        },
        "size": {
          "NORMAL": "normal",
          "COMPACT": "compact"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "CollapsibleTextProperties": {
      "enums": {
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl"
        },
        "align": {
          "LEFT": "left",
          "RIGHT": "right",
          "CENTER": "center"
        },
        "alignButton": {
          "LEFT": "left",
          "RIGHT": "right",
          "CENTER": "center"
        },
        "wrappingStyle": {
          "SINGLE_LINE": "single-line",
          "MULTI_LINE": "multi-line"
        },
        "expandMode": {
          "BUTTON": "button",
          "LINK": "link"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "HamburgerCloseButtonProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "HamburgerMenuContainerProperties": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "HamburgerOpenButtonProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LineShareButtonProperties": {
      "enums": {
        "buttonType": {
          "BUTTON": "button",
          "CLASSICWITHBUTTON": "classicWithButton",
          "CLASSICBIG": "classicBig",
          "CLASSICMEDIUM": "classicMedium",
          "CLASSICSMALL": "classicSmall",
          "BUBBLEBIG": "bubbleBig",
          "BUBBLEMEDIUM": "bubbleMedium",
          "BUBBLESMALL": "bubbleSmall"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MusicPlayerProperties": {
      "enums": {
        "layout": {
          "CLASSIC": "classic",
          "ICON": "icon"
        },
        "source": {
          "UPLOADS": "uploads",
          "URL": "url",
          "WIXMUSIC": "wixMusic"
        },
        "playlistTracksInfo": {
          "TRACKNAME": "trackName",
          "TRACKNAMEANDARTISTNAME": "trackNameAndArtistName"
        },
        "playlistTracksAction": {
          "ONACTIVE": "onActive",
          "ONALL": "onAll"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PaginationProperties": {
      "enums": {
        "paginationMode": {
          "PAGES": "pages",
          "INPUT": "input",
          "ARROWS": "arrows"
        },
        "navigationType": {
          "ARROWS": "arrows",
          "TEXT": "text"
        },
        "paginationDirection": {
          "LTR": "ltr",
          "RTL": "rtl"
        },
        "alignment": {
          "LEFT": "left",
          "CENTER": "center",
          "SPREAD": "spread",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ProGalleryProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ProgressBarProperties": {
      "enums": {
        "direction": {
          "RTL": "rtl",
          "LTR": "ltr"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RangeSliderProperties": {
      "enums": {
        "align": {
          "START": "start",
          "CENTER": "center",
          "END": "end"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RatingsDisplayProperties": {
      "enums": {
        "noReviewsMode": {
          "NOTHING": "nothing",
          "EMPTYICONS": "emptyIcons",
          "PLACEHOLDERTEXT": "placeholderText"
        },
        "ratingPosition": {
          "BEFORE": "before",
          "AFTER": "after"
        },
        "alignment": {
          "LEFT": "left",
          "RIGHT": "right",
          "CENTER": "center"
        },
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RatingsInputProperties": {
      "enums": {
        "labelPosition": {
          "TOP": "top",
          "BOTTOM": "bottom",
          "SIDE": "side"
        },
        "a11yLabelPosition": {
          "TOP": "top",
          "BOTTOM": "bottom",
          "SIDE": "side"
        },
        "labelAlignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "a11yLabelAlignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "direction": {
          "LTR": "ltr",
          "RTL": "rtl"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RichTextBoxProperties": {
      "enums": {
        "textAlignment": {
          "LEFT": "left",
          "RIGHT": "right",
          "CENTER": "center"
        },
        "toolbarPosition": {
          "TOP": "top",
          "BOTTOM": "bottom",
          "INLINE": "inline"
        },
        "defaultTextType": {
          "NONE": "none",
          "INITIALTEXT": "initialText",
          "PLACEHOLDERTEXT": "placeholderText",
          "PLACEHOLDERANDINITIALTEXT": "placeholderAndInitialText"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SearchBoxProperties": {
      "enums": {
        "layout": {
          "ICON": "icon",
          "BUTTON": "button",
          "ICON_ONLY": "icon-only",
          "EXPANDABLE": "expandable"
        },
        "iconAlignment": {
          "LEFT": "left",
          "RIGHT": "right"
        },
        "textAlignment": {
          "LEFT": "left",
          "CENTER": "center"
        },
        "expandedDirection": {
          "LEFT": "left",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SearchButtonProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SelectionTagsListProperties": {
      "enums": {
        "direction": {
          "RTL": "rtl",
          "LTR": "ltr"
        },
        "alignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SignatureInputProperties": {
      "enums": {
        "direction": {
          "RTL": "rtl",
          "LTR": "ltr"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SingleTabProperties": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SliderProperties": {
      "enums": {
        "orientation": {
          "HORIZONTAL": "horizontal",
          "VERTICAL": "vertical"
        },
        "thumbShape": {
          "CIRCLE": "circle",
          "SQUARE": "square",
          "RECTANGLE": "rectangle",
          "BAR": "bar"
        },
        "tickMarksShape": {
          "NONE": "none",
          "LINE": "line",
          "DOT": "dot"
        },
        "tooltipVisibility": {
          "NONE": "none",
          "HOVER": "hover",
          "ALWAYS": "always"
        },
        "tooltipPosition": {
          "NORMAL": "normal",
          "ACROSS": "across"
        },
        "tickMarksPosition": {
          "NORMAL": "normal",
          "MIDDLE": "middle",
          "ACROSS": "across"
        },
        "dir": {
          "LTR": "ltr",
          "RTL": "rtl"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SlideshowProperties": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SlideshowButtonProperties": {
      "enums": {
        "action": {
          "PREV": "prev",
          "NEXT": "next"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SocialAuthProperties": {
      "enums": {
        "mode": {
          "SIGNUP": "signup",
          "LOGIN": "login"
        },
        "formType": {
          "DEFAULT": "default",
          "CUSTOM": "custom",
          "CORVID": "corvid"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StylableButtonProperties": {
      "enums": {
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StylableHorizontalMenuProperties": {
      "enums": {
        "menuMode": {
          "WRAP": "wrap",
          "SCROLL": "scroll"
        },
        "submenuMode": {
          "COLUMNMENU": "columnMenu",
          "COLUMNSTRETCHED": "columnStretched",
          "FLYOUT": "flyout"
        },
        "submenuOrder": {
          "VERTICAL": "vertical",
          "HORIZONTAL": "horizontal"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TabsProperties": {
      "enums": {
        "itemsOrientation": {
          "HORIZONTAL": "horizontal",
          "VERTICAL": "vertical"
        },
        "itemsAlignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "contentAlignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "itemsLogicalAlign": {
          "START": "start",
          "CENTER": "center",
          "END": "end"
        },
        "contentLogicalAlign": {
          "START": "start",
          "CENTER": "center",
          "END": "end"
        },
        "menuMode": {
          "WRAP": "wrap",
          "SCROLL": "scroll"
        },
        "itemsDirection": {
          "RTL": "rtl",
          "LTR": "ltr"
        },
        "tabEnterAnimationName": {
          "NONE": "none",
          "FADEIN": "fadeIn",
          "FLOATFROMTOP": "floatFromTop",
          "FLOATFROMBOTTOM": "floatFromBottom"
        },
        "tabExitAnimationName": {
          "NONE": "none",
          "FADEOUT": "fadeOut"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TimePickerProperties": {
      "enums": {
        "alignment": {
          "LEFT": "left",
          "CENTER": "center",
          "RIGHT": "right"
        },
        "controller": {
          "TEXT": "text",
          "STEPPER": "stepper",
          "DROPDOWN": "dropdown"
        },
        "initialTime": {
          "NONE": "none",
          "CURRENT": "current",
          "VALUE": "value",
          "PLACEHOLDER": "placeholder"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ToggleSwitchProperties": {
      "enums": {
        "alignment": {
          "LEFT": "left",
          "RIGHT": "right"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VideoPlayerProperties": {
      "enums": {
        "controlsVisibility": {
          "HOVER": "hover",
          "NEVER": "never"
        },
        "animatePoster": {
          "FADE": "fade",
          "NONE": "none"
        },
        "ghost": {
          "COLLAPSED": "COLLAPSED"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RefArray": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VariantRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MinimalUnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SPXReferenceDefinition": {
      "enums": {
        "resolverType": {
          "SCALE": "scale",
          "FIXED": "fixed"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLength": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLengthPercentage": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitAngle": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizeArea": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizePoint": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointsData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRange": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "NumberThatCanConnectToAVariable": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkReference": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_Image": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_SVGItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ColorLayers": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinearLayer": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleLayer": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseLayer": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientMeshLayer": {
      "enums": {
        "type": {
          "GRADIENTMESH": "GradientMesh",
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConicLayer": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColorLayer": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinear": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircle": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipse": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConic": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColor": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BlendMode": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientColorStop": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientAngularColorStop": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    }
  },
  "connections": {
    "$id": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ConnectionList": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ConnectionItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [
        "controllerId"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WixCodeConnectionItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RefArray": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VariantRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MinimalUnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SPXReferenceDefinition": {
      "enums": {
        "resolverType": {
          "SCALE": "scale",
          "FIXED": "fixed"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLength": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLengthPercentage": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitAngle": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizeArea": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizePoint": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointsData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRange": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "NumberThatCanConnectToAVariable": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkReference": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_Image": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_SVGItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ColorLayers": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinearLayer": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleLayer": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseLayer": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientMeshLayer": {
      "enums": {
        "type": {
          "GRADIENTMESH": "GradientMesh",
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConicLayer": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColorLayer": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinear": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircle": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipse": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConic": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColor": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BlendMode": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientColorStop": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientAngularColorStop": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    }
  },
  "controllers": {
    "$id": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ControllerList": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RefArray": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VariantRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MinimalUnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SPXReferenceDefinition": {
      "enums": {
        "resolverType": {
          "SCALE": "scale",
          "FIXED": "fixed"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLength": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLengthPercentage": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitAngle": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizeArea": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizePoint": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointsData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRange": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "NumberThatCanConnectToAVariable": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkReference": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_Image": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_SVGItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ColorLayers": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinearLayer": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleLayer": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseLayer": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientMeshLayer": {
      "enums": {
        "type": {
          "GRADIENTMESH": "GradientMesh",
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConicLayer": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColorLayer": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinear": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircle": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipse": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConic": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColor": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BlendMode": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientColorStop": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientAngularColorStop": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    }
  },
  "naming": {
    "$id": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "naming": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RefArray": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VariantRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MinimalUnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SPXReferenceDefinition": {
      "enums": {
        "resolverType": {
          "SCALE": "scale",
          "FIXED": "fixed"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLength": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLengthPercentage": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitAngle": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizeArea": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizePoint": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointsData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRange": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "NumberThatCanConnectToAVariable": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkReference": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_Image": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_SVGItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ColorLayers": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinearLayer": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleLayer": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseLayer": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientMeshLayer": {
      "enums": {
        "type": {
          "GRADIENTMESH": "GradientMesh",
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConicLayer": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColorLayer": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinear": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircle": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipse": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConic": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColor": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BlendMode": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientColorStop": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientAngularColorStop": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    }
  },
  "presets": {
    "$id": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PresetData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RefArray": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VariantRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [
        "variants",
        "remoteVariants",
        "from"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MinimalUnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SPXReferenceDefinition": {
      "enums": {
        "resolverType": {
          "SCALE": "scale",
          "FIXED": "fixed"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLength": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLengthPercentage": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitAngle": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizeArea": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizePoint": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointsData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRange": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "NumberThatCanConnectToAVariable": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkReference": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_Image": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_SVGItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ColorLayers": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinearLayer": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleLayer": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseLayer": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientMeshLayer": {
      "enums": {
        "type": {
          "GRADIENTMESH": "GradientMesh",
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConicLayer": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColorLayer": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinear": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircle": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipse": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConic": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColor": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BlendMode": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientColorStop": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientAngularColorStop": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    }
  },
  "slots": {
    "$id": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PlaceholderSlot": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "DynamicSlots": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SlotRef": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RefArray": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VariantRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MinimalUnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SPXReferenceDefinition": {
      "enums": {
        "resolverType": {
          "SCALE": "scale",
          "FIXED": "fixed"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLength": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLengthPercentage": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitAngle": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizeArea": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizePoint": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointsData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRange": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "NumberThatCanConnectToAVariable": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkReference": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_Image": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_SVGItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ColorLayers": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinearLayer": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleLayer": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseLayer": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientMeshLayer": {
      "enums": {
        "type": {
          "GRADIENTMESH": "GradientMesh",
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConicLayer": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColorLayer": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinear": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircle": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipse": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConic": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColor": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BlendMode": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientColorStop": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientAngularColorStop": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    }
  },
  "style": {
    "$id": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WFlatTheme": {
      "enums": {
        "fontStyle": {
          "NORMAL": "normal",
          "ITALIC": "italic"
        },
        "fontWeight": {
          "NORMAL": "normal",
          "BOLD": "bold",
          "BOLDER": "bolder",
          "LIGHTER": "lighter",
          "_100": "100",
          "_200": "200",
          "_300": "300",
          "_400": "400",
          "_500": "500",
          "_600": "600",
          "_700": "700",
          "_800": "800",
          "_900": "900"
        },
        "fontVariant": {
          "NORMAL": "normal",
          "SMALL_CAPS": "small-caps",
          "INHERIT": "inherit"
        },
        "resolverType": {
          "SCALE": "scale",
          "FIXED": "fixed"
        },
        "fontDisplay": {
          "AUTO": "auto",
          "BLOCK": "block",
          "SWAP": "swap",
          "FALLBACK": "fallback",
          "OPTIONAL": "optional"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "OverridableTheme": {
      "enums": {
        "resolverType": {
          "SCALE": "scale",
          "FIXED": "fixed"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TextTheme": {
      "enums": {
        "fontStyle": {
          "NORMAL": "normal",
          "ITALIC": "italic"
        },
        "fontWeight": {
          "NORMAL": "normal",
          "BOLD": "bold",
          "BOLDER": "bolder",
          "LIGHTER": "lighter",
          "_100": "100",
          "_200": "200",
          "_300": "300",
          "_400": "400",
          "_500": "500",
          "_600": "600",
          "_700": "700",
          "_800": "800",
          "_900": "900"
        },
        "fontVariant": {
          "NORMAL": "normal",
          "SMALL_CAPS": "small-caps",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FontStyle": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FontSize": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FontWeight": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FontVariant": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FontFamily": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TextColor": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LineHeight": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LetterSpacing": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PartialTextTheme": {
      "enums": {
        "fontStyle": {
          "NORMAL": "normal",
          "ITALIC": "italic"
        },
        "fontWeight": {
          "NORMAL": "normal",
          "BOLD": "bold",
          "BOLDER": "bolder",
          "LIGHTER": "lighter",
          "_900": "900",
          "_800": "800",
          "_700": "700",
          "_600": "600",
          "_500": "500",
          "_400": "400",
          "_300": "300",
          "_200": "200",
          "_100": "100"
        },
        "fontVariant": {
          "NORMAL": "normal",
          "SMALL_CAPS": "small-caps",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {
        "fontFamily": {
          "ANTON": "anton",
          "ANTON_2": "Anton",
          "ANTON_SANS_SERIF": "Anton,sans-serif",
          "ARIAL": "arial",
          "ARIAL_2": "Arial",
          "ARIAL_SANS_SERIF": "Arial,sans-serif",
          "COURIER_NEW": "courier+new",
          "COURIER_NEW_2": "Courier+New",
          "COURIER_NEW_MONOSPACE": "Courier+New,monospace",
          "ARIAL_BLACK": "arial+black",
          "ARIAL_BLACK_2": "Arial+Black",
          "ARIAL_BLACK_SANS_SERIF": "Arial+Black,sans-serif",
          "BASIC": "basic",
          "BASIC_2": "Basic",
          "BASIC_SANS_SERIF": "Basic,sans-serif",
          "CAUDEX": "caudex",
          "CAUDEX_2": "Caudex",
          "CAUDEX_SERIF": "Caudex,serif",
          "CHELSEA_MARKET": "chelsea+market",
          "CHELSEA_MARKET_2": "Chelsea+Market",
          "CHELSEA_MARKET_FANTASY": "Chelsea+Market,fantasy",
          "COMIC_SANS_MS": "comic+sans+ms",
          "COMIC_SANS_MS_2": "Comic+Sans+MS",
          "COMIC_SANS_MS_CURSIVE": "Comic+Sans+MS,cursive",
          "CORBEN": "corben",
          "CORBEN_2": "Corben",
          "CORBEN_SERIF": "Corben,serif",
          "EB_GARAMOND": "eb+garamond",
          "EB_GARAMOND_2": "EB+Garamond",
          "EB_GARAMOND_SERIF": "EB+Garamond,serif",
          "ENRIQUETA": "enriqueta",
          "ENRIQUETA_2": "Enriqueta",
          "ENRIQUETA_SERIF": "Enriqueta,serif",
          "FORUM": "forum",
          "FORUM_2": "Forum",
          "FORUM_SERIF": "Forum,serif",
          "FREDERICKA_THE_GREAT": "fredericka+the+great",
          "FREDERICKA_THE_GREAT_2": "Fredericka+the+Great",
          "FREDERICKA_THE_GREAT_FANTASY": "Fredericka+the+Great,fantasy",
          "GEORGIA": "georgia",
          "GEORGIA_2": "Georgia",
          "GEORGIA_SERIF": "Georgia,serif",
          "IMPACT": "impact",
          "IMPACT_2": "Impact",
          "IMPACT_SANS_SERIF": "Impact,sans-serif",
          "JOCKEY_ONE": "jockey+one",
          "JOCKEY_ONE_2": "Jockey+One",
          "JOCKEY_ONE_3": "Jockey+one",
          "JOCKEY_ONE_SANS_SERIF": "Jockey+One,sans-serif",
          "JOSEFIN_SLAB": "josefin+slab",
          "JOSEFIN_SLAB_2": "Josefin+Slab",
          "JOSEFIN_SLAB_SERIF": "Josefin+Slab,serif",
          "JURA": "jura",
          "JURA_2": "Jura",
          "JURA_SANS_SERIF": "Jura,sans-serif",
          "KELLY_SLAB": "kelly+slab",
          "KELLY_SLAB_2": "Kelly+Slab",
          "KELLY_SLAB_FANTASY": "Kelly+Slab,fantasy",
          "LUCIDA_CONSOLE": "lucida+console",
          "LUCIDA_CONSOLE_2": "Lucida+Console",
          "LUCIDA_CONSOLE_MONOSPACE": "Lucida+Console,monospace",
          "LUCIDA_SANS_UNICODE": "lucida+sans+unicode",
          "LUCIDA_SANS_UNICODE_2": "Lucida+Sans+Unicode",
          "LUCIDA_SANS_UNICODE_SANS_SERIF": "Lucida+Sans+Unicode,sans-serif",
          "MARCK_SCRIPT": "marck+script",
          "MARCK_SCRIPT_2": "Marck+Script",
          "MARCK_SCRIPT_CURSIVE": "Marck+Script,cursive",
          "LOBSTER": "lobster",
          "LOBSTER_2": "Lobster",
          "LOBSTER_CURSIVE": "Lobster,cursive",
          "MR_DE_HAVILAND": "mr+de+haviland",
          "MR_DE_HAVILAND_2": "Mr+De+Haviland",
          "MR_DE_HAVILAND_CURSIVE": "Mr+De+Haviland,cursive",
          "NICONNE": "niconne",
          "NICONNE_2": "Niconne",
          "NICONNE_FANTASY": "Niconne,fantasy",
          "NOTICIA_TEXT": "noticia+text",
          "NOTICIA_TEXT_2": "Noticia+Text",
          "NOTICIA_TEXT_SERIF": "Noticia+Text,serif",
          "OPEN_SANS": "open+sans",
          "OPEN_SANS_2": "Open+Sans",
          "OPEN_SANS_SANS_SERIF": "Open+Sans,sans-serif",
          "OVERLOCK": "overlock",
          "OVERLOCK_2": "Overlock",
          "OVERLOCK_SANS_SERIF": "Overlock,sans-serif",
          "PALATINO_LINOTYPE": "palatino+linotype",
          "PALATINO_LINOTYPE_2": "Palatino+Linotype",
          "PALATINO_LINOTYPE_SERIF": "Palatino+Linotype,serif",
          "PATRICK_HAND": "patrick+hand",
          "PATRICK_HAND_2": "Patrick+Hand",
          "PATRICK_HAND_CURSIVE": "Patrick+Hand,cursive",
          "PLAY": "play",
          "PLAY_2": "Play",
          "PLAY_SANS_SERIF": "Play,sans-serif",
          "SARINA": "sarina",
          "SARINA_2": "Sarina",
          "SARINA_CURSIVE": "Sarina,cursive",
          "SIGNIKA": "signika",
          "SIGNIKA_2": "Signika",
          "SIGNIKA_SANS_SERIF": "Signika,sans-serif",
          "SPINNAKER": "spinnaker",
          "SPINNAKER_2": "Spinnaker",
          "SPINNAKER_SANS_SERIF": "Spinnaker,sans-serif",
          "TAHOMA": "tahoma",
          "TAHOMA_2": "Tahoma",
          "TAHOMA_SANS_SERIF": "Tahoma,sans-serif",
          "TIMES_NEW_ROMAN": "times+new+roman",
          "TIMES_NEW_ROMAN_2": "Times+New+Roman",
          "TIMES_NEW_ROMAN_SERIF": "Times+New+Roman,serif",
          "VERDANA": "verdana",
          "VERDANA_2": "Verdana",
          "VERDANA_SANS_SERIF": "Verdana,sans-serif",
          "HELVETICANEUEW01_45LIGH": "helveticaneuew01-45ligh",
          "HELVETICA_45": "Helvetica+45",
          "HELVETICA_45_SANS_SERIF": "Helvetica+45,sans-serif",
          "HELVETICANEUEW01_65MEDI": "helveticaneuew01-65medi",
          "HELVETICA_65": "Helvetica+65",
          "HELVETICA_65_SANS_SERIF": "Helvetica+65,sans-serif",
          "HELVETICANEUEW01_75BOLD": "helveticaneuew01-75bold",
          "HELVETICA_75": "Helvetica+75",
          "HELVETICA_75_SANS_SERIF": "Helvetica+75,sans-serif",
          "HELVETICANEUEW01_95BLAC": "helveticaneuew01-95blac",
          "HELVETICA_95": "Helvetica+95",
          "HELVETICA_95_SANS_SERIF": "Helvetica+95,sans-serif",
          "HELVETICANEUEW01_THIN": "helveticaneuew01-thin",
          "HELVETICA_35": "Helvetica+35",
          "HELVETICA_35_SANS_SERIF": "Helvetica+35,sans-serif",
          "HELVETICANEUEW01_ULTLT": "helveticaneuew01-ultlt",
          "HELVETICA_25": "Helvetica+25",
          "HELVETICA_25_SANS_SERIF": "Helvetica+25,sans-serif",
          "HELVETICANEUEW02_45LIGH": "helveticaneuew02-45ligh",
          "HELVETICA_45_LATIN_EXT": "Helvetica+45+Latin+Ext",
          "HELVETICA_45_LATIN_EXT_SANS_SERIF": "Helvetica+45+Latin+Ext,sans-serif",
          "HELVETICANEUEW02_65MEDI": "helveticaneuew02-65medi",
          "HELVETICA_65_LATIN_EXT": "Helvetica+65+Latin+Ext",
          "HELVETICA_65_LATIN_EXT_SANS_SERIF": "Helvetica+65+Latin+Ext,sans-serif",
          "HELVETICANEUEW02_75BOLD": "helveticaneuew02-75bold",
          "HELVETICA_75_LATIN_EXT": "Helvetica+75+Latin+Ext",
          "HELVETICA_75_LATIN_EXT_SANS_SERIF": "Helvetica+75+Latin+Ext,sans-serif",
          "HELVETICANEUEW02_95BLAC": "helveticaneuew02-95blac",
          "HELVETICA_95_LATIN_EXT": "Helvetica+95+Latin+Ext",
          "HELVETICA_95_LATIN_EXT_SANS_SERIF": "Helvetica+95+Latin+Ext,sans-serif",
          "HELVETICANEUEW02_THIN": "helveticaneuew02-thin",
          "HELVETICA_35_LATIN_EXT": "Helvetica+35+Latin+Ext",
          "HELVETICA_35_LATIN_EXT_SANS_SERIF": "Helvetica+35+Latin+Ext,sans-serif",
          "HELVETICANEUEW02_ULTLT": "helveticaneuew02-ultlt",
          "HELVETICA_25_LATIN_EXT": "Helvetica+25+Latin+Ext",
          "HELVETICA_25_LATIN_EXT_SANS_SERIF": "Helvetica+25+Latin+Ext,sans-serif",
          "HELVETICANEUEW10_45LIGH": "helveticaneuew10-45ligh",
          "HELVETICA_45_CYRILLIC": "Helvetica+45+Cyrillic",
          "HELVETICA_45_CYRILLIC_SANS_SERIF": "Helvetica+45+Cyrillic,sans-serif",
          "HELVETICANEUEW10_65MEDI": "helveticaneuew10-65medi",
          "HELVETICA_65_CYRILLIC": "Helvetica+65+Cyrillic",
          "HELVETICA_65_CYRILLIC_SANS_SERIF": "Helvetica+65+Cyrillic,sans-serif",
          "HELVETICANEUEW10_75BOLD": "helveticaneuew10-75bold",
          "HELVETICA_75_CYRILLIC": "Helvetica+75+Cyrillic",
          "HELVETICA_75_CYRILLIC_SANS_SERIF": "Helvetica+75+Cyrillic,sans-serif",
          "HELVETICANEUEW10_95BLAC": "helveticaneuew10-95blac",
          "HELVETICA_95_CYRILLIC": "Helvetica+95+Cyrillic",
          "HELVETICA_95_CYRILLIC_SANS_SERIF": "Helvetica+95+Cyrillic,sans-serif",
          "HELVETICANEUEW10_35THIN": "helveticaneuew10-35thin",
          "HELVETICA_35_CYRILLIC": "Helvetica+35+Cyrillic",
          "HELVETICA_35_CYRILLIC_SANS_SERIF": "Helvetica+35+Cyrillic,sans-serif",
          "HELVETICANEUEW10_25ULTL": "helveticaneuew10-25ultl",
          "HELVETICA_25_CYRILLIC": "Helvetica+25+Cyrillic",
          "HELVETICA_25_CYRILLIC_SANS_SERIF": "Helvetica+25+Cyrillic,sans-serif",
          "MEIRYO": "meiryo",
          "MEIRYO_2": "Meiryo",
          "MEIRYO_SANS_SERIF": "Meiryo,sans-serif",
          "SEGOE_PRINTREGULAR": "segoe_printregular",
          "SEGOE_PRINT": "Segoe+Print",
          "SEGOE_PRINT_CURSIVE": "Segoe+Print,cursive",
          "BODONI_W01_POSTER": "bodoni-w01-poster",
          "BODONI_POSTER": "Bodoni+Poster",
          "BODONI_POSTER_FANTASY": "Bodoni+Poster,fantasy",
          "STENCIL_W01_BOLD": "stencil-w01-bold",
          "STENCIL": "Stencil",
          "STENCIL_FANTASY": "Stencil,fantasy",
          "ITC_ARECIBO_W01_REGULAR": "itc-arecibo-w01-regular",
          "ITC_ARECIBO": "ITC+Arecibo",
          "ITC_ARECIBO_FANTASY": "ITC+Arecibo,fantasy",
          "AVENIDA_W01": "avenida-w01",
          "AVENIDA": "Avenida",
          "AVENIDA_FANTASY": "Avenida,fantasy",
          "PACIFICA_W00_CONDENSED": "pacifica-w00-condensed",
          "PACIFICA_CONDENSED": "Pacifica+Condensed",
          "PACIFICA_CONDENSED_FANTASY": "Pacifica+Condensed,fantasy",
          "GEOTICA_W01_FOUR_OPEN": "geotica-w01-four-open",
          "GEOTICA_FOUR_OPEN": "Geotica+Four+Open",
          "GEOTICA_FOUR_OPEN_FANTASY": "Geotica+Four+Open,fantasy",
          "MARZO_W00_REGULAR": "marzo-w00-regular",
          "MARZO": "Marzo",
          "MARZO_FANTASY": "Marzo,fantasy",
          "BRAGGADOCIO_W01": "braggadocio-w01",
          "BRAGGADOCIO": "Braggadocio",
          "BRAGGADOCIO_FANTASY": "Braggadocio,fantasy",
          "REKLAMESCRIPTW00_MEDIUM": "reklamescriptw00-medium",
          "REKLAME_SCRIPT": "Reklame+Script",
          "REKLAME_SCRIPT_CURSIVE": "Reklame+Script,cursive",
          "SNELLROUNDHANDW01_SCRIP": "snellroundhandw01-scrip",
          "SNELL_ROUNDHAND": "Snell+Roundhand",
          "SNELL_ROUNDHAND_CURSIVE": "Snell+Roundhand,cursive",
          "DIN_NEXT_W01_LIGHT": "din-next-w01-light",
          "DIN_NEXT_LIGHT": "DIN+Next+Light",
          "DIN_NEXT_LIGHT_SANS_SERIF": "DIN+Next+Light,sans-serif",
          "HELVETICA_W01_ROMAN": "helvetica-w01-roman",
          "HELVETICA": "Helvetica",
          "HELVETICA_SANS_SERIF": "Helvetica,sans-serif",
          "HELVETICA_W01_LIGHT": "helvetica-w01-light",
          "HELVETICA_LIGHT": "Helvetica+Light",
          "HELVETICA_LIGHT_SANS_SERIF": "Helvetica+Light,sans-serif",
          "HELVETICA_W01_BOLD": "helvetica-w01-bold",
          "HELVETICA_BOLD": "Helvetica+Bold",
          "HELVETICA_BOLD_SANS_SERIF": "Helvetica+Bold,sans-serif",
          "NIMBUS_SANS_TW01CON": "nimbus-sans-tw01con",
          "NIMBUS_SANS": "Nimbus+Sans",
          "NIMBUS_SANS_SANS_SERIF": "Nimbus+Sans,sans-serif",
          "SOHO_W01_THIN_CONDENSED": "soho-w01-thin-condensed",
          "SOHO_CONDENSED": "Soho+Condensed",
          "SOHO_CONDENSED_SERIF": "Soho+Condensed,serif",
          "DROID_SERIF_W01_REGULAR": "droid-serif-w01-regular",
          "DROID_SERIF": "Droid+Serif",
          "DROID_SERIF_SERIF": "Droid+Serif,serif",
          "CLARENDON_W01_MEDIUM_692107": "clarendon-w01-medium-692107",
          "CLARENDON_LT": "Clarendon+LT",
          "CLARENDON_LT_SERIF": "Clarendon+LT,serif",
          "MUSEO_W01_700": "museo-w01-700",
          "MUSEO": "Museo",
          "MUSEO_SERIF": "Museo,serif",
          "MUSEO_SLAB_W01_100": "museo-slab-w01-100",
          "MUSEO_SLAB": "Museo+Slab",
          "MUSEO_SLAB_SERIF": "Museo+Slab,serif",
          "AMERICANTYPWRTERITCW01__731025": "americantypwrteritcw01--731025",
          "AMERICAN_TYPEWRITER": "American+Typewriter",
          "AMERICAN_TYPEWRITER_SERIF": "American+Typewriter,serif",
          "MONOTON": "monoton",
          "MONOTON_2": "Monoton",
          "MONOTON_FANTASY": "Monoton,fantasy",
          "SACRAMENTO": "sacramento",
          "SACRAMENTO_2": "Sacramento",
          "SACRAMENTO_CURSIVE": "Sacramento,cursive",
          "COOKIE": "cookie",
          "COOKIE_2": "Cookie",
          "COOKIE_CURSIVE": "Cookie,cursive",
          "RALEWAY": "raleway",
          "RALEWAY_2": "Raleway",
          "RALEWAY_SANS_SERIF": "Raleway,sans-serif",
          "OPEN_SANS_CONDENSED": "open+sans+condensed",
          "OPEN_SANS_CONDENSED_2": "Open+Sans+Condensed",
          "OPEN_SANS_CONDENSED_SANS_SERIF": "Open+Sans+Condensed,sans-serif",
          "OPEN_SANS_CONDENSED_300": "open+sans+condensed:300",
          "AMATIC_SC": "amatic+sc",
          "AMATIC_SC_2": "Amatic+SC",
          "AMATIC_SC_CURSIVE": "Amatic+SC,cursive",
          "COQUETTE_W00_LIGHT": "coquette-w00-light",
          "COQUETTE": "Coquette",
          "COQUETTE_SANS_SERIF": "Coquette,sans-serif",
          "ROSEWOOD_W01_REGULAR": "rosewood-w01-regular",
          "ROSEWOOD": "Rosewood",
          "ROSEWOOD_SANS_SERIF": "Rosewood,sans-serif",
          "HELVETICA_NEUE": "helvetica+neue",
          "HELVETICA_NEUE_2": "Helvetica+Neue",
          "HELVETICA_NEUE_SANS_SERIF": "Helvetica+Neue,sans-serif",
          "HELVETICA_NEUE_ITALIC": "helvetica+neue+italic",
          "HELVETICA_NEUE_ITALIC_2": "Helvetica+Neue+Italic",
          "HELVETICA_NEUE_ITALIC_SANS_SERIF": "Helvetica+Neue+Italic,sans-serif",
          "HELVETICA_NEUE_THIN": "helvetica+neue+thin",
          "HELVETICA_NEUE_THIN_2": "Helvetica+Neue+Thin",
          "HELVETICA_NEUE_THIN_SANS_SERIF": "Helvetica+Neue+Thin,sans-serif",
          "HELVETICA_NEUE_MEDIUM": "helvetica+neue+medium",
          "HELVETICA_NEUE_MEDIUM_2": "Helvetica+Neue+Medium",
          "HELVETICA_NEUE_MEDIUM_SANS_SERIF": "Helvetica+Neue+Medium,sans-serif",
          "FRANK_RUHL_W26_REGULAR": "frank-ruhl-w26-regular",
          "FRANK_RUHL": "Frank+Ruhl",
          "FRANK_RUHL_SERIF": "Frank+Ruhl,serif",
          "ALEF_REGULAR": "alef-regular",
          "ALEF": "Alef",
          "ALEF_SANS_SERIF": "Alef,sans-serif",
          "MIRIAM_W26_MEDIUM": "miriam-w26-medium",
          "MIRIAM": "Miriam",
          "MIRIAM_SERIF": "Miriam,serif",
          "ADLER_W26_REGULAR": "adler-w26-regular",
          "ADLER": "Adler",
          "ADLER_CURSIVE": "Adler,cursive",
          "HAIM_ARUKEEM_W26_MEDIUM": "haim-arukeem-w26-medium",
          "LONGLIFE": "Longlife",
          "LONGLIFE_SANS_SERIF": "Longlife,sans-serif",
          "SHABAZI_W26_BOLD": "shabazi-w26-bold",
          "SHABAZI_BOLD": "Shabazi+Bold",
          "SHABAZI_BOLD_SERIF": "Shabazi+Bold,serif",
          "GULASH_W26_REGULAR": "gulash-w26-regular",
          "GULASH": "Gulash",
          "GULASH_CURSIVE": "Gulash,cursive",
          "CHIPS_W26_NORMAL": "chips-w26-normal",
          "CHIPS": "Chips",
          "CHIPS_FANTASY": "Chips,fantasy",
          "NEKUDOT_W26_BOLD": "nekudot-w26-bold",
          "NEKUDOT_BOLD": "Nekudot+Bold",
          "NEKUDOT_BOLD_FANTASY": "Nekudot+Bold,fantasy",
          "OPENSANSHEBREWCONDENSED_REGULAR": "opensanshebrewcondensed-regular",
          "ASIMON_AAA_400": "asimon-aaa-400",
          "ASIMON": "Asimon",
          "ASIMON_SANS_SERIF": "Asimon,sans-serif",
          "ATLAS_AAA_500": "atlas-aaa-500",
          "ATLAS": "Atlas",
          "ATLAS_SANS_SERIF": "Atlas,sans-serif",
          "OMES_AAA_400": "omes-aaa-400",
          "OMES": "Omes",
          "OMES_CURSIVE": "Omes,cursive",
          "ALMONI_DL_AAA_300": "almoni-dl-aaa-300",
          "ALMONI_DL_LIGHT": "Almoni+DL+Light",
          "ALMONI_DL_LIGHT_SANS_SERIF": "Almoni+DL+Light,sans-serif",
          "ALMONI_DL_AAA_400": "almoni-dl-aaa-400",
          "ALMONI_DL_REGULAR": "Almoni+DL+Regular",
          "ALMONI_DL_REGULAR_SANS_SERIF": "Almoni+DL+Regular,sans-serif",
          "ALMONI_DL_AAA_700": "almoni-dl-aaa-700",
          "ALMONI_DL_BOLD": "Almoni+DL+Bold",
          "ALMONI_DL_BOLD_SANS_SERIF": "Almoni+DL+Bold,sans-serif",
          "MIXTAPE_AAA_400": "mixtape-aaa-400",
          "MIXTAPE": "Mixtape",
          "MIXTAPE_SANS_SERIF": "Mixtape,sans-serif",
          "MUSEUM_AAA_400": "museum-aaa-400",
          "MUSEUM": "Museum",
          "MUSEUM_SANS_SERIF": "Museum,sans-serif",
          "MEODEDPASHUT_OEREGULAR": "meodedpashut-oeregular",
          "MEODED": "Meoded",
          "MEODED_SANS_SERIF": "Meoded,sans-serif",
          "ARABICTYPESETTINGW23_RE": "arabictypesettingw23-re",
          "ARABIC_TYPESETTING_REGULAR": "Arabic+Typesetting+Regular",
          "ARABIC_TYPESETTING_REGULAR_SERIF": "Arabic+Typesetting+Regular,serif",
          "MIDAN_W20": "midan-w20",
          "MIDAN": "Midan",
          "MIDAN_SERIF": "Midan,serif",
          "ARIAN_LT_W20_LIGHT": "arian-lt-w20-light",
          "ARIAN_LIGHT": "Arian+Light",
          "ARIAN_LIGHT_SANS_SERIF": "Arian+Light,sans-serif",
          "ARIAN_LT_W20_REGULAR": "arian-lt-w20-regular",
          "ARIAN": "Arian",
          "ARIAN_SANS_SERIF": "Arian,sans-serif",
          "COHEADLINEW23_ARABICBOL": "coheadlinew23-arabicbol",
          "CO_HEADLINE_ARABIC_BOLD": "Co+Headline+Arabic+Bold",
          "CO_HEADLINE_ARABIC_BOLD_FANTASY": "Co+Headline+Arabic+Bold,fantasy",
          "JANNA_LT_W20_REGULAR": "janna-lt-w20-regular",
          "JANNA": "Janna",
          "JANNA_SANS_SERIF": "Janna,sans-serif",
          "HELVETICANEUELTW20_LIGH": "helveticaneueltw20-ligh",
          "NEUE_HELVETICA_ARABIC": "Neue+Helvetica+Arabic",
          "NEUE_HELVETICA_ARABIC_SANS_SERIF": "Neue+Helvetica+Arabic,sans-serif",
          "DINNEXTLTW23_ULTRALIGHT": "dinnextltw23-ultralight",
          "DIN_NEXT_ARABIC": "DIN+Next+Arabic",
          "DIN_NEXT_ARABIC_SANS_SERIF": "DIN+Next+Arabic,sans-serif",
          "TANSEEKMODERNW20_LIGHT": "tanseekmodernw20-light",
          "TANSEEK_MODERN_LIGHT": "Tanseek+Modern+Light",
          "TANSEEK_MODERN_LIGHT_SANS_SERIF": "Tanseek+Modern+Light,sans-serif",
          "AHMEDLTW20_OUTLINEREGUL": "ahmedltw20-outlineregul",
          "AHMED_OUTLINE": "Ahmed+Outline",
          "AHMED_OUTLINE_FANTASY": "Ahmed+Outline,fantasy",
          "KUFI_LT_W20_REGULAR": "kufi-lt-w20-regular",
          "KUFI_REGULAR": "Kufi+Regular",
          "KUFI_REGULAR_FANTASY": "Kufi+Regular,fantasy",
          "AMIRI": "amiri",
          "AMIRI_2": "Amiri",
          "AMIRI_SERIF": "Amiri,serif",
          "DROID_NASKH": "droid-naskh",
          "DROID_NASKH_2": "Droid+Naskh",
          "DROID_NASKH_SERIF": "Droid+Naskh,serif",
          "MS_JP_GOTHIC": "ｍｓ+ゴシック",
          "MS_JP_GOTHIC_2": "MS+ゴシック",
          "MS_JP_GOTHIC_SANS_SERIF": "MS+ゴシック,sans-serif",
          "MS_JP_MING_DYNASTY": "ｍｓ+明朝",
          "MS_JP_MING_DYNASTY_2": "MS+明朝",
          "MS_JP_MING_DYNASTY_SERIF": "MS+明朝,serif",
          "MS_P_JP_GOTHIC": "ｍｓ+ｐゴシック",
          "MS_P_JP_GOTHIC_2": "MS+Pゴシック",
          "MS_P_GOTHIC_SANS_SERIF": "MS+Pゴシック,sans-serif",
          "MS_P_JP_MING_DYNASTY": "ｍｓ+ｐ明朝",
          "MS_P_JP_MING_DYNASTY_2": "MS+P明朝",
          "MS_P_JP_MING_DYNASTY_SERIF": "MS+P明朝,serif",
          "JP_MEIRYO": "メイリオ",
          "JP_MEIRYO_SANS_SERIF": "メイリオ,sans-serif",
          "KO_MALGUN_GOTHIC": "맑은+고딕",
          "MALGUN_GOTHIC": "Malgun+Gothic",
          "MALGUN_GOTHIC_SANS_SERIF": "Malgun+Gothic,sans-serif",
          "KO_DOTUM": "돋움",
          "DOTUM": "Dotum",
          "DOTUM_SANS_SERIF": "Dotum,sans-serif",
          "KO_GULIM": "굴림",
          "GULIM": "Gulim",
          "GULIM_SANS_SERIF": "Gulim,sans-serif",
          "NANUMGOTHIC_REGULAR": "nanumgothic-regular",
          "NANUM_GOTHIC": "Nanum+Gothic",
          "NANUM_GOTHIC_SANS_SERIF": "Nanum+Gothic,sans-serif",
          "BM_HANNA": "bm-hanna",
          "BM_HANNA_2": "BM+Hanna",
          "BM_HANNA_SANS_SERIF": "BM+Hanna,sans-serif",
          "FBNEOGOTHIC": "fbneogothic",
          "FB_NEO_GOTHIC": "FB+Neo+Gothic",
          "FB_NEO_GOTHIC_SANS_SERIF": "FB+Neo+Gothic,sans-serif",
          "FBCHAMBLUE": "fbchamblue",
          "FB_CHAM_BLUE": "FB+Cham+Blue",
          "FB_CHAM_BLUE_FANTASY": "FB+Cham+Blue,fantasy",
          "FBBLUEGOTHICL": "fbbluegothicl",
          "FB_BLUE_GOTHIC": "FB+Blue+Gothic",
          "FB_BLUE_GOTHIC_SERIF": "FB+Blue+Gothic,serif",
          "FBPLUM": "fbplum",
          "FB_PLUM": "FB+Plum",
          "FB_PLUM_FANTASY": "FB+Plum,fantasy",
          "FBGREEN": "fbgreen",
          "FB_GREEN": "FB+Green",
          "FB_GREEN_SANS_SERIF": "FB+Green,sans-serif",
          "CINZEL": "cinzel",
          "CINZEL_2": "Cinzel",
          "CINZEL_SERIF": "Cinzel,serif",
          "SAIL": "sail",
          "SAIL_2": "Sail",
          "SAIL_SERIF": "Sail,serif",
          "PLAYFAIR_DISPLAY": "playfair+display",
          "PLAYFAIR_DISPLAY_2": "Playfair+Display",
          "PLAYFAIR_DISPLAY_SERIF": "Playfair+Display,serif",
          "LIBRE_BASKERVILLE": "libre+baskerville",
          "LIBRE_BASKERVILLE_2": "Libre+Baskerville",
          "LIBRE_BASKERVILLE_SERIF": "Libre+Baskerville,serif",
          "TREND_SANS_W00_FOUR": "trend-sans-w00-four",
          "TREND": "Trend",
          "TREND_SANS_SERIF": "Trend,sans-serif",
          "PROXIMA_N_W01_REG": "proxima-n-w01-reg",
          "PROXIMA_NOVA": "Proxima+Nova",
          "PROXIMA_NOVA_SANS_SERIF": "Proxima+Nova,sans-serif",
          "BREE_W01_THIN_OBLIQUE": "bree-w01-thin-oblique",
          "BREE": "Bree",
          "BREE_SANS_SERIF": "Bree,sans-serif",
          "LULO_CLEAN_W01_ONE_BOLD": "lulo-clean-w01-one-bold",
          "LULO_CLEAN": "Lulo+Clean",
          "LULO_CLEAN_SANS_SERIF": "Lulo+Clean,sans-serif",
          "FUTURA_LT_W01_BOOK": "futura-lt-w01-book",
          "FUTURA": "Futura",
          "FUTURA_SANS_SERIF": "Futura,sans-serif",
          "FUTURA_LT_W01_LIGHT": "futura-lt-w01-light",
          "FUTURA_LIGHT": "Futura+Light",
          "FUTURA_LIGHT_SANS_SERIF": "Futura+Light,sans-serif",
          "BRANDON_GROT_W01_LIGHT": "brandon-grot-w01-light",
          "BRANDON_GROTESQUE": "Brandon+Grotesque",
          "BRANDON_GROTESQUE_SANS_SERIF": "Brandon+Grotesque,sans-serif",
          "AVENIR_LT_W01_85_HEAVY1475544": "avenir-lt-w01_85-heavy1475544",
          "AVENIR": "Avenir",
          "AVENIR_SANS_SERIF": "Avenir,sans-serif",
          "AVENIR_LT_W01_35_LIGHT1475496": "avenir-lt-w01_35-light1475496",
          "AVENIR_LIGHT": "Avenir+Light",
          "AVENIR_LIGHT_SANS_SERIF": "Avenir+Light,sans-serif",
          "DIDOT_W01_ITALIC": "didot-w01-italic",
          "LINOTYPE_DIDOT": "Linotype+Didot",
          "LINOTYPE_DIDOT_SERIF": "Linotype+Didot,serif",
          "ADOBE_CASLON_W01_SMBD": "adobe-caslon-w01-smbd",
          "ADOBE_CASLON": "Adobe+Caslon",
          "ADOBE_CASLON_SERIF": "Adobe+Caslon,serif",
          "KEPLER_W03_LIGHT_SCD_CP": "kepler-w03-light-scd-cp",
          "KEPLER": "Kepler",
          "KEPLER_SERIF": "Kepler,serif",
          "BASKERVILLEMTW01_SMBDIT": "baskervillemtw01-smbdit",
          "MONOTYPE_BASKERVILLE": "Monotype+Baskerville",
          "MONOTYPE_BASKERVILLE_SERIF": "Monotype+Baskerville,serif",
          "BELINDA_W00_REGULAR": "belinda-w00-regular",
          "BELINDA": "Belinda",
          "BELINDA_SCRIPT": "Belinda,script",
          "HELVETICANEUEW01_55ROMA": "helveticaneuew01-55roma",
          "HELVETICA_55": "Helvetica+55",
          "HELVETICA_55_SANS_SERIF": "Helvetica+55,sans-serif",
          "PEACHES_AND_CREAM_REGULAR_W00": "peaches-and-cream-regular-w00",
          "PEACHES_AND_CREAM": "Peaches+&+Cream",
          "PEACHES_AND_CREAM_SCRIPT": "Peaches+&+Cream,script",
          "DINNEUZEITGROTESKLTW01__812426": "dinneuzeitgroteskltw01-_812426",
          "DIN_NEUZEIT_GROTESK": "DIN+Neuzeit+Grotesk",
          "DIN_NEUZEIT_GROTESK_SANS_SERIF": "DIN+Neuzeit+Grotesk,sans-serif",
          "ROBOTO_THIN": "roboto-thin",
          "ROBOTO_THIN_2": "Roboto+Thin",
          "ROBOTO_THIN_SANS_SERIF": "Roboto+Thin,sans-serif",
          "ROBOTO": "roboto",
          "ROBOTO_BOLD": "roboto-bold",
          "ROBOTO_BOLD_2": "Roboto+Bold",
          "ROBOTO_BOLD_SANS_SERIF": "Roboto+Bold,sans-serif",
          "ROBOTO_2": "Roboto",
          "ROBOTO_SANS_SERIF": "Roboto,sans-serif",
          "WORKSANS_EXTRALIGHT": "worksans-extralight",
          "WORK_SANS_EXTRA_LIGHT": "Work+Sans+Extra+Light",
          "WORK_SANS_EXTRA_LIGHT_SANS_SERIF": "Work+Sans+Extra+Light,sans-serif",
          "WORK_SANS": "work+sans",
          "WORKSANS_SEMIBOLD": "worksans-semibold",
          "WORK_SANS_SEMI_BOLD": "Work+Sans+Semi+Bold",
          "WORK_SANS_SEMI_BOLD_SANS_SERIF": "Work+Sans+Semi+Bold,sans-serif",
          "POPPINS_EXTRALIGHT": "poppins-extralight",
          "POPPINS_EXTRA_LIGHT": "Poppins+Extra+Light",
          "POPPINS_EXTRA_LIGHT_SANS_SERIF": "Poppins+Extra+Light,sans-serif",
          "POPPINS": "poppins",
          "POPPINS_SEMIBOLD": "poppins-semibold",
          "POPPINS_SEMI_BOLD": "Poppins+Semi+Bold",
          "POPPINS_SEMI_BOLD_SANS_SERIF": "Poppins+Semi+Bold,sans-serif",
          "BARLOW_EXTRALIGHT": "barlow-extralight",
          "BARLOW_EXTRA_LIGHT": "Barlow+Extra+Light",
          "BARLOW_EXTRA_LIGHT_SANS_SERIF": "Barlow+Extra+Light,sans-serif",
          "BARLOW": "barlow",
          "BARLOW_MEDIUM": "barlow-medium",
          "BARLOW_MEDIUM_2": "Barlow+Medium",
          "BARLOW_MEDIUM_SANS_SERIF": "Barlow+Medium,sans-serif",
          "OSWALD_EXTRALIGHT": "oswald-extralight",
          "OSWALD_EXTRA_LIGHT": "Oswald+Extra+Light",
          "OSWALD_EXTRA_LIGHT_SANS_SERIF": "Oswald+Extra+Light,sans-serif",
          "OSWALD": "oswald",
          "OSWALD_MEDIUM": "oswald-medium",
          "OSWALD_MEDIUM_2": "Oswald+Medium",
          "OSWALD_MEDIUM_SANS_SERIF": "Oswald+Medium,sans-serif",
          "OSWALD_2": "Oswald",
          "OSWALD_SANS_SERIF": "Oswald,sans-serif",
          "CORMORANTGARAMOND_LIGHT": "cormorantgaramond-light",
          "CORMORANT_GARAMOND_LIGHT": "Cormorant+Garamond+Light",
          "CORMORANT_GARAMOND_LIGHT_SERIF": "Cormorant+Garamond+Light,serif",
          "CORMORANT_GARAMOND": "cormorant+garamond",
          "CORMORANTGARAMOND_SEMIBOLD": "cormorantgaramond-semibold",
          "CORMORANT_GARAMOND_SEMI_BOLD": "Cormorant+Garamond+Semi+Bold",
          "CORMORANT_GARAMOND_SEMI_BOLD_SERIF": "Cormorant+Garamond+Semi+Bold,serif",
          "CORMORANTGARAMOND": "cormorantgaramond",
          "CORMORANT_GARAMOND_2": "Cormorant+Garamond",
          "CORMORANT_GARAMOND_SERIF": "Cormorant+Garamond,serif",
          "PLAYFAIRDISPLAY_BOLD": "playfairdisplay-bold",
          "PLAYFAIR_DISPLAY_BOLD": "Playfair+Display+Bold",
          "PLAYFAIR_DISPLAY_BOLD_SERIF": "Playfair+Display+Bold,serif",
          "DANCINGSCRIPT_REGULAR": "dancingscript-regular",
          "DANCING_SCRIPT_REGULAR": "Dancing+Script+Regular",
          "DANCING_SCRIPT_REGULAR_CURSIVE": "Dancing+Script+Regular,cursive",
          "DANCING_SCRIPT": "dancing+script",
          "DAMION": "damion",
          "DAMION_2": "Damion",
          "DAMION_CURSIVE": "Damion,cursive",
          "SUEZ_ONE": "suez+one",
          "SUEZ_ONE_2": "Suez+One",
          "SUEZ_ONE_SERIF": "Suez+One,serif",
          "ROZHA_ONE": "rozha+one",
          "ROZHA_ONE_2": "Rozha+One",
          "ROZHA_ONE_SERIF": "Rozha+One,serif",
          "RALEWAY_SEMIBOLD": "raleway-semibold",
          "RALEWAY_SEMI_BOLD": "Raleway+Semi+Bold",
          "RALEWAY_SEMI_BOLD_SANS_SERIF": "Raleway+Semi+Bold,sans-serif",
          "LATO_LIGHT": "lato-light",
          "LATO_LIGHT_2": "Lato+Light",
          "LATO_LIGHT_SANS_SERIF": "Lato+Light,sans-serif",
          "LATO": "lato",
          "QUESTRIAL": "questrial",
          "QUESTRIAL_2": "Questrial",
          "QUESTRIAL_SANS_SERIF": "Questrial,sans-serif",
          "AUGUST_BOLD": "august-bold",
          "AUGUST_BOLD_2": "August+Bold",
          "AUGUST_BOLD_SANS_SERIF": "August+Bold,sans-serif",
          "AUGUST_LIGHT": "august-light",
          "AUGUST_LIGHT_2": "August+Light",
          "AUGUST_LIGHT_SANS_SERIF": "August+Light,sans-serif",
          "AUGUST_MEDIUM": "august-medium",
          "AUGUST_MEDIUM_2": "August+Medium",
          "AUGUST_MEDIUM_SANS_SERIF": "August+Medium,sans-serif",
          "KNEDGE_BOLD": "knedge-bold",
          "KNEDGE_BOLD_2": "Knedge+Bold",
          "KNEDGE_BOLD_SERIF": "Knedge+Bold,serif",
          "MONTSERRAT": "montserrat",
          "MONTSERRAT_2": "Montserrat",
          "MONTSERRAT_SANS_SERIF": "Montserrat,sans-serif",
          "TSUKUSHIGOTHIC": "tsukushigothic",
          "JP_TSUKUSHIGOTHIC": "筑紫ゴシック",
          "JP_TSUKUSHIGOTHIC_SANS_SERIF": "筑紫ゴシック,sans-serif",
          "RODIN_LIGHT": "rodin-light",
          "JP_RODIN_L": "ロダン+L",
          "JP_RODIN_L_SANS_SERIF": "ロダン+L,sans-serif",
          "RODIN_DEMI_BOLD": "rodin-demi-bold",
          "JP_RODIN_M": "ロダン+M",
          "JP_RODIN_M_SANS_SERIF": "ロダン+M,sans-serif",
          "NEWCEZANNE": "newcezanne",
          "JP_NEWCEZANNE": "ニューセザンヌ",
          "JP_NEWCEZANNE_SANS_SERIF": "ニューセザンヌ,sans-serif",
          "UDKAKUGOLARGE": "udkakugolarge",
          "JP_UDKAKUGOLARGE": "UD角ゴ_ラージ",
          "JP_UDKAKUGOLARGE_SANS_SERIF": "UD角ゴ_ラージ,sans-serif",
          "TSUKUSHIMARUGOTHIC": "tsukushimarugothic",
          "JP_TSUKUSHIMARUGOTHIC": "筑紫A丸ゴシック",
          "JP_TSUKUSHIMARUGOTHIC_SANS_SERIF": "筑紫A丸ゴシック,sans-serif",
          "SEURAT": "seurat",
          "JP_SEURAT": "スーラ",
          "JP_SEURAT_SANS_SERIF": "スーラ,sans-serif",
          "TSUKUSHIBMARUGOTHIC": "tsukushibmarugothic",
          "JP_TSUKUSHIBMARUGOTHIC": "筑紫B丸ゴシック",
          "JP_TSUKUSHIBMARUGOTHIC_SANS_SERIF": "筑紫B丸ゴシック,sans-serif",
          "UDMINCHO": "udmincho",
          "JP_UDMINCHO": "UD明朝",
          "JP_UDMINCHO_SERIF": "UD明朝,serif",
          "TSUKUSHIOLDMINCHO": "tsukushioldmincho",
          "JP_TSUKUSHIOLDMINCHO": "筑紫Aオールド明朝",
          "TSUKUSHIOLDMINCHO_SERIF": "筑紫Aオールド明朝,serif",
          "MATISSE": "matisse",
          "JP_MATISSE": "マティス",
          "JP_MATISSE_SERIF": "マティス,serif",
          "SKIP": "skip",
          "JP_SKIP": "スキップ",
          "JP_SKIP_SANS_SERIF": "スキップ,sans-serif",
          "COOKHAND": "cookhand",
          "JP_COOKHAND": "クックハンド",
          "JP_COOKHAND_SANS_SERIF": "クックハンド,sans-serif",
          "MADEFOR_DISPLAY": "madefor-display",
          "WIX_MADEFOR_DISPLAY": "Wix+Madefor+Display",
          "WIX_MADEFOR_DISPLAY_SANS_SERIF": "Wix+Madefor+Display,sans-serif",
          "MADEFOR_DISPLAY_BOLD": "madefor-display-bold",
          "WIX_MADEFOR_DISPLAY_BOLD": "Wix+Madefor+Display+Bold",
          "WIX_MADEFOR_DISPLAY_BOLD_SANS_SERIF": "Wix+Madefor+Display+Bold,sans-serif",
          "MADEFOR_DISPLAY_EXTRABOLD": "madefor-display-extrabold",
          "WIX_MADEFOR_DISPLAY_XBOLD": "Wix+Madefor+Display+XBold",
          "WIX_MADEFOR_DISPLAY_XBOLD_SANS_SERIF": "Wix+Madefor+Display+XBold,sans-serif",
          "MADEFOR_TEXT": "madefor-text",
          "WIX_MADEFOR_TEXT": "Wix+Madefor+Text",
          "WIX_MADEFOR_TEXT_SANS_SERIF": "Wix+Madefor+Text,sans-serif",
          "MADEFOR_TEXT_MEDIUMBOLD": "madefor-text-mediumbold",
          "WIX_MADEFOR_TEXT_MEDIUM": "Wix+Madefor+Text+Medium",
          "WIX_MADEFOR_TEXT_MEDIUM_SANS_SERIF": "Wix+Madefor+Text+Medium,sans-serif",
          "MADEFOR_TEXT_BOLD": "madefor-text-bold",
          "WIX_MADEFOR_TEXT_BOLD": "Wix+Madefor+Text+Bold",
          "WIX_MADEFOR_TEXT_BOLD_SANS_SERIF": "Wix+Madefor+Text+Bold,sans-serif",
          "MADEFOR_TEXT_EXTRABOLD": "madefor-text-extrabold",
          "WIX_MADEFOR_TEXT_XBOLD": "Wix+Madefor+Text+XBold",
          "WIX_MADEFOR_TEXT_XBOLD_SANS_SERIF": "Wix+Madefor+Text+XBold,sans-serif",
          "FAHKWANG": "fahkwang",
          "FAHKWANG_2": "Fahkwang",
          "FAHKWANG_SANS_SERIF": "Fahkwang,sans-serif",
          "FRAUNCES": "fraunces",
          "FRAUNCES_2": "Fraunces",
          "FRAUNCES_SERIF": "Fraunces,serif",
          "SYNE": "syne",
          "SYNE_2": "Syne",
          "SYNE_SANS_SERIF": "Syne,sans-serif",
          "SPACE_GROTESK": "space+grotesk",
          "SPACE_GROTESK_2": "Space+Grotesk",
          "SPACE_GROTESK_SANS_SERIF": "Space+Grotesk,sans-serif",
          "QUICKSAND": "quicksand",
          "QUICKSAND_2": "Quicksand",
          "QUICKSAND_SANS_SERIF": "Quicksand,sans-serif",
          "NOBILE": "nobile",
          "NOBILE_2": "Nobile",
          "NOBILE_SANS_SERIF": "Nobile,sans-serif",
          "INKNUT_ANTIQUA": "inknut+antiqua",
          "INKNUT_ANTIQUA_2": "Inknut+Antiqua",
          "INKNUT_ANTIQUA_SERIF": "Inknut+Antiqua,serif",
          "CAVEAT": "caveat",
          "CAVEAT_2": "Caveat",
          "CAVEAT_CURSIVE": "Caveat,cursive",
          "MARMELAD": "marmelad",
          "MARMELAD_2": "Marmelad",
          "MARMELAD_SANS_SERIF": "Marmelad,sans-serif",
          "KANIT": "kanit",
          "KANIT_2": "Kanit",
          "KANIT_SANS_SERIF": "Kanit,sans-serif",
          "PROMPT": "prompt",
          "PROMPT_2": "Prompt",
          "PROMPT_SANS_SERIF": "Prompt,sans-serif",
          "MITR": "mitr",
          "MITR_2": "Mitr",
          "MITR_SANS_SERIF": "Mitr,sans-serif",
          "SARABUN": "sarabun",
          "SARABUN_2": "Sarabun",
          "SARABUN_SANS_SERIF": "Sarabun,sans-serif",
          "K2D": "k2d",
          "K2D_2": "K2D",
          "K2D_SANS_SERIF": "K2D,sans-serif",
          "PRIDI": "pridi",
          "PRIDI_2": "Pridi",
          "PRIDI_SERIF": "Pridi,serif",
          "TRIRONG": "trirong",
          "TRIRONG_2": "Trirong",
          "TRIRONG_SERIF": "Trirong,serif",
          "MAITREE": "maitree",
          "MAITREE_2": "Maitree",
          "MAITREE_SERIF": "Maitree,serif",
          "SRIRACHA": "sriracha",
          "SRIRACHA_2": "Sriracha",
          "SRIRACHA_CURSIVE": "Sriracha,cursive",
          "KODCHASAN": "kodchasan",
          "KODCHASAN_2": "Kodchasan",
          "KODCHASAN_SERIF": "Kodchasan,serif",
          "BAI_JAMJUREE": "bai+jamjuree",
          "BAI_JAMJUREE_2": "Bai+Jamjuree",
          "BAI_JAMJUREE_SANS_SERIF": "Bai+Jamjuree,sans-serif",
          "VARELA_ROUND": "varela+round",
          "VARELA_ROUND_2": "Varela+Round",
          "VARELA_ROUND_SANS_SERIF": "Varela+Round,sans-serif",
          "SECULAR_ONE": "secular+one",
          "SECULAR_ONE_2": "Secular+One",
          "SECULAR_ONE_SANS_SERIF": "Secular+One,sans-serif",
          "FRAUNCES_120PT_LIGHT": "fraunces_120pt-light",
          "FRAUNCES_120_LIGHT": "Fraunces+120+Light",
          "FRAUNCES_120_LIGHT_SERIF": "Fraunces+120+Light,serif",
          "FRAUNCES_120PT_SEMIBOLD": "fraunces_120pt-semibold",
          "FRAUNCES_120_SEMI_BOLD": "Fraunces+120+Semi+Bold",
          "FRAUNCES_120_SEMI_BOLD_SERIF": "Fraunces+120+Semi+Bold,serif",
          "HEEBO_LIGHT": "heebo-light",
          "HEEBO_LIGHT_2": "Heebo+Light",
          "HEEBO_LIGHT_SANS_SERIF": "Heebo+Light,sans-serif",
          "HEEBO_MEDIUM": "heebo-medium",
          "HEEBO_MEDIUM_2": "Heebo+Medium",
          "HEEBO_MEDIUM_SANS_SERIF": "Heebo+Medium,sans-serif",
          "RUBIK_LIGHT": "rubik-light",
          "RUBIK_LIGHT_2": "Rubik+Light",
          "RUBIK_LIGHT_SANS_SERIF": "Rubik+Light,sans-serif",
          "RUBIK_MEDIUM": "rubik-medium",
          "RUBIK_MEDIUM_2": "Rubik+Medium",
          "RUBIK_MEDIUM_SANS_SERIF": "Rubik+Medium,sans-serif",
          "ASSISTANT_LIGHT": "assistant-light",
          "ASSISTANT_LIGHT_2": "Assistant+Light",
          "ASSISTANT_LIGHT_SANS_SERIF": "Assistant+Light,sans-serif",
          "ASSISTANT_SEMIBOLD": "assistant-semibold",
          "ASSISTANT_SEMI_BOLD": "Assistant+Semi+Bold",
          "ASSISTANT_SEMI_BOLD_SANS_SERIF": "Assistant+Semi+Bold,sans-serif",
          "KARANTINA_LIGHT": "karantina-light",
          "KARANTINA_LIGHT_2": "Karantina+Light",
          "KARANTINA_LIGHT_CURSIVE": "Karantina+Light,cursive"
        }
      },
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TextThemeWithDefaults": {
      "enums": {
        "fontStyle": {
          "NORMAL": "normal",
          "ITALIC": "italic"
        },
        "fontWeight": {
          "NORMAL": "normal",
          "BOLD": "bold",
          "BOLDER": "bolder",
          "LIGHTER": "lighter",
          "_100": "100",
          "_200": "200",
          "_300": "300",
          "_400": "400",
          "_500": "500",
          "_600": "600",
          "_700": "700",
          "_800": "800",
          "_900": "900"
        },
        "fontVariant": {
          "NORMAL": "normal",
          "SMALL_CAPS": "small-caps",
          "INHERIT": "inherit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TopLevelStyle": {
      "enums": {
        "styleType": {
          "SYSTEM": "system",
          "CUSTOM": "custom",
          "USERDEFINED": "userDefined"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ComponentStyle": {
      "enums": {
        "styleType": {
          "CUSTOM": "custom"
        },
        "resolverType": {
          "SCALE": "scale",
          "FIXED": "fixed"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GlobalStylesCollection": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StyleObjectDefinition": {
      "enums": {
        "styleType": {
          "SYSTEM": "system",
          "CUSTOM": "custom",
          "USERDEFINED": "userDefined"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RefArray": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VariantRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [
        "variants",
        "remoteVariants",
        "from"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [
        "breakpoint"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinearLayer": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleLayer": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseLayer": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientMeshLayer": {
      "enums": {
        "type": {
          "GRADIENTMESH": "GradientMesh",
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConicLayer": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColorLayer": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MinimalUnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SPXReferenceDefinition": {
      "enums": {
        "resolverType": {
          "SCALE": "scale",
          "FIXED": "fixed"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLength": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLengthPercentage": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitAngle": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizeArea": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizePoint": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointsData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRange": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "NumberThatCanConnectToAVariable": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkReference": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_Image": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_SVGItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ColorLayers": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinear": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircle": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipse": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConic": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColor": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BlendMode": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientColorStop": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientAngularColorStop": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    }
  },
  "design": {
    "$id": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MediaContainerDesignData": {
      "enums": {
        "top": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "right": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "bottom": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "left": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "unit": {
          "%": "%"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {
        "unit": [
          {
            "PX": "px",
            "CM": "cm",
            "MM": "mm",
            "Q": "q",
            "IN": "in",
            "PT": "pt",
            "PC": "pc"
          },
          {
            "EM": "em",
            "EX": "ex",
            "CH": "ch",
            "REM": "rem",
            "VW": "vw",
            "VH": "vh",
            "VMIN": "vmin",
            "VMAX": "vmax"
          }
        ]
      },
      "floatToInt": [],
      "convertToString": []
    },
    "MediaContainerWithDividers": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ShapeDivider": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "pin": {
          "IN": "in",
          "OUT": "out"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MediaPlayerDesignData": {
      "enums": {
        "top": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "right": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "bottom": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "left": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "unit": {
          "%": "%"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {
        "unit": [
          {
            "PX": "px",
            "CM": "cm",
            "MM": "mm",
            "Q": "q",
            "IN": "in",
            "PT": "pt",
            "PC": "pc"
          },
          {
            "EM": "em",
            "EX": "ex",
            "CH": "ch",
            "REM": "rem",
            "VW": "vw",
            "VH": "vh",
            "VMIN": "vmin",
            "VMAX": "vmax"
          }
        ]
      },
      "floatToInt": [],
      "convertToString": []
    },
    "TextFxDesign": {
      "enums": {
        "align": {
          "START": "start",
          "MIDDLE": "middle",
          "END": "end"
        },
        "weight": {
          "NORMAL": "normal",
          "BOLD": "bold",
          "_100": "100",
          "_200": "200",
          "_300": "300",
          "_400": "400",
          "_500": "500",
          "_600": "600",
          "_700": "700",
          "_800": "800",
          "_900": "900"
        },
        "style": {
          "NORMAL": "normal",
          "ITALIC": "italic"
        },
        "decoration": {
          "NONE": "none",
          "UNDERLINE": "underline",
          "LINE_THROUGH": "line-through"
        },
        "transform": {
          "NONE": "none",
          "CAPITALIZE": "capitalize",
          "UPPERCASE": "uppercase",
          "LOWERCASE": "lowercase"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TextFxMask": {
      "enums": {
        "align": {
          "START": "start",
          "MIDDLE": "middle",
          "END": "end"
        },
        "weight": {
          "NORMAL": "normal",
          "BOLD": "bold",
          "_100": "100",
          "_200": "200",
          "_300": "300",
          "_400": "400",
          "_500": "500",
          "_600": "600",
          "_700": "700",
          "_800": "800",
          "_900": "900"
        },
        "style": {
          "NORMAL": "normal",
          "ITALIC": "italic"
        },
        "decoration": {
          "NONE": "none",
          "UNDERLINE": "underline",
          "LINE_THROUGH": "line-through"
        },
        "transform": {
          "NONE": "none",
          "CAPITALIZE": "capitalize",
          "UPPERCASE": "uppercase",
          "LOWERCASE": "lowercase"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "mediaFlip": {
          "NONE": "none",
          "HORIZONTAL": "horizontal",
          "VERTICAL": "vertical",
          "BOTH": "both"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "TextFxPath": {
      "enums": {
        "align": {
          "START": "start",
          "MIDDLE": "middle",
          "END": "end"
        },
        "weight": {
          "NORMAL": "normal",
          "BOLD": "bold",
          "_100": "100",
          "_200": "200",
          "_300": "300",
          "_400": "400",
          "_500": "500",
          "_600": "600",
          "_700": "700",
          "_800": "800",
          "_900": "900"
        },
        "style": {
          "NORMAL": "normal",
          "ITALIC": "italic"
        },
        "decoration": {
          "NONE": "none",
          "UNDERLINE": "underline",
          "LINE_THROUGH": "line-through"
        },
        "transform": {
          "NONE": "none",
          "CAPITALIZE": "capitalize",
          "UPPERCASE": "uppercase",
          "LOWERCASE": "lowercase"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "verticalAlign": {
          "TOP": "top",
          "MIDDLE": "middle",
          "BOTTOM": "bottom"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "css-keyword": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "css-percentage": {
      "enums": {
        "unit": {
          "%": "%"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "css-absolute-length-unit": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "css-relative-length-unit": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "css-length": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {
        "unit": [
          {
            "PX": "px",
            "CM": "cm",
            "MM": "mm",
            "Q": "q",
            "IN": "in",
            "PT": "pt",
            "PC": "pc"
          },
          {
            "EM": "em",
            "EX": "ex",
            "CH": "ch",
            "REM": "rem",
            "VW": "vw",
            "VH": "vh",
            "VMIN": "vmin",
            "VMAX": "vmax"
          }
        ]
      },
      "floatToInt": [],
      "convertToString": []
    },
    "css-length-or-percentage": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "css-byte": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "css-color": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "css-box-shadow": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "css-border-radius": {
      "enums": {
        "unit": {
          "%": "%"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {
        "unit": [
          {
            "PX": "px",
            "CM": "cm",
            "MM": "mm",
            "Q": "q",
            "IN": "in",
            "PT": "pt",
            "PC": "pc"
          },
          {
            "EM": "em",
            "EX": "ex",
            "CH": "ch",
            "REM": "rem",
            "VW": "vw",
            "VH": "vh",
            "VMIN": "vmin",
            "VMAX": "vmax"
          }
        ]
      },
      "floatToInt": [],
      "convertToString": []
    },
    "css-br-width": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "css-border-width": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {
        "unit": [
          {
            "PX": "px",
            "CM": "cm",
            "MM": "mm",
            "Q": "q",
            "IN": "in",
            "PT": "pt",
            "PC": "pc"
          },
          {
            "EM": "em",
            "EX": "ex",
            "CH": "ch",
            "REM": "rem",
            "VW": "vw",
            "VH": "vh",
            "VMIN": "vmin",
            "VMAX": "vmax"
          }
        ]
      },
      "floatToInt": [],
      "convertToString": []
    },
    "css-br-style": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "css-border-style": {
      "enums": {
        "top": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "right": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "bottom": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "left": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "css-border-color": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "css-border": {
      "enums": {
        "top": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "right": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "bottom": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "left": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {
        "unit": [
          {
            "PX": "px",
            "CM": "cm",
            "MM": "mm",
            "Q": "q",
            "IN": "in",
            "PT": "pt",
            "PC": "pc"
          },
          {
            "EM": "em",
            "EX": "ex",
            "CH": "ch",
            "REM": "rem",
            "VW": "vw",
            "VH": "vh",
            "VMIN": "vmin",
            "VMAX": "vmax"
          }
        ]
      },
      "floatToInt": [],
      "convertToString": []
    },
    "cssBorder": {
      "enums": {
        "top": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "right": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "bottom": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "left": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {
        "unit": [
          {
            "PX": "px",
            "CM": "cm",
            "MM": "mm",
            "Q": "q",
            "IN": "in",
            "PT": "pt",
            "PC": "pc"
          },
          {
            "EM": "em",
            "EX": "ex",
            "CH": "ch",
            "REM": "rem",
            "VW": "vw",
            "VH": "vh",
            "VMIN": "vmin",
            "VMAX": "vmax"
          }
        ]
      },
      "floatToInt": [],
      "convertToString": []
    },
    "cssBorderRadius": {
      "enums": {
        "unit": {
          "%": "%"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {
        "unit": [
          {
            "PX": "px",
            "CM": "cm",
            "MM": "mm",
            "Q": "q",
            "IN": "in",
            "PT": "pt",
            "PC": "pc"
          },
          {
            "EM": "em",
            "EX": "ex",
            "CH": "ch",
            "REM": "rem",
            "VW": "vw",
            "VH": "vh",
            "VMIN": "vmin",
            "VMAX": "vmax"
          }
        ]
      },
      "floatToInt": [],
      "convertToString": []
    },
    "cssBoxShadow": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "cssStyle": {
      "enums": {
        "top": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "right": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "bottom": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "left": {
          "NONE": "none",
          "HIDDEN": "hidden",
          "DOTTED": "dotted",
          "DASHED": "dashed",
          "SOLID": "solid",
          "DOUBLE": "double",
          "GROOVE": "groove",
          "RIDGE": "ridge",
          "INSET": "inset",
          "OUTSET": "outset"
        },
        "unit": {
          "%": "%"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {
        "unit": [
          {
            "PX": "px",
            "CM": "cm",
            "MM": "mm",
            "Q": "q",
            "IN": "in",
            "PT": "pt",
            "PC": "pc"
          },
          {
            "EM": "em",
            "EX": "ex",
            "CH": "ch",
            "REM": "rem",
            "VW": "vw",
            "VH": "vh",
            "VMIN": "vmin",
            "VMAX": "vmax"
          }
        ]
      },
      "floatToInt": [],
      "convertToString": []
    },
    "LayersEffect": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "pin": {
          "IN": "in",
          "OUT": "out"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "dataChangeBehaviors": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BackgroundMedia": {
      "enums": {
        "color": {
          "TRANSPARENT": "transparent",
          "NOCOLOR": "noColor"
        },
        "alignType": {
          "TOP": "top",
          "BOTTOM": "bottom",
          "LEFT": "left",
          "RIGHT": "right",
          "CENTER": "center",
          "TOP_LEFT": "top_left",
          "TOP_RIGHT": "top_right",
          "BOTTOM_LEFT": "bottom_left",
          "BOTTOM_RIGHT": "bottom_right"
        },
        "fittingType": {
          "FILL": "fill",
          "FIT": "fit",
          "STRETCH": "stretch",
          "ACTUAL_SIZE": "actual_size",
          "ORIGINAL_SIZE": "original_size",
          "TILE": "tile",
          "TILE_HORIZONTAL": "tile_horizontal",
          "TILE_VERTICAL": "tile_vertical",
          "FIT_AND_TILE": "fit_and_tile",
          "LEGACY_TILE": "legacy_tile",
          "LEGACY_TILE_HORIZONTAL": "legacy_tile_horizontal",
          "LEGACY_TILE_VERTICAL": "legacy_tile_vertical",
          "LEGACY_NORMAL": "legacy_normal"
        },
        "scrollType": {
          "NONE": "none",
          "FIXED": "fixed",
          "SCROLL": "scroll",
          "LOCAL": "local",
          "PARALLAX": "parallax"
        },
        "showOverlayForMediaType": {
          "ALL": "all",
          "WIXVIDEO": "WixVideo",
          "IMAGE": "Image"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "effectType": {
          "NONE": "none",
          "NORMAL": "normal",
          "INK": "ink",
          "KENNEDY": "kennedy",
          "FEATHERED": "feathered",
          "BLUR": "blur",
          "WHISTLER": "whistler",
          "_3D": "3d",
          "BLUERAY": "blueray",
          "LIGHTEN": "lighten",
          "DARKEN": "darken",
          "PINKRINSE": "pinkrinse",
          "REDRUM": "redrum",
          "GREENWASH": "greenwash",
          "YELLOWSTREAK": "yellowstreak",
          "NEONSKY": "neonsky",
          "SEAWEED": "seaweed",
          "SOLEDAD": "soledad",
          "SANGRIA": "sangria",
          "MALIBU": "malibu",
          "CANDYFLOSS": "candyfloss",
          "ELMO": "elmo",
          "UNICORN": "unicorn",
          "KEROUAC": "kerouac",
          "KOOLAID": "koolaid",
          "HYDRA": "hydra",
          "PIXIE": "pixie",
          "NIGHTRAIN": "nightrain",
          "BAUHAUS": "bauhaus",
          "NEPTUNE": "neptune",
          "ORCA": "orca",
          "MANHATTAN": "manhattan",
          "GOLDIE": "goldie",
          "FLAMINGO": "flamingo",
          "FADED": "faded",
          "GOTHAM": "gotham",
          "HULK": "hulk",
          "MIDNIGHT": "midnight",
          "LUCILLE": "lucille",
          "ORGANIC": "organic",
          "GRAYSCALE": "grayscale",
          "TVDUOTONE": "tvDuotone",
          "TVMONOTONEDARK": "tvMonotoneDark",
          "TVMONOTONELIGHT": "tvMonotoneLight",
          "TVHUE": "tvHue"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BlendMode": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Shadow": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "filterEffect": {
      "enums": {
        "effectType": {
          "NONE": "none",
          "NORMAL": "normal",
          "INK": "ink",
          "KENNEDY": "kennedy",
          "FEATHERED": "feathered",
          "BLUR": "blur",
          "WHISTLER": "whistler",
          "_3D": "3d",
          "BLUERAY": "blueray",
          "LIGHTEN": "lighten",
          "DARKEN": "darken",
          "PINKRINSE": "pinkrinse",
          "REDRUM": "redrum",
          "GREENWASH": "greenwash",
          "YELLOWSTREAK": "yellowstreak",
          "NEONSKY": "neonsky",
          "SEAWEED": "seaweed",
          "SOLEDAD": "soledad",
          "SANGRIA": "sangria",
          "MALIBU": "malibu",
          "CANDYFLOSS": "candyfloss",
          "ELMO": "elmo",
          "UNICORN": "unicorn",
          "KEROUAC": "kerouac",
          "KOOLAID": "koolaid",
          "HYDRA": "hydra",
          "PIXIE": "pixie",
          "NIGHTRAIN": "nightrain",
          "BAUHAUS": "bauhaus",
          "NEPTUNE": "neptune",
          "ORCA": "orca",
          "MANHATTAN": "manhattan",
          "GOLDIE": "goldie",
          "FLAMINGO": "flamingo",
          "FADED": "faded",
          "GOTHAM": "gotham",
          "HULK": "hulk",
          "MIDNIGHT": "midnight",
          "LUCILLE": "lucille",
          "ORGANIC": "organic",
          "GRAYSCALE": "grayscale",
          "TVDUOTONE": "tvDuotone",
          "TVMONOTONEDARK": "tvMonotoneDark",
          "TVMONOTONELIGHT": "tvMonotoneLight",
          "TVHUE": "tvHue"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "overlayBlending": {
      "enums": {
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BackgroundTransforms": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ImageMask": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        },
        "mode": {
          "ALPHA": "alpha",
          "LUMINANCE": "luminance"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WixVideo": {
      "enums": {
        "format": {
          "MP4": "mp4",
          "WEBM": "webm",
          "HLS": "hls",
          "DASH": "dash"
        },
        "preload": {
          "AUTO": "auto",
          "METADATA": "metadata",
          "NONE": "none"
        },
        "controls": {
          "NONE": "none",
          "FULL": "full"
        },
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        },
        "mode": {
          "ALPHA": "alpha",
          "LUMINANCE": "luminance"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Video": {
      "enums": {
        "videoType": {
          "YOUTUBE": "YOUTUBE",
          "VIMEO": "VIMEO",
          "FACEBOOK": "FACEBOOK",
          "DAILYMOTION": "DAILYMOTION"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RepeatedData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Image": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        }
      },
      "links": [
        "link"
      ],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MediaControlsDesignData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ControlIconDesignData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VectorImageDesignData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientMesh": {
      "enums": {
        "type": {
          "GRADIENTMESH": "GradientMesh"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RefArray": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VariantRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [
        "variants",
        "remoteVariants",
        "from"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinearLayer": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleLayer": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseLayer": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientMeshLayer": {
      "enums": {
        "type": {
          "GRADIENTMESH": "GradientMesh",
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConicLayer": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColorLayer": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MinimalUnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SPXReferenceDefinition": {
      "enums": {
        "resolverType": {
          "SCALE": "scale",
          "FIXED": "fixed"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLength": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLengthPercentage": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitAngle": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizeArea": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizePoint": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointsData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRange": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "NumberThatCanConnectToAVariable": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkReference": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_Image": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_SVGItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ColorLayers": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinear": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircle": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipse": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConic": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColor": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientColorStop": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientAngularColorStop": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    }
  },
  "source": {
    "$id": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Source": {
      "enums": {
        "original": {
          "TEMPLATE": "template",
          "PRESET": "preset",
          "USER": "user",
          "APPLICATION": "application",
          "TRANSLATION": "translation",
          "CAAS": "caas",
          "AI": "ai"
        },
        "current": {
          "TEMPLATE": "template",
          "PRESET": "preset",
          "USER": "user",
          "APPLICATION": "application",
          "TRANSLATION": "translation",
          "CAAS": "caas",
          "AI": "ai"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SourceEnumType": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RefArray": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VariantRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MinimalUnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SPXReferenceDefinition": {
      "enums": {
        "resolverType": {
          "SCALE": "scale",
          "FIXED": "fixed"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLength": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLengthPercentage": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitAngle": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizeArea": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizePoint": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointsData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRange": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "NumberThatCanConnectToAVariable": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkReference": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_Image": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_SVGItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ColorLayers": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinearLayer": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleLayer": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseLayer": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientMeshLayer": {
      "enums": {
        "type": {
          "GRADIENTMESH": "GradientMesh",
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConicLayer": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColorLayer": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinear": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircle": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipse": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConic": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColor": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BlendMode": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientColorStop": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientAngularColorStop": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    }
  },
  "classnames": {
    "$id": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Classnames": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RefArray": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VariantRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MinimalUnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SPXReferenceDefinition": {
      "enums": {
        "resolverType": {
          "SCALE": "scale",
          "FIXED": "fixed"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLength": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLengthPercentage": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitAngle": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizeArea": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizePoint": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointsData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRange": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "NumberThatCanConnectToAVariable": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkReference": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_Image": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_SVGItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ColorLayers": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinearLayer": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleLayer": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseLayer": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientMeshLayer": {
      "enums": {
        "type": {
          "GRADIENTMESH": "GradientMesh",
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConicLayer": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColorLayer": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinear": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircle": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipse": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConic": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColor": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BlendMode": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientColorStop": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientAngularColorStop": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    }
  },
  "layout": {
    "$id": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "KeywordSize": {
      "enums": {
        "type": {
          "AUTO": "auto",
          "MAXCONTENT": "maxContent",
          "MINCONTENT": "minContent",
          "UNSET": "unset",
          "FIT": "fit"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Calculation": {
      "enums": {
        "type": {
          "CALC": "Calc"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "CalculationFormula": {
      "enums": {
        "type": {
          "CALCFORMULA": "CalcFormula"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AspectRatioSize": {
      "enums": {
        "type": {
          "ASPECTRATIO": "aspectRatio"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SystemVariableSize": {
      "enums": {
        "type": {
          "SYSTEMVARIABLE": "SystemVariable"
        },
        "value": {
          "SITEWIDTH": "siteWidth",
          "TOPBANNERHEIGHT": "topBannerHeight"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "NumberSize": {
      "enums": {
        "type": {
          "NUMBER": "Number"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LayoutSize": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SpxStopper": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StretchWithSoftMargins": {
      "enums": {
        "type": {
          "STRETCHWITHSOFTMARGINS": "StretchWithSoftMargins"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Height": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MinMaxSize": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GridTrackSize": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BaseGridTrackSize": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "KeywordLength": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ItemsAlignment": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ContainerLayoutIntent": {
      "enums": {
        "layoutIntent": {
          "ROWS": "Rows",
          "COLS": "Cols",
          "MOSAIC": "Mosaic",
          "SLIDER": "Slider",
          "SLIDESHOW": "SlideShow",
          "BRICKS": "Bricks"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Alignment": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Direction": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Margins": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Padding": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FlexDirection": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FlexWrap": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Overflow": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Contain": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "AutoFlow": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "JustifyContent": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GridArea": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LayoutData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SingleLayoutData": {
      "enums": {
        "resolverType": {
          "SCALE": "scale",
          "FIXED": "fixed"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ScrollSnapType": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ScrollSnapDirection": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ScrollBehavior": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ScrollSnapAlignType": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ScrollSnapData": {
      "enums": {
        "scrollSnapType": {
          "MANDATORY": "mandatory",
          "PROXIMITY": "proximity",
          "NONE": "none"
        },
        "scrollSnapDirection": {
          "X": "x",
          "Y": "y"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ContentMaxWidth": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        },
        "align": {
          "CENTER": "center",
          "RIGHT": "right",
          "LEFT": "left"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GridContainerLayout": {
      "enums": {
        "autoFlow": {
          "ROW": "row",
          "COLUMN": "column",
          "DENSE": "dense",
          "ROW_DENSE": "row dense",
          "COLUMN_DENSE": "column dense"
        },
        "overflowY": {
          "AUTO": "auto",
          "SCROLL": "scroll",
          "HIDDEN": "hidden",
          "VISIBLE": "visible",
          "CLIP": "clip"
        },
        "overflowX": {
          "AUTO": "auto",
          "SCROLL": "scroll",
          "HIDDEN": "hidden",
          "VISIBLE": "visible",
          "CLIP": "clip"
        },
        "scrollSnapType": {
          "MANDATORY": "mandatory",
          "PROXIMITY": "proximity",
          "NONE": "none"
        },
        "scrollSnapDirection": {
          "X": "x",
          "Y": "y"
        },
        "scrollBehavior": {
          "AUTO": "auto",
          "SMOOTH": "smooth"
        },
        "type": {
          "GRIDCONTAINERLAYOUT": "GridContainerLayout"
        },
        "align": {
          "CENTER": "center",
          "RIGHT": "right",
          "LEFT": "left"
        },
        "contain": {
          "NONE": "none",
          "PAINT": "paint"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ComponentLayout": {
      "enums": {
        "containerType": {
          "INLINE_SIZE": "inline-size"
        },
        "type": {
          "COMPONENTLAYOUT": "ComponentLayout"
        },
        "direction": {
          "RTL": "rtl",
          "LTR": "ltr"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ClassicComponentLayout": {
      "enums": {
        "containerType": {
          "INLINE_SIZE": "inline-size"
        },
        "type": {
          "CLASSICCOMPONENTLAYOUT": "ClassicComponentLayout"
        },
        "direction": {
          "RTL": "rtl",
          "LTR": "ltr"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BaseComponentLayout": {
      "enums": {
        "containerType": {
          "INLINE_SIZE": "inline-size"
        },
        "type": {
          "STRETCHWITHSOFTMARGINS": "StretchWithSoftMargins"
        },
        "direction": {
          "RTL": "rtl",
          "LTR": "ltr"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GridItemLayout": {
      "enums": {
        "type": {
          "GRIDITEMLAYOUT": "GridItemLayout"
        },
        "scrollSnapAlign": {
          "CENTER": "center",
          "END": "end",
          "START": "start",
          "NONE": "none"
        },
        "position": {
          "STICKY": "sticky",
          "STICKYTOHEADER": "stickyToHeader",
          "ABSOLUTE": "absolute",
          "RELATIVE": "relative"
        },
        "alignSelf": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        },
        "justifySelf": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FixedItemLayout": {
      "enums": {
        "type": {
          "FIXEDITEMLAYOUT": "FixedItemLayout"
        },
        "scrollSnapAlign": {
          "CENTER": "center",
          "END": "end",
          "START": "start",
          "NONE": "none"
        },
        "position": {
          "STICKY": "sticky",
          "STICKYTOHEADER": "stickyToHeader",
          "ABSOLUTE": "absolute",
          "RELATIVE": "relative"
        },
        "alignSelf": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        },
        "justifySelf": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BackgroundLayerItemLayout": {
      "enums": {
        "type": {
          "BACKGROUNDLAYERITEMLAYOUT": "BackgroundLayerItemLayout"
        },
        "scrollSnapAlign": {
          "CENTER": "center",
          "END": "end",
          "START": "start",
          "NONE": "none"
        },
        "position": {
          "STICKY": "sticky",
          "STICKYTOHEADER": "stickyToHeader",
          "ABSOLUTE": "absolute",
          "RELATIVE": "relative"
        },
        "alignSelf": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        },
        "justifySelf": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FixedPositionItemLayout": {
      "enums": {
        "type": {
          "FIXEDPOSITIONITEMLAYOUT": "FixedPositionItemLayout"
        },
        "scrollSnapAlign": {
          "CENTER": "center",
          "END": "end",
          "START": "start",
          "NONE": "none"
        },
        "position": {
          "STICKY": "sticky",
          "STICKYTOHEADER": "stickyToHeader",
          "ABSOLUTE": "absolute",
          "RELATIVE": "relative"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MasterPageItemLayout": {
      "enums": {
        "type": {
          "MASTERPAGEITEMLAYOUT": "MasterPageItemLayout"
        },
        "scrollSnapAlign": {
          "CENTER": "center",
          "END": "end",
          "START": "start",
          "NONE": "none"
        },
        "position": {
          "STICKY": "sticky",
          "STICKYTOHEADER": "stickyToHeader",
          "ABSOLUTE": "absolute",
          "RELATIVE": "relative"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FlexContainerLayoutBase": {
      "enums": {
        "scrollSnapAlign": {
          "CENTER": "center",
          "END": "end",
          "START": "start",
          "NONE": "none"
        },
        "position": {
          "STICKY": "sticky",
          "STICKYTOHEADER": "stickyToHeader",
          "ABSOLUTE": "absolute",
          "RELATIVE": "relative"
        },
        "direction": {
          "ROW": "row",
          "ROWREVERSE": "rowReverse",
          "COLUMN": "column",
          "COLUMNREVERSE": "columnReverse"
        },
        "wrap": {
          "NOWRAP": "nowrap",
          "WRAP": "wrap"
        },
        "alignItems": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        },
        "justifyContent": {
          "START": "start",
          "CENTER": "center",
          "END": "end",
          "SPACEBETWEEN": "spaceBetween",
          "SPACEAROUND": "spaceAround",
          "SPACEEVENLY": "spaceEvenly"
        },
        "overflowY": {
          "AUTO": "auto",
          "SCROLL": "scroll",
          "HIDDEN": "hidden",
          "VISIBLE": "visible",
          "CLIP": "clip"
        },
        "overflowX": {
          "AUTO": "auto",
          "SCROLL": "scroll",
          "HIDDEN": "hidden",
          "VISIBLE": "visible",
          "CLIP": "clip"
        },
        "scrollSnapType": {
          "MANDATORY": "mandatory",
          "PROXIMITY": "proximity",
          "NONE": "none"
        },
        "scrollSnapDirection": {
          "X": "x",
          "Y": "y"
        },
        "scrollBehaviour": {
          "AUTO": "auto",
          "SMOOTH": "smooth"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        },
        "align": {
          "CENTER": "center",
          "RIGHT": "right",
          "LEFT": "left"
        },
        "contain": {
          "NONE": "none",
          "PAINT": "paint"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FlexContainerLayout": {
      "enums": {
        "type": {
          "FLEXCONTAINERLAYOUT": "FlexContainerLayout",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        },
        "scrollSnapAlign": {
          "CENTER": "center",
          "END": "end",
          "START": "start",
          "NONE": "none"
        },
        "position": {
          "STICKY": "sticky",
          "STICKYTOHEADER": "stickyToHeader",
          "ABSOLUTE": "absolute",
          "RELATIVE": "relative"
        },
        "direction": {
          "ROW": "row",
          "ROWREVERSE": "rowReverse",
          "COLUMN": "column",
          "COLUMNREVERSE": "columnReverse"
        },
        "wrap": {
          "NOWRAP": "nowrap",
          "WRAP": "wrap"
        },
        "alignItems": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        },
        "justifyContent": {
          "START": "start",
          "CENTER": "center",
          "END": "end",
          "SPACEBETWEEN": "spaceBetween",
          "SPACEAROUND": "spaceAround",
          "SPACEEVENLY": "spaceEvenly"
        },
        "overflowY": {
          "AUTO": "auto",
          "SCROLL": "scroll",
          "HIDDEN": "hidden",
          "VISIBLE": "visible",
          "CLIP": "clip"
        },
        "overflowX": {
          "AUTO": "auto",
          "SCROLL": "scroll",
          "HIDDEN": "hidden",
          "VISIBLE": "visible",
          "CLIP": "clip"
        },
        "scrollSnapType": {
          "MANDATORY": "mandatory",
          "PROXIMITY": "proximity",
          "NONE": "none"
        },
        "scrollSnapDirection": {
          "X": "x",
          "Y": "y"
        },
        "scrollBehaviour": {
          "AUTO": "auto",
          "SMOOTH": "smooth"
        },
        "align": {
          "CENTER": "center",
          "RIGHT": "right",
          "LEFT": "left"
        },
        "contain": {
          "NONE": "none",
          "PAINT": "paint"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FlexItemLayoutBase": {
      "enums": {
        "scrollSnapAlign": {
          "CENTER": "center",
          "END": "end",
          "START": "start",
          "NONE": "none"
        },
        "position": {
          "STICKY": "sticky",
          "STICKYTOHEADER": "stickyToHeader",
          "ABSOLUTE": "absolute",
          "RELATIVE": "relative"
        },
        "alignSelf": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        },
        "justifySelf": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "FlexItemLayout": {
      "enums": {
        "type": {
          "FLEXITEMLAYOUT": "FlexItemLayout"
        },
        "scrollSnapAlign": {
          "CENTER": "center",
          "END": "end",
          "START": "start",
          "NONE": "none"
        },
        "position": {
          "STICKY": "sticky",
          "STICKYTOHEADER": "stickyToHeader",
          "ABSOLUTE": "absolute",
          "RELATIVE": "relative"
        },
        "alignSelf": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        },
        "justifySelf": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "OrganizerContainerLayout": {
      "enums": {
        "layoutIntent": {
          "ROWS": "Rows",
          "COLS": "Cols",
          "MOSAIC": "Mosaic",
          "SLIDER": "Slider",
          "SLIDESHOW": "SlideShow",
          "BRICKS": "Bricks"
        },
        "type": {
          "ORGANIZERCONTAINERLAYOUT": "OrganizerContainerLayout",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        },
        "scrollSnapAlign": {
          "CENTER": "center",
          "END": "end",
          "START": "start",
          "NONE": "none"
        },
        "position": {
          "STICKY": "sticky",
          "STICKYTOHEADER": "stickyToHeader",
          "ABSOLUTE": "absolute",
          "RELATIVE": "relative"
        },
        "direction": {
          "ROW": "row",
          "ROWREVERSE": "rowReverse",
          "COLUMN": "column",
          "COLUMNREVERSE": "columnReverse"
        },
        "wrap": {
          "NOWRAP": "nowrap",
          "WRAP": "wrap"
        },
        "alignItems": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        },
        "justifyContent": {
          "START": "start",
          "CENTER": "center",
          "END": "end",
          "SPACEBETWEEN": "spaceBetween",
          "SPACEAROUND": "spaceAround",
          "SPACEEVENLY": "spaceEvenly"
        },
        "overflowY": {
          "AUTO": "auto",
          "SCROLL": "scroll",
          "HIDDEN": "hidden",
          "VISIBLE": "visible",
          "CLIP": "clip"
        },
        "overflowX": {
          "AUTO": "auto",
          "SCROLL": "scroll",
          "HIDDEN": "hidden",
          "VISIBLE": "visible",
          "CLIP": "clip"
        },
        "scrollSnapType": {
          "MANDATORY": "mandatory",
          "PROXIMITY": "proximity",
          "NONE": "none"
        },
        "scrollSnapDirection": {
          "X": "x",
          "Y": "y"
        },
        "scrollBehaviour": {
          "AUTO": "auto",
          "SMOOTH": "smooth"
        },
        "align": {
          "CENTER": "center",
          "RIGHT": "right",
          "LEFT": "left"
        },
        "contain": {
          "NONE": "none",
          "PAINT": "paint"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MultiColumnsContainerLayout": {
      "enums": {
        "alignContent": {
          "AUTO": "auto",
          "STRETCH": "stretch",
          "START": "start",
          "CENTER": "center",
          "END": "end"
        },
        "type": {
          "MULTICOLUMNSCONTAINERLAYOUT": "MultiColumnsContainerLayout"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MultiColumnsItemLayout": {
      "enums": {
        "type": {
          "MULTICOLUMNSITEMLAYOUT": "MultiColumnsItemLayout"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "OrganizerItemLayout": {
      "enums": {
        "type": {
          "ORGANIZERITEMLAYOUT": "OrganizerItemLayout"
        },
        "scrollSnapAlign": {
          "CENTER": "center",
          "END": "end",
          "START": "start",
          "NONE": "none"
        },
        "position": {
          "STICKY": "sticky",
          "STICKYTOHEADER": "stickyToHeader",
          "ABSOLUTE": "absolute",
          "RELATIVE": "relative"
        },
        "alignSelf": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        },
        "justifySelf": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StackContainerLayout": {
      "enums": {
        "type": {
          "STACKCONTAINERLAYOUT": "StackContainerLayout",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        },
        "scrollSnapAlign": {
          "CENTER": "center",
          "END": "end",
          "START": "start",
          "NONE": "none"
        },
        "position": {
          "STICKY": "sticky",
          "STICKYTOHEADER": "stickyToHeader",
          "ABSOLUTE": "absolute",
          "RELATIVE": "relative"
        },
        "direction": {
          "ROW": "row",
          "ROWREVERSE": "rowReverse",
          "COLUMN": "column",
          "COLUMNREVERSE": "columnReverse"
        },
        "wrap": {
          "NOWRAP": "nowrap",
          "WRAP": "wrap"
        },
        "alignItems": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        },
        "justifyContent": {
          "START": "start",
          "CENTER": "center",
          "END": "end",
          "SPACEBETWEEN": "spaceBetween",
          "SPACEAROUND": "spaceAround",
          "SPACEEVENLY": "spaceEvenly"
        },
        "overflowY": {
          "AUTO": "auto",
          "SCROLL": "scroll",
          "HIDDEN": "hidden",
          "VISIBLE": "visible",
          "CLIP": "clip"
        },
        "overflowX": {
          "AUTO": "auto",
          "SCROLL": "scroll",
          "HIDDEN": "hidden",
          "VISIBLE": "visible",
          "CLIP": "clip"
        },
        "scrollSnapType": {
          "MANDATORY": "mandatory",
          "PROXIMITY": "proximity",
          "NONE": "none"
        },
        "scrollSnapDirection": {
          "X": "x",
          "Y": "y"
        },
        "scrollBehaviour": {
          "AUTO": "auto",
          "SMOOTH": "smooth"
        },
        "align": {
          "CENTER": "center",
          "RIGHT": "right",
          "LEFT": "left"
        },
        "contain": {
          "NONE": "none",
          "PAINT": "paint"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "StackItemLayout": {
      "enums": {
        "type": {
          "STACKITEMLAYOUT": "StackItemLayout"
        },
        "scrollSnapAlign": {
          "CENTER": "center",
          "END": "end",
          "START": "start",
          "NONE": "none"
        },
        "position": {
          "STICKY": "sticky",
          "STICKYTOHEADER": "stickyToHeader",
          "ABSOLUTE": "absolute",
          "RELATIVE": "relative"
        },
        "alignSelf": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        },
        "justifySelf": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LayoutDataItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BaseItemLayout": {
      "enums": {
        "scrollSnapAlign": {
          "CENTER": "center",
          "END": "end",
          "START": "start",
          "NONE": "none"
        },
        "position": {
          "STICKY": "sticky",
          "STICKYTOHEADER": "stickyToHeader",
          "ABSOLUTE": "absolute",
          "RELATIVE": "relative"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "PositionType": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "WedgeItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MeshGridArea": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ItemMeshData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MeshItemLayout": {
      "enums": {
        "justifySelf": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        },
        "type": {
          "MESHITEMLAYOUT": "MeshItemLayout"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ContainerMeshData": {
      "enums": {
        "contentHeight": {
          "AUTO": "auto"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ContentArea": {
      "enums": {
        "alignment": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MeshContainerLayout": {
      "enums": {
        "type": {
          "MESHCONTAINERLAYOUT": "MeshContainerLayout"
        },
        "contentHeight": {
          "AUTO": "auto"
        },
        "alignment": {
          "START": "start",
          "END": "end",
          "CENTER": "center",
          "STRETCH": "stretch",
          "CONTENT": "content"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RefArray": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VariantRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [
        "variants",
        "remoteVariants",
        "from"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [
        "breakpoint"
      ],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MinimalUnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SPXReferenceDefinition": {
      "enums": {
        "resolverType": {
          "SCALE": "scale",
          "FIXED": "fixed"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLength": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLengthPercentage": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitAngle": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizeArea": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizePoint": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointsData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRange": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "NumberThatCanConnectToAVariable": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkReference": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_Image": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_SVGItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ColorLayers": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinearLayer": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleLayer": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseLayer": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientMeshLayer": {
      "enums": {
        "type": {
          "GRADIENTMESH": "GradientMesh",
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConicLayer": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColorLayer": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinear": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircle": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipse": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConic": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColor": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BlendMode": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientColorStop": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientAngularColorStop": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    }
  },
  "variants": {
    "$id": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Hover": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Mobile": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "State": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Selected": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Trigger": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Preset": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RepeaterPattern": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RepeaterPatternList": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VariantsList": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointsData": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRange": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "RefArray": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BreakpointRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "VariantRelation": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "MinimalUnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSize": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "FR": "fr",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "SPX": "spx",
          "SITEWIDTHPERCENTAGE": "siteWidthPercentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SPXReferenceDefinition": {
      "enums": {
        "resolverType": {
          "SCALE": "scale",
          "FIXED": "fixed"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLength": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitLengthPercentage": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitAngle": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizeArea": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "UnitSizePoint": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "NumberThatCanConnectToAVariable": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "LinkReference": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_Image": {
      "enums": {
        "flip": {
          "X": "x",
          "Y": "y",
          "XY": "xy",
          "NONE": "none"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "Common_SVGItem": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "ColorLayers": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinearLayer": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleLayer": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseLayer": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientMeshLayer": {
      "enums": {
        "type": {
          "GRADIENTMESH": "GradientMesh",
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConicLayer": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColorLayer": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientLinear": {
      "enums": {
        "type": {
          "GRADIENTLINEAR": "GradientLinear",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircleSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientCircle": {
      "enums": {
        "type": {
          "GRADIENTCIRCLE": "GradientCircle",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "PERCENTAGE": "percentage"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipseSize": {
      "enums": {
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        },
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientEllipse": {
      "enums": {
        "type": {
          "GRADIENTELLIPSE": "GradientEllipse",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        },
        "keyword": {
          "CLOSEST_SIDE": "closest-side",
          "CLOSEST_CORNER": "closest-corner",
          "FARTHEST_SIDE": "farthest-side",
          "FARTHEST_CORNER": "farthest-corner"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientConic": {
      "enums": {
        "type": {
          "GRADIENTCONIC": "GradientConic",
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax",
          "DEG": "deg"
        },
        "blendMode": {
          "NORMAL": "normal",
          "MULTIPLY": "multiply",
          "SCREEN": "screen",
          "DARKEN": "darken",
          "LIGHTEN": "lighten",
          "OVERLAY": "overlay",
          "COLORDODGE": "colorDodge",
          "COLORBURN": "colorBurn",
          "HARDLIGHT": "hardLight",
          "SOFTLIGHT": "softLight",
          "DIFFERENCE": "difference",
          "EXCLUSION": "exclusion",
          "HUE": "hue",
          "SATURATION": "saturation",
          "COLOR": "color",
          "LUMINOSITY": "luminosity"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "SolidColor": {
      "enums": {
        "type": {
          "SOLIDCOLOR": "SolidColor"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "BlendMode": {
      "enums": {},
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientColorStop": {
      "enums": {
        "type": {
          "PX": "px",
          "EM": "em",
          "REM": "rem",
          "PERCENTAGE": "percentage",
          "VH": "vh",
          "VW": "vw",
          "VMIN": "vmin",
          "VMAX": "vmax"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    },
    "GradientAngularColorStop": {
      "enums": {
        "type": {
          "DEG": "deg",
          "PERCENTAGE": "percentage"
        }
      },
      "links": [],
      "refsNotOwnedBySchema": [],
      "linksArr": [],
      "enumsArr": {},
      "enumStringOneOfs": {},
      "enumsOneOf": {},
      "floatToInt": [],
      "convertToString": []
    }
  }
}
